var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153, _symbol154, _symbol155, _symbol156, _symbol157, _symbol158, _symbol159, _symbol160, _symbol161, _symbol162, _symbol163, _symbol164, _symbol165, _symbol166, _symbol167, _symbol168, _symbol169, _symbol170, _symbol171, _symbol172, _symbol173, _symbol174, _symbol175, _symbol176, _symbol177, _symbol178, _symbol179, _symbol180, _symbol181, _symbol182, _symbol183, _symbol184, _symbol185, _symbol186, _symbol187, _symbol188, _symbol189, _symbol190, _symbol191, _symbol192, _symbol193, _symbol194, _symbol195, _symbol196, _symbol197, _symbol198, _symbol199, _symbol200, _symbol201, _symbol202, _symbol203, _symbol204, _symbol205, _symbol206, _symbol207, _symbol208, _symbol209, _symbol210, _symbol211, _symbol212, _symbol213, _symbol214, _symbol215, _symbol216, _symbol217, _symbol218, _symbol219, _symbol220, _symbol221, _symbol222, _symbol223, _symbol224, _symbol225, _symbol226, _symbol227, _symbol228, _symbol229, _symbol230, _symbol231, _symbol232, _symbol233, _symbol234, _symbol235, _symbol236, _symbol237, _symbol238, _symbol239, _symbol240, _symbol241, _symbol242, _symbol243, _symbol244, _symbol245, _symbol246, _symbol247, _symbol248, _symbol249, _symbol250, _symbol251, _symbol252, _symbol253, _symbol254, _symbol255, _symbol256, _symbol257, _symbol258, _symbol259, _symbol260, _symbol261, _symbol262, _symbol263, _symbol264, _symbol265, _symbol266, _symbol267, _symbol268, _symbol269, _symbol270, _symbol271, _symbol272, _symbol273, _symbol274, _symbol275, _symbol276, _symbol277;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "X icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 20.001,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 20.001,
    height: 2,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "accessibility",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "accessibility icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,10.308a3.154,3.154,0,1,1,3.2-3.154A3.181,3.181,0,0,1,12.5,10.308ZM12.5,6a1.155,1.155,0,1,0,1.2,1.154A1.179,1.179,0,0,0,12.5,6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 13,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.707,20.383,12.5,15.45,9.293,20.383l-1.677-1.09,4.045-6.223a1.039,1.039,0,0,1,1.677,0l4.045,6.223Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.014,12.014,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "archive-file-box",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "archive-file-box icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21.215,12.177,20.02,6.2a.337.337,0,0,0-.11-.214L4,6c.055,0,0,.087-.01.141L2.785,12.177.823,11.785,2.02,5.8A2.106,2.106,0,0,1,4,4H20a2.124,2.124,0,0,1,1.99,1.859l1.187,5.926Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23H3a2,2,0,0,1-2-2V14a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1v2h6V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v7A2,2,0,0,1,21,23ZM3,15v6H21V15H17v2a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V15Z",
    fill: "currentColor"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-down icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,23a2,2,0,0,1-1.294-.477L4.639,17.378l1.294-1.525L12,21l6.067-5.147,1.294,1.525-6.067,5.147A2,2,0,0,1,12,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2.312,
    width: 2,
    height: 16,
    fill: "currentColor"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-horizontal-caps",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-horizontal-caps icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,17.414,17.586,16l4-4-4-4L19,6.586l4,4a2,2,0,0,1,0,2.828Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,17.414l-4-4a2,2,0,0,1,0-2.828l4-4L6.414,8l-4,4,4,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 14,
    height: 2,
    fill: "currentColor"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left icon"), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,4.9L4,12l6.1,7.1l-1.5,1.3l-6.1-7.1c-0.6-0.7-0.6-1.9,0-2.6l6.1-7.1L10.1,4.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.7,
    y: 11,
    width: 16,
    height: 2
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-multi-direction",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-multi-direction icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15,5.414l-3-3-3,3L7.586,4l3-3a2,2,0,0,1,2.828,0l3,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16.414,18.586,15l3-3-3-3L20,7.586l3,3a2,2,0,0,1,0,2.828Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,16.414l-3-3a2,2,0,0,1,0-2.828l3-3L5.414,9l-3,3,3,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.585A1.992,1.992,0,0,1,10.586,23l-3-3L9,18.586l3,3,3-3L16.414,20l-3,3A1.992,1.992,0,0,1,12,23.585Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 2,
    height: 8,
    fill: "currentColor"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16.108,20.41l-1.519-1.3L20.683,12,14.59,4.892l1.519-1.3L22.2,10.7a1.99,1.99,0,0,1,0,2.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 16,
    height: 2,
    fill: "currentColor"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-subdirectory-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-subdirectory-left icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18,19H7V17H18V2h2V17A2,2,0,0,1,18,19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,23.414l-4-4a2,2,0,0,1,0-2.828l4-4L8.414,14l-4,4,4,4Z",
    fill: "currentColor"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-subdirectory-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-subdirectory-right icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17,23.414,15.586,22l4-4-4-4L17,12.586l4,4a2,2,0,0,1,0,2.828Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,19H6a2,2,0,0,1-2-2V2H6V17H17Z",
    fill: "currentColor"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-up icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.067,9.458,12,4.312,5.933,9.458,4.639,7.933l6.067-5.147a1.994,1.994,0,0,1,2.588,0l6.067,5.147Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 2,
    height: 16,
    fill: "currentColor"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-vertical-caps",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-vertical-caps icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16,6.414l-4-4-4,4L6.586,5l4-4a2,2,0,0,1,2.828,0l4,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.585A1.993,1.993,0,0,1,10.586,23l-4-4L8,17.586l4,4,4-4L17.414,19l-4,4A1.993,1.993,0,0,1,12,23.585Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 2,
    height: 14,
    fill: "currentColor"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "attachment",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "attachment icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16,24H8a3,3,0,0,1-3-3V4A3,3,0,0,1,8,1h4a3,3,0,0,1,3,3V19a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V6h2V18h2V4a1,1,0,0,0-1-1H8A1,1,0,0,0,7,4V21a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V3h2V21A3,3,0,0,1,16,24Z",
    fill: "currentColor"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "ban",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "ban icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1.133,
    width: 2,
    height: 21.735,
    transform: "translate(-4.971 12.001) rotate(-45.002)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22.995A10.995,10.995,0,0,1,4.222,4.222h0A11,11,0,1,1,12,22.995ZM5.636,5.636a9,9,0,1,0,12.729,0,9.011,9.011,0,0,0-12.729,0Z",
    fill: "currentColor"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "battery-charging",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "battery-charging icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,21H15V19h4V8H14V6h5a2,2,0,0,1,2,2V19A2,2,0,0,1,19,21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,21H2a2,2,0,0,1-2-2V8A2,2,0,0,1,2,6H6V8H2V19H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,18H21V16h1V11H21V9h2a1,1,0,0,1,1,1v7A1,1,0,0,1,23,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.333 12.333 11 19 11 13.667 7.667 13.667 11 7 11 12.333 14.333 12.333",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,23.236V14.667H6.048L12,2.764v8.569h3.952Zm2-9.9v1.431l.715-1.431Zm-2.715-.667H10V11.236Z",
    fill: "currentColor"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "battery-empty",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "battery-empty icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,20H2a2,2,0,0,1-2-2V7A2,2,0,0,1,2,5H19a2,2,0,0,1,2,2V18A2,2,0,0,1,19,20ZM2,7V18H19V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,17H21V15h1V10H21V8h2a1,1,0,0,1,1,1v7A1,1,0,0,1,23,17Z",
    fill: "currentColor"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "battery-full",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "battery-full icon"), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.5,
    width: 14,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,17H3.5a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,3.5,8h14a.5.5,0,0,1,.5.5v8A.5.5,0,0,1,17.5,17ZM4,16H17V9H4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,20H2a2,2,0,0,1-2-2V7A2,2,0,0,1,2,5H19a2,2,0,0,1,2,2V18A2,2,0,0,1,19,20ZM2,7V18H19V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,17H21V15h1V10H21V8h2a1,1,0,0,1,1,1v7A1,1,0,0,1,23,17Z",
    fill: "currentColor"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "battery-half-full",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "battery-half-full icon"), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.5,
    width: 8,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,17h-8a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,3.5,8h8a.5.5,0,0,1,.5.5v8A.5.5,0,0,1,11.5,17ZM4,16h7V9H4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,20H2a2,2,0,0,1-2-2V7A2,2,0,0,1,2,5H19a2,2,0,0,1,2,2V18A2,2,0,0,1,19,20ZM2,7V18H19V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,17H21V15h1V10H21V8h2a1,1,0,0,1,1,1v7A1,1,0,0,1,23,17Z",
    fill: "currentColor"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell-full",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "bell-full icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9.11,21a3.168,3.168,0,0,0,5.78,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.87a4.179,4.179,0,0,1-3.8-2.459L7.563,20h8.873L15.8,21.411A4.179,4.179,0,0,1,12,23.87Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.933,18H5.067A1.05,1.05,0,0,1,4,16.968v-2.4a3.051,3.051,0,0,1,1.007-2.256L6.193,11.23A3.051,3.051,0,0,0,7.2,8.974V6.645A4.724,4.724,0,0,1,12,2h0a4.724,4.724,0,0,1,4.8,4.645V8.937a3.049,3.049,0,0,0,.986,2.236l1.228,1.138A3.049,3.049,0,0,1,20,14.547v2.42A1.05,1.05,0,0,1,18.933,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.934,19H5.066A2.052,2.052,0,0,1,3,16.968v-2.4a4.062,4.062,0,0,1,1.335-3L5.519,10.49A2.057,2.057,0,0,0,6.2,8.974V6.645A5.73,5.73,0,0,1,12,1a5.73,5.73,0,0,1,5.8,5.645V8.937a2.062,2.062,0,0,0,.666,1.5l1.228,1.139A4.066,4.066,0,0,1,21,14.547v2.42A2.052,2.052,0,0,1,18.934,19ZM12,3A3.729,3.729,0,0,0,8.2,6.645V8.974a4.059,4.059,0,0,1-1.335,3L5.682,13.048A2.058,2.058,0,0,0,5,14.564v2.4L18.934,17A.072.072,0,0,0,19,16.969V14.547a2.062,2.062,0,0,0-.666-1.5l-1.228-1.139A4.066,4.066,0,0,1,15.8,8.937V6.645A3.729,3.729,0,0,0,12,3Z",
    fill: "currentColor"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "bell-line icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,24A4.5,4.5,0,0,1,8,19.5v-1h2v1a2.5,2.5,0,0,0,5,0v-1h2v1A4.5,4.5,0,0,1,12.5,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.866,19H5.134A2.118,2.118,0,0,1,3,16.9V14.35a4.258,4.258,0,0,1,1.4-3.136l1.261-1.146A2.254,2.254,0,0,0,6.4,8.41V5.936A6.026,6.026,0,0,1,12.5,0a6.026,6.026,0,0,1,6.1,5.936V8.371a2.256,2.256,0,0,0,.728,1.643l1.3,1.209A4.258,4.258,0,0,1,22,14.332V16.9A2.118,2.118,0,0,1,19.866,19ZM12.5,2A4.025,4.025,0,0,0,8.4,5.936V8.41A4.258,4.258,0,0,1,7,11.546L5.743,12.692A2.255,2.255,0,0,0,5,14.35V16.9a.122.122,0,0,0,.134.1H19.866A.122.122,0,0,0,20,16.9V14.332a2.257,2.257,0,0,0-.728-1.643l-1.3-1.209A4.258,4.258,0,0,1,16.6,8.371V5.936A4.025,4.025,0,0,0,12.5,2Z",
    fill: "currentColor"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "book",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "book icon"), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 18,
    height: 19,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,21H3a1,1,0,0,1-1-1V1A1,1,0,0,1,3,0H21a1,1,0,0,1,1,1V20A1,1,0,0,1,21,21ZM4,19H20V2H4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 2,
    height: 11,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,17H21a0,0,0,0,1,0,0v5.75a.25.25,0,0,1-.25.25H5a2,2,0,0,1-2-2V19a2,2,0,0,1,2-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75,24H5a3,3,0,0,1-3-3V19a3,3,0,0,1,3-3H22v6.75A1.251,1.251,0,0,1,20.75,24ZM5,18a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H20V18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    width: 11,
    height: 2,
    fill: "currentColor"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "bookmark-full",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "bookmark-full icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19.765,1A1.235,1.235,0,0,1,21,2.235V22l-8.647-4.938L4,22V2c0-.682.259-1,.941-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23a1,1,0,0,1-.5-.132l-8.143-4.649L4.509,22.861A1,1,0,0,1,3,22V2A1.811,1.811,0,0,1,4.941,0H19.765A2.238,2.238,0,0,1,22,2.235V22a1,1,0,0,1-1,1Zm-8.647-6.938a1,1,0,0,1,.5.132L20,20.277V2.235A.235.235,0,0,0,19.765,2H5V20.247L11.844,16.2A1,1,0,0,1,12.353,16.062Z",
    fill: "currentColor"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "bookmark-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "bookmark-line icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21,23a1,1,0,0,1-.5-.132l-8.143-4.649L4.509,22.861A1,1,0,0,1,3,22V2A1.811,1.811,0,0,1,4.941,0H19.765A2.238,2.238,0,0,1,22,2.235V22a1,1,0,0,1-1,1Zm-8.647-6.938a1,1,0,0,1,.5.132L20,20.277V2.235A.235.235,0,0,0,19.765,2H5V20.247L11.844,16.2A1,1,0,0,1,12.353,16.062Z",
    fill: "currentColor"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "building",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "building icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,24H5a1,1,0,0,1-1-1V1A1,1,0,0,1,5,0H19a1,1,0,0,1,1,1V23A1,1,0,0,1,19,24ZM6,22H18V2H6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,24H1a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H3v2H2v7H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,24H21V22h1V15H21V13h2a1,1,0,0,1,1,1v9A1,1,0,0,1,23,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 22 13 22 13 18 11 18 11 22 9 22 9 16 15 16 15 22",
    fill: "currentColor"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "buildings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "buildings icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,24H13a1,1,0,0,1-1-1V6a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1V23A1,1,0,0,1,22,24Zm-8-2h7V7H14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.003,
    y: 9,
    width: 5,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.003,
    y: 12,
    width: 5,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.003,
    y: 15,
    width: 5,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.003,
    y: 18,
    width: 5,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,24H2a1,1,0,0,1-1-1V9A1,1,0,0,1,2,8h8a1,1,0,0,1,1,1V23A1,1,0,0,1,10,24ZM3,22H9V10H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.003,
    y: 15,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.003,
    y: 12,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.003,
    y: 18,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,7H5V1A1,1,0,0,1,6,0H19a1,1,0,0,1,1,1V3.25H18V2H7Z",
    fill: "currentColor"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "calculator",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "calculator icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,24H3.5A1.5,1.5,0,0,1,2,22.5V1.5A1.5,1.5,0,0,1,3.5,0h17A1.5,1.5,0,0,1,22,1.5v21A1.5,1.5,0,0,1,20.5,24ZM4,22H20V2H4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,9H6.1A1.1,1.1,0,0,1,5,7.9V4.1A1.1,1.1,0,0,1,6.1,3H17.9A1.1,1.1,0,0,1,19,4.1V7.9A1.1,1.1,0,0,1,17.9,9ZM7,7H17V5H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,21H14.1A1.1,1.1,0,0,1,13,19.9V11.1A1.1,1.1,0,0,1,14.1,10h3.8A1.1,1.1,0,0,1,19,11.1v8.8A1.1,1.1,0,0,1,17.9,21ZM15,19h2V12H15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9,15H6.1A1.1,1.1,0,0,1,5,13.9V11.1A1.1,1.1,0,0,1,6.1,10h4.8A1.1,1.1,0,0,1,12,11.1v2.8A1.1,1.1,0,0,1,10.9,15ZM7,13h3V12H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9,21H6.1A1.1,1.1,0,0,1,5,19.9V17.1A1.1,1.1,0,0,1,6.1,16h4.8A1.1,1.1,0,0,1,12,17.1v2.8A1.1,1.1,0,0,1,10.9,21ZM7,19h3V18H7Z",
    fill: "currentColor"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "calendar icon"), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 6,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23H3a2,2,0,0,1-2-2V6A2,2,0,0,1,3,4H5V6H3V21H21V6H19V4h2a2,2,0,0,1,2,2V21A2,2,0,0,1,21,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 4,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 4,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 4,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 4,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 4,
    height: 4,
    rx: 1,
    ry: 1,
    fill: "currentColor"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "camera",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "camera icon"), /*#__PURE__*/React.createElement("path", {
    d: "M14,18a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,14,18Zm0-7a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,14,11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 11,
    r: 1,
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,10a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,21H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1V20A1,1,0,0,1,23,21ZM2,19H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 6,
    height: 2,
    fill: "currentColor"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "car",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "car icon"), /*#__PURE__*/React.createElement("path", {
    d: "M7,24H4a2,2,0,0,1-2-2V20H4v2H7V20H9v2A2,2,0,0,1,7,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,24H17a2,2,0,0,1-2-2V20h2v2h3V20h2v2A2,2,0,0,1,20,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 15,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 6,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,12H7a1,1,0,0,1-.98-1.2l1-5A1,1,0,0,1,8,5h8a1,1,0,0,1,.98.8l1,5A1,1,0,0,1,17,12ZM8.22,10H15.78l-.6-3H8.82Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,20H1a1,1,0,0,1-1-1V12.12A2.017,2.017,0,0,1,2,10h.125a.119.119,0,0,0,.116-.09l1.576-6.3A2.258,2.258,0,0,1,6,2H18a2.258,2.258,0,0,1,2.182,1.606l1.576,6.3A.493.493,0,0,0,22,10a.989.989,0,0,1,.26.034A2.124,2.124,0,0,1,24,12.12V19A1,1,0,0,1,23,20ZM2,18H22V12.12c0-.147-.22-.114-.359-.149a2.231,2.231,0,0,1-1.823-1.577l-1.576-6.3A.493.493,0,0,0,18,4H6a.379.379,0,0,0-.252.119L4.182,10.395A2.117,2.117,0,0,1,2.125,12H2.009c0,.01-.009.054-.009.12Z",
    fill: "currentColor"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "caret-down icon"), /*#__PURE__*/React.createElement("path", {
    d: "M5.365,7H18.635a1,1,0,0,1,.825,1.565l-6.635,9.7a1,1,0,0,1-1.651,0L4.54,8.565A1,1,0,0,1,5.365,7Z",
    fill: "currentColor"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "caret-left icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17,5.013V18.283a1,1,0,0,1-1.565.825l-9.7-6.635a1,1,0,0,1,0-1.651l9.7-6.635A1,1,0,0,1,17,5.013Z",
    fill: "currentColor"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "caret-right icon"), /*#__PURE__*/React.createElement("path", {
    d: "M7,18.283V5.013a1,1,0,0,1,1.565-.825l9.7,6.635a1,1,0,0,1,0,1.651l-9.7,6.635A1,1,0,0,1,7,18.283Z",
    fill: "currentColor"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "caret-up icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.635,16H5.365a1,1,0,0,1-.825-1.565l6.635-9.7a1,1,0,0,1,1.651,0l6.635,9.7A1,1,0,0,1,18.635,16Z",
    fill: "currentColor"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "chart-bar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chart-bar icon"), /*#__PURE__*/React.createElement("path", {
    d: "M6,23H2a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H6a1,1,0,0,1,1,1v7A1,1,0,0,1,6,23ZM3,21H5V16H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,23H10a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V22A1,1,0,0,1,14,23Zm-3-2h2V10H11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,23H18a1,1,0,0,1-1-1V2a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V22A1,1,0,0,1,22,23Zm-3-2h2V3H19Z",
    fill: "currentColor"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "chart-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chart-line icon"), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 18,
    r: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,20.5A2.5,2.5,0,1,1,6,18,2.5,2.5,0,0,1,3.5,20.5Zm0-4A1.5,1.5,0,1,0,5,18,1.5,1.5,0,0,0,3.5,16.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 11,
    r: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,13.5A2.5,2.5,0,1,1,12,11,2.5,2.5,0,0,1,9.5,13.5Zm0-4A1.5,1.5,0,1,0,11,11,1.5,1.5,0,0,0,9.5,9.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13,
    r: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,15.5A2.5,2.5,0,1,1,19,13,2.5,2.5,0,0,1,16.5,15.5Zm0-4A1.5,1.5,0,1,0,18,13,1.5,1.5,0,0,0,16.5,11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 4,
    r: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,6.5A2.5,2.5,0,1,1,24,4,2.5,2.5,0,0,1,21.5,6.5Zm0-4A1.5,1.5,0,1,0,23,4,1.5,1.5,0,0,0,21.5,2.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.379,
    y: 13.5,
    width: 6.242,
    height: 2,
    transform: "translate(-8.349 8.843) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.615,
    y: 8.885,
    width: 2,
    height: 6.306,
    transform: "translate(-3.352 19.047) rotate(-67.358)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.523,
    y: 7.479,
    width: 8.975,
    height: 2,
    transform: "translate(2.925 21.691) rotate(-63.435)",
    fill: "currentColor"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "chart-pie",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chart-pie icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11,23A10.134,10.134,0,0,1,1,13,10.134,10.134,0,0,1,11,3h1V5H11a8.209,8.209,0,0,0-8,8,8.209,8.209,0,0,0,8,8,8.209,8.209,0,0,0,8-8V12h2v1A10.134,10.134,0,0,1,11,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,10H15a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1,8.8,8.8,0,0,1,9,9A1,1,0,0,1,23,10ZM16,8h5.936A6.782,6.782,0,0,0,16,2.064Z",
    fill: "currentColor"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "check-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "9.249 19.82 3.643 14.214 5.764 12.093 9.249 15.578 18.734 6.093 20.855 8.214 9.249 19.82",
    fill: "currentColor"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-in-doc-1",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "check-in-doc-1 icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,24H1a1,1,0,0,1-1-1V19H2v3H22V19h2v4A1,1,0,0,1,23,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.956,17.449a2.314,2.314,0,0,1-1.663-.742L6.586,13,8,11.586l3.707,3.707c.113.112.282.281.6-.013L16,11.586,17.414,13l-3.707,3.707A2.562,2.562,0,0,1,11.956,17.449Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,21H5a2,2,0,0,1-2-2V2A2,2,0,0,1,5,0h9.171a2.98,2.98,0,0,1,2.122.879l3.414,3.414A4.515,4.515,0,0,1,21,6.829V19A2,2,0,0,1,19,21ZM5,2V19H19V6.829a3.387,3.387,0,0,0-.707-1.122L14.879,2.293A.994.994,0,0,0,14.171,2Z",
    fill: "currentColor"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-in-doc-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "check-in-doc-2 icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,22H2.1A2.1,2.1,0,0,1,0,19.9V3.4C0,1.808.673,1,2,1H8V3H2.013C2,3.121,2,3.293,2,3.4V19.9a.1.1,0,0,0,.1.1H21.9a.1.1,0,0,0,.1-.1V3.4c0-.106,0-.279-.013-.4H16V1h6c1.327,0,2,.808,2,2.4V19.9A2.1,2.1,0,0,1,21.9,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.956,17.449a2.314,2.314,0,0,1-1.663-.742L6.586,13,8,11.586l3.707,3.707c.113.112.281.281.6-.013L16,11.586,17.414,13l-3.707,3.707A2.562,2.562,0,0,1,11.956,17.449Z",
    fill: "currentColor"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-out-doc-1",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "check-out-doc-1 icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23,24H1a1,1,0,0,1-1-1V19H2v3H22V19h2v4A1,1,0,0,1,23,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,21H5a2,2,0,0,1-2-2V2A2,2,0,0,1,5,0h9.171a2.98,2.98,0,0,1,2.122.879l3.414,3.414A4.515,4.515,0,0,1,21,6.829V19A2,2,0,0,1,19,21ZM5,2V19H19V6.829a3.387,3.387,0,0,0-.707-1.122L14.879,2.293A.994.994,0,0,0,14.171,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8.444,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10.858,12.293,7.151c-.112-.111-.281-.28-.6.013L8,10.858,6.586,9.444l3.707-3.707a2.346,2.346,0,0,1,3.414,0l3.707,3.707Z",
    fill: "currentColor"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-out-doc-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "check-out-doc-2 icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,22H16V20h5.987c.013-.121.013-.293.013-.4V3.1a.1.1,0,0,0-.1-.1H2.1a.1.1,0,0,0-.1.1V19.6c0,.106,0,.279.013.4H8v2H2c-1.327,0-2-.808-2-2.4V3.1A2.1,2.1,0,0,1,2.1,1H21.9A2.1,2.1,0,0,1,24,3.1V19.6C24,21.192,23.327,22,22,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,11.414,12.293,7.707c-.112-.111-.28-.28-.6.013L8,11.414,6.586,10l3.707-3.707a2.346,2.346,0,0,1,3.414,0L17.414,10Z",
    fill: "currentColor"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "check icon"), /*#__PURE__*/React.createElement("path", {
    d: "M8,18.828a1.993,1.993,0,0,1-1.414-.585L1.1,12.757l1.414-1.414L8,16.829,21.485,3.343,22.9,4.757,9.414,18.243A1.993,1.993,0,0,1,8,18.828Z",
    fill: "currentColor"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-down-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-down-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "12 19.121 2.879 10 5 7.879 12 14.879 19 7.879 21.121 10 12 19.121",
    fill: "currentColor"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-down icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.4,17.137a1.988,1.988,0,0,1-1.411-.584l-8.5-8.709,1.432-1.4,8.491,8.7,8.474-8.7,1.432,1.4-8.49,8.7A2.012,2.012,0,0,1,12.4,17.137Z",
    fill: "currentColor"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-hard-stop",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-hard-stop icon"), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 2,
    height: 19,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48,20.914,4.086,19.48l7.7-7.49L4.086,4.52,5.48,3.086l7.7,7.49a2,2,0,0,1,.01,2.838Z",
    fill: "currentColor"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-left-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "14 21.121 4.879 12 14 2.879 16.121 5 9.121 12 16.121 19 14 21.121",
    fill: "currentColor"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-left icon"), /*#__PURE__*/React.createElement("path", {
    d: "M14.518,21.914l-8.7-8.491a2,2,0,0,1-.009-2.837l8.71-8.5,1.4,1.431-8.7,8.492,8.7,8.474Z",
    fill: "currentColor"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-right-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "10 21.121 7.879 19 14.879 12 7.879 5 10 2.879 19.121 12 10 21.121",
    fill: "currentColor"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-right icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9.483,21.914l-1.4-1.431,8.7-8.492-8.7-8.474,1.4-1.431,8.7,8.491a2,2,0,0,1,.009,2.837Z",
    fill: "currentColor"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-up-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-up-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "19 16.121 12 9.121 5 16.121 2.879 14 12 4.879 21.121 14 19 16.121",
    fill: "currentColor"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-up icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20.886,17.553l-8.49-8.7-8.475,8.7-1.432-1.4,8.491-8.7a2,2,0,0,1,2.838-.009l8.5,8.709Z",
    fill: "currentColor"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-check icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.459,16.074a1.986,1.986,0,0,1-1.414-.586L6.56,12l1.414-1.414,3.485,3.485L21.944,3.589,23.358,5,12.873,15.488A1.986,1.986,0,0,1,11.459,16.074Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.994A12,12,0,1,1,16.515.879l.927.376L16.69,3.108l-.927-.376A10,10,0,1,0,22,12V11h2v1A11.99,11.99,0,0,1,12,23.994Z",
    fill: "currentColor"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-exclamation-mark-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-exclamation-mark-filled icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19.78,4.22a11,11,0,1,0,0,15.56A11.015,11.015,0,0,0,19.78,4.22ZM13,18H11V16h2Zm0-4H11V6h2Z",
    fill: "currentColor"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-exclamation-mark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-exclamation-mark icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.25A1.25,1.25,0,1,1,13.25,17,1.251,1.251,0,0,1,12,18.25Zm0-2a.75.75,0,1,0,.75.75A.751.751,0,0,0,12,16.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.994A11.994,11.994,0,0,1,3.515,3.515h0A12,12,0,1,1,12,23.994ZM4.929,4.929a10,10,0,1,0,14.143,0,10.013,10.013,0,0,0-14.143,0Z",
    fill: "currentColor"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-filled icon"), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22ZM12,5a7,7,0,1,0,7,7A7.008,7.008,0,0,0,12,5Z",
    fill: "currentColor"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-line icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,22A10,10,0,1,1,22,12,10.012,10.012,0,0,1,12,22ZM12,5a7,7,0,1,0,7,7A7.008,7.008,0,0,0,12,5Z",
    fill: "currentColor"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-minus icon"), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.994A11.994,11.994,0,0,1,3.515,3.515h0A12,12,0,1,1,12,23.994ZM4.929,4.929a10,10,0,1,0,14.143,0,10.013,10.013,0,0,0-14.143,0Z",
    fill: "currentColor"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-plus icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.994A11.994,11.994,0,0,1,3.515,3.515h0A12,12,0,1,1,12,23.994ZM4.929,4.929a10,10,0,1,0,14.143,0,10.013,10.013,0,0,0-14.143,0Z",
    fill: "currentColor"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-question-mark-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-question-mark-filled icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19.778,4.222a11,11,0,1,0,0,15.556A11,11,0,0,0,19.778,4.222ZM12,19a1,1,0,1,1,1-1A1,1,0,0,1,12,19Zm1-6.142V14a1,1,0,0,1-2,0V12a1,1,0,0,1,1-1,2,2,0,1,0-2-2A1,1,0,0,1,8,9a4,4,0,1,1,5,3.858Z",
    fill: "currentColor"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-question-mark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-question-mark icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.994A11.994,11.994,0,0,1,3.515,3.515h0A12,12,0,1,1,12,23.994ZM4.929,4.929a10,10,0,1,0,14.143,0,10.013,10.013,0,0,0-14.143,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,17a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13a1,1,0,0,1,0-2,2,2,0,1,0-2-2A1,1,0,0,1,8,9a4,4,0,1,1,4,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v2A1,1,0,0,1,12,15Z",
    fill: "currentColor"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle-x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "circle-x icon"), /*#__PURE__*/React.createElement("rect", {
    x: 5.343,
    y: 11,
    width: 13.313,
    height: 2,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5.343,
    width: 2,
    height: 13.313,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.994A11.994,11.994,0,0,1,3.515,3.515h0A12,12,0,1,1,12,23.994ZM4.929,4.929a10,10,0,1,0,14.143,0,10.011,10.011,0,0,0-14.143,0Z",
    fill: "currentColor"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "clipboard",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "clipboard icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15,7H8A1,1,0,0,1,7,6V2A1,1,0,0,1,8,1h7a1,1,0,0,1,1,1V6A1,1,0,0,1,15,7ZM9,5h5V3H9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,23H3a2,2,0,0,1-2-2V5A2,2,0,0,1,3,3H6V5H3V21H20V5H17V3h3a2,2,0,0,1,2,2V21A2,2,0,0,1,20,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,20H5a1,1,0,0,1-1-1V7H6V18H17V7h2V19A1,1,0,0,1,18,20Z",
    fill: "currentColor"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "clock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "clock icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,17.414l-3.707-3.707A1,1,0,0,1,11,13V5h2v7.586L16.414,16Z",
    fill: "currentColor"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud-rain",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "cloud-rain icon"), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18.5,
    width: 2,
    height: 5.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18.5,
    width: 2,
    height: 3.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18.5,
    width: 2,
    height: 5.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10H7a6.007,6.007,0,0,1,6-6V6A4,4,0,0,0,9,10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.815,19H6.275c-2.315,0-5.482-.392-6.25-3.779h0a6.1,6.1,0,0,1,1.05-4.908A5.6,5.6,0,0,1,4.123,8.146,8.472,8.472,0,0,1,12.5,1c4.582,0,7.782,4.11,8.419,8.285A4.831,4.831,0,0,1,24,14a1.007,1.007,0,0,1-.013.158A5.388,5.388,0,0,1,18.815,19ZM1.975,14.779C2.237,15.933,2.938,17,6.275,17h12.54A3.4,3.4,0,0,0,22,13.92a2.93,2.93,0,0,0-2.32-2.973A1,1,0,0,1,19,10.09C18.687,6.6,16.167,3,12.5,3A6.588,6.588,0,0,0,5.993,9.12,1,1,0,0,1,5.1,10a3.446,3.446,0,0,0-2.4,1.489,4.157,4.157,0,0,0-.721,3.295Z",
    fill: "currentColor"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "cloud icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.815,20H6.275c-2.315,0-5.482-.392-6.25-3.779h0a6.1,6.1,0,0,1,1.05-4.908A5.6,5.6,0,0,1,4.123,9.146,8.472,8.472,0,0,1,12.5,2c4.582,0,7.782,4.11,8.419,8.285A4.831,4.831,0,0,1,24,15a1.007,1.007,0,0,1-.013.158A5.388,5.388,0,0,1,18.815,20ZM1.975,15.779C2.237,16.933,2.938,18,6.275,18h12.54A3.4,3.4,0,0,0,22,14.92a2.93,2.93,0,0,0-2.32-2.973A1,1,0,0,1,19,11.09C18.687,7.6,16.167,4,12.5,4a6.588,6.588,0,0,0-6.507,6.12A1,1,0,0,1,5.1,11a3.446,3.446,0,0,0-2.4,1.489,4.156,4.156,0,0,0-.721,3.295Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11H7a6.007,6.007,0,0,1,6-6V7A4,4,0,0,0,9,11Z",
    fill: "currentColor"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "collapse",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "collapse icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15,16H8a1,1,0,0,1-1-1V8A1,1,0,0,1,8,7h7a1,1,0,0,1,1,1v7A1,1,0,0,1,15,16ZM9,14h5V9H9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,7H0V5H5V0H7V6A1,1,0,0,1,6,7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,7H17a1,1,0,0,1-1-1V0h2V5h5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,23H16V17a1,1,0,0,1,1-1h6v2H18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,23H5V18H0V16H6a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-conversation",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "comment-conversation icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23,22.857a1,1,0,0,1-.689-.276L19.6,20H11.5A1.5,1.5,0,0,1,10,18.5v-7A1.5,1.5,0,0,1,11.5,10h11A1.5,1.5,0,0,1,24,11.5V21.857a1,1,0,0,1-1,1ZM12,18h8a1,1,0,0,1,.689.276L22,19.524V12H12Zm10.5-6h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,19.929a1,1,0,0,1-1-1V5A2,2,0,0,1,2,3H18a2,2,0,0,1,2,2V8H18V5H2V16.539l2.284-2.251a1,1,0,0,1,.7-.288H8v2H5.4L1.7,19.641A1,1,0,0,1,1,19.929Z",
    fill: "currentColor"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-text",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "comment-text icon"), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 14,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 11,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 7,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,23a1,1,0,0,1-1-1V4A2,2,0,0,1,3,2H21a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H7.414L2.707,22.707A1,1,0,0,1,2,23ZM21,4H3V19.586l3.293-3.293A1,1,0,0,1,7,16H21Z",
    fill: "currentColor"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment-typing",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "comment-typing icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17.154,8A1.846,1.846,0,1,0,19,9.846,1.846,1.846,0,0,0,17.154,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8a1.846,1.846,0,1,0,1.846,1.846A1.846,1.846,0,0,0,12,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.846,8A1.846,1.846,0,1,0,8.692,9.846,1.846,1.846,0,0,0,6.846,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,23a1,1,0,0,1-1-1V4A2,2,0,0,1,3,2H21a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H7.414L2.707,22.707A1,1,0,0,1,2,23ZM21,4H3V19.586l3.293-3.293A1,1,0,0,1,7,16H21Z",
    fill: "currentColor"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "comment icon"), /*#__PURE__*/React.createElement("path", {
    d: "M2,23a1,1,0,0,1-1-1V4A2,2,0,0,1,3,2H21a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H7.414L2.707,22.707A1,1,0,0,1,2,23ZM21,4H3V19.586l3.293-3.293A1,1,0,0,1,7,16H21Z",
    fill: "currentColor"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "compass",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "compass icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 2,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 2,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,18a1,1,0,0,1-.873-1.488L9.713,10.1a1.006,1.006,0,0,1,.385-.385l6.414-3.586a1,1,0,0,1,1.361,1.361L14.287,13.9a1.006,1.006,0,0,1-.385.385L7.488,17.873A1,1,0,0,1,7,18Zm4.32-6.679L9.6,14.4l3.081-1.723L14.4,9.6Zm2.094,2.093h0Z",
    fill: "currentColor"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "contact-card",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "contact-card icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,21H3a2,2,0,0,1-2-2V3A2,2,0,0,1,3,1H20a1,1,0,0,1,1,1V20A1,1,0,0,1,20,21ZM3,3V19H19V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,24H3V22H22V10h2V23A1,1,0,0,1,23,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,10.5a2.25,2.25,0,1,1,2.25-2.25A2.252,2.252,0,0,1,11,10.5ZM11,8a.25.25,0,0,0-.25.25c0,.275.5.275.5,0A.25.25,0,0,0,11,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75,17H7.25a1,1,0,0,1-1-1V14.75a4.941,4.941,0,0,1,1.509-3.171l.671-.741L9.913,12.18l-.671.741A3.045,3.045,0,0,0,8.25,14.75V15h5.5v-.25a3.045,3.045,0,0,0-.991-1.829l-.671-.741,1.482-1.343.671.741A4.941,4.941,0,0,1,15.75,14.75V16A1,1,0,0,1,14.75,17Z",
    fill: "currentColor"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "copy icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22.321,22H12.679A1.68,1.68,0,0,1,11,20.321V9.679A1.68,1.68,0,0,1,12.679,8h6.2a2.351,2.351,0,0,1,1.6.627l2.768,2.564A2.365,2.365,0,0,1,24,12.921v7.4A1.68,1.68,0,0,1,22.321,22ZM13,20h9V12.921a.358.358,0,0,0-.114-.262h0l-2.768-2.564A.357.357,0,0,0,18.876,10H13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,22H3a2,2,0,0,1-2-2V4A2,2,0,0,1,3,2h9.17a4.514,4.514,0,0,1,2.537,1.292L16.414,5,15,6.414,13.293,4.707A3.23,3.23,0,0,0,12.146,4H3V20H9Z",
    fill: "currentColor"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "credit-card",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "credit-card icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,20H2a2,2,0,0,1-2-2V6A2,2,0,0,1,2,4H22a2,2,0,0,1,2,2V18A2,2,0,0,1,22,20ZM2,6V18H22V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 22,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 5,
    height: 2,
    fill: "currentColor"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "crosshairs",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "crosshairs icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 11,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,21a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21ZM12,5a7,7,0,1,0,7,7A7.008,7.008,0,0,0,12,5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,12,10Z",
    fill: "currentColor"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "database",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "database icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,23c-2.111,0-9-.216-9-3V4.105C3,1.087,11.079,1,12,1s9,.087,9,3.105V20C21,22.784,14.111,23,12,23ZM5,19.854C5.486,20.284,7.867,21,12,21s6.514-.716,7-1.146V4.242C18.527,3.791,16.085,3,12,3s-6.527.791-7,1.242Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8C8.657,8,3,7.263,3,4.5S8.657,1,12,1s9,.737,9,3.5S15.343,8,12,8ZM5.027,4.5C5.392,4.976,7.753,6,12,6s6.608-1.024,6.973-1.5C18.608,4.024,16.247,3,12,3S5.392,4.024,5.027,4.5Zm13.983.059h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13c-1.5,0-9-.145-9-3V9H5v.833C5.518,10.262,7.97,11,12,11s6.482-.738,7-1.167V9h2v1C21,12.855,13.5,13,12,13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18c-1.5,0-9-.145-9-3V14H5v.833C5.518,15.262,7.97,16,12,16s6.482-.738,7-1.167V14h2v1C21,17.855,13.5,18,12,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 2,
    height: 4,
    fill: "currentColor"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "device-laptop",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "device-laptop icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,22H2a2,2,0,0,1-2-1.89,3.5,3.5,0,0,1,.023-1.338A2.113,2.113,0,0,1,2,17H22a1.959,1.959,0,0,1,2,2l.016.1a2.376,2.376,0,0,1-.078,1.252A2.454,2.454,0,0,1,22,22ZM2.074,19a.617.617,0,0,0-.1.229,1.622,1.622,0,0,0,0,.557A.987.987,0,0,1,2,20H21.817a1.049,1.049,0,0,0,.245-.348,1.107,1.107,0,0,0-.023-.248A2.7,2.7,0,0,1,22,19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,15H20V4H4V15H2V4A2,2,0,0,1,4,2H20a2,2,0,0,1,2,2Z",
    fill: "currentColor"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "device-mobile",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "device-mobile icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18,24H6a2,2,0,0,1-2-2V2A2,2,0,0,1,6,0H18a2,2,0,0,1,2,2V22A2,2,0,0,1,18,24ZM6,2V22H18V2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,18H8a1,1,0,0,1-1-1V4A1,1,0,0,1,8,3h8a1,1,0,0,1,1,1V17A1,1,0,0,1,16,18ZM9,16h6V5H9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1,
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,19a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "device-monitor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "device-monitor icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,18H1.5A1.5,1.5,0,0,1,0,16.5V3.5A1.5,1.5,0,0,1,1.5,2h21A1.5,1.5,0,0,1,24,3.5v13A1.5,1.5,0,0,1,22.5,18ZM2,16H22V4H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 14,
    height: 2,
    fill: "currentColor"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "device-tablet",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "device-tablet icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,22H2a2,2,0,0,1-2-2V4A2,2,0,0,1,2,2H22a2,2,0,0,1,2,2V20A2,2,0,0,1,22,22ZM22,4H2V20H22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,19.066H4a1,1,0,0,1-1-1V5.934a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1V18.066A1,1,0,0,1,17,19.066Zm-12-2H16V6.934H5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 1,
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,11a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "device-tv",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "device-tv icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,20H2a2,2,0,0,1-2-2V4A2,2,0,0,1,2,2H22a2,2,0,0,1,2,2V18A2,2,0,0,1,22,20ZM2,4V18H22V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21,
    width: 22,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16a1,1,0,0,1-1-1V7a1,1,0,0,1,1.5-.868l7,4a1,1,0,0,1,0,1.736l-7,4A1,1,0,0,1,9,16Zm1-7.276v4.553L13.984,11Z",
    fill: "currentColor"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar-sign",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "dollar-sign icon"), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 2,
    height: 24,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 2,
    height: 24,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22c-3.859,0-7-2.586-7-5.765v-1H7v1C7,18.312,9.243,20,12,20s5-1.688,5-3.765c0-2.1-1.87-2.836-4.95-3.806-2.793-.88-5.959-1.877-5.959-5.194C6.091,4.349,8.741,2,12,2s5.909,2.349,5.909,5.235v1h-2v-1C15.909,5.451,14.155,4,12,4S8.091,5.451,8.091,7.235c0,1.726,1.723,2.393,4.561,3.286S19,12.521,19,16.235C19,19.414,15.859,22,12,22Z",
    fill: "currentColor"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "download-cloud",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "download-cloud icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,18H16V16h2.1a3.137,3.137,0,0,0,3.151-2.511,3.028,3.028,0,0,0-2-3.371,1,1,0,0,1-.675-.857A6.155,6.155,0,0,0,6.336,9.085a1,1,0,0,1-.9.875A3.032,3.032,0,0,0,2.787,13.67,3.1,3.1,0,0,0,5.863,16H9v2H5.863A5.107,5.107,0,0,1,.833,14.1a5.033,5.033,0,0,1,3.642-5.99,8.158,8.158,0,0,1,16.012.363,5.031,5.031,0,0,1,2.736,5.337A5.15,5.15,0,0,1,18.1,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.6a2.5,2.5,0,0,1-1.707-.9L7.586,20,9,18.586l2.707,2.707a2.935,2.935,0,0,0,.293.263,2.935,2.935,0,0,0,.293-.263L15,18.586,16.414,20l-2.707,2.707A2.5,2.5,0,0,1,12,23.6Zm.09-1.991h0Z",
    fill: "currentColor"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "download icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,22H3.1A2.1,2.1,0,0,1,1,19.9V3.4C1,1.808,1.673,1,3,1H8V3H3.013C3,3.121,3,3.293,3,3.4V19.9a.1.1,0,0,0,.1.1H20.9a.1.1,0,0,0,.1-.1V3.4c0-.106,0-.279-.013-.4H16V1h5c1.327,0,2,.808,2,2.4V19.9A2.1,2.1,0,0,1,20.9,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.956,17.449a2.314,2.314,0,0,1-1.663-.742L6.586,13,8,11.586l3.707,3.707c.112.112.282.28.6-.013L16,11.586,17.414,13l-3.707,3.707A2.562,2.562,0,0,1,11.956,17.449Z",
    fill: "currentColor"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "edit icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,22H3a2,2,0,0,1-2-2V6A2,2,0,0,1,3,4H13V6H3V20H20V11h2v9A2,2,0,0,1,20,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,7.927a1,1,0,0,1-.707-.293L17.366,4.805a1,1,0,0,1,0-1.414L19.487,1.27a2,2,0,0,1,2.829,0L23.73,2.684a2,2,0,0,1,0,2.829L21.609,7.634A1,1,0,0,1,20.9,7.927ZM19.487,4.1,20.9,5.513,22.316,4.1,20.9,2.684Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.829,16H10a1,1,0,0,1-1-1V12.171a1,1,0,0,1,.293-.707l8.28-8.28L18.987,4.6,11,12.585V14h1.415L20.4,6.013l1.414,1.414-8.28,8.28A1,1,0,0,1,12.829,16Z",
    fill: "currentColor"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "envelope-closed",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "envelope-closed icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,22H2a2,2,0,0,1-2-2V7.333C0,5.4,1.088,5,2,5H22c.912,0,2,.4,2,2.333V20A2,2,0,0,1,22,22ZM2.01,7C2,7.1,2,7.245,2,7.333V20H22V7.333c0-.088,0-.229-.01-.333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16a1,1,0,0,1-.5-.132l-7.868-4.5.992-1.736L12,13.848l7.372-4.212.992,1.736-7.868,4.5A1,1,0,0,1,12,16Z",
    fill: "currentColor"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "envelope-open",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "envelope-open icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.258,14.5h-.512c-.774,0-3.217-1.225-7.259-3.642l-.858-.513L4.654,8.628l.858.513a48.189,48.189,0,0,0,6.312,3.364l.434-.005a53.843,53.843,0,0,0,6.229-3.358l.858-.513,1.026,1.717-.857.513C15.473,13.275,13.031,14.5,12.258,14.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,21H2a2,2,0,0,1-2-2V7C0,5.9,1.308,5.222,1.57,5.1l9.591-4.3A1.977,1.977,0,0,1,12.86.8l9.549,4.286.021.009C22.692,5.222,24,5.9,24,7V19A2,2,0,0,1,22,21ZM2,7.194V19H22V7.194a1.968,1.968,0,0,0-.422-.288l-9.558-4.29-9.611,4.3A1.915,1.915,0,0,0,2,7.194Z",
    fill: "currentColor"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "exclamation-filled icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 3,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 19,
    r: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,18a1,1,0,1,1-1,1,1,1,0,0,1,1-1m0-1a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z",
    fill: "currentColor"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation-point",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "exclamation-point icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,16H11c-1.429,0-1.53-1.344-1.563-1.786L8.5,3.083A2.017,2.017,0,0,1,10.5,1h3a2,2,0,0,1,2,2l-.933,11.16C14.53,14.656,14.429,16,13,16Zm0-2v0Zm-1.574,0h1.148L13.5,2.917,10.5,3l.926,10.993Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23a3,3,0,1,1,3-3A3,3,0,0,1,12,23Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,12,19Z",
    fill: "currentColor"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "expand",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "expand icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15,16H8a1,1,0,0,1-1-1V8A1,1,0,0,1,8,7h7a1,1,0,0,1,1,1v7A1,1,0,0,1,15,16ZM9,14h5V9H9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,8H1V2A1,1,0,0,1,2,1H8V3H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,8H20V3H15V1h6a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15V20h5V15h2v6A1,1,0,0,1,21,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,22H2a1,1,0,0,1-1-1V15H3v5H8Z",
    fill: "currentColor"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "export",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "export icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,22H3a2,2,0,0,1-2-2V4A2,2,0,0,1,3,2H9V4H3V20H20V16h2v4A2,2,0,0,1,20,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.027,10,20,4.022,14,4,14,2l6,.027A2.007,2.007,0,0,1,22,4.013L22.027,10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.524,
    y: 9.526,
    width: 11.899,
    height: 2,
    transform: "translate(-3.497 12.61) rotate(-45)",
    fill: "currentColor"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "face-neutral",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "face-neutral icon"), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 11,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,24A11.5,11.5,0,1,1,23,12.5,11.513,11.513,0,0,1,11.5,24Zm0-21A9.5,9.5,0,1,0,21,12.5,9.511,9.511,0,0,0,11.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11a2,2,0,1,1,2-2A2,2,0,0,1,8,11ZM8,9H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11a2,2,0,1,1,2-2A2,2,0,0,1,15,11Zm0-2h0Z",
    fill: "currentColor"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "face-sad-big",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "face-sad-big icon"), /*#__PURE__*/React.createElement("path", {
    d: "M6.723,13.387,5.613,11.723,8.2,10,5.613,8.277,6.723,6.613l3.832,2.555a1,1,0,0,1,0,1.664Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.277,13.387l-3.832-2.555a1,1,0,0,1,0-1.664l3.832-2.555,1.109,1.664L14.8,10l2.584,1.723Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.825,19.016a2.165,2.165,0,0,1-1.936-1.328,2.021,2.021,0,0,1,.481-2.464A8.773,8.773,0,0,1,11.5,13.5a8.776,8.776,0,0,1,5.13,1.723h0a2.021,2.021,0,0,1,.481,2.464,2.118,2.118,0,0,1-2.294,1.295l-.505-.1A16.835,16.835,0,0,0,11.5,18.5a16.835,16.835,0,0,0-2.812.388l-.505.1A1.947,1.947,0,0,1,7.825,19.016ZM11.5,15.5a6.686,6.686,0,0,0-3.87,1.277c.027.021.138.213.217.242l.467-.1A18.123,18.123,0,0,1,11.5,16.5a18.123,18.123,0,0,1,3.186.423l.5.094a.52.52,0,0,0,.146-.273A6.723,6.723,0,0,0,11.5,15.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,24A11.5,11.5,0,1,1,23,12.5,11.513,11.513,0,0,1,11.5,24Zm0-21A9.5,9.5,0,1,0,21,12.5,9.511,9.511,0,0,0,11.5,3Z",
    fill: "currentColor"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "face-sad",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "face-sad icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15.793,18.207A6.712,6.712,0,0,0,11.5,16.5a6.607,6.607,0,0,0-4.293,1.707L5.793,16.793A8.645,8.645,0,0,1,11.5,14.5a8.645,8.645,0,0,1,5.707,2.293Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,24A11.5,11.5,0,1,1,23,12.5,11.513,11.513,0,0,1,11.5,24Zm0-21A9.5,9.5,0,1,0,21,12.5,9.511,9.511,0,0,0,11.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11a2,2,0,1,1,2-2A2,2,0,0,1,8,11ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11a2,2,0,1,1,2-2A2,2,0,0,1,15,11Zm0-2h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    fill: "currentColor"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "face-smile-big",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "face-smile-big icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,24A11.5,11.5,0,1,1,23,12.5,11.513,11.513,0,0,1,11.5,24Zm0-21A9.5,9.5,0,1,0,21,12.5,9.511,9.511,0,0,0,11.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11a2,2,0,1,1,2-2A2,2,0,0,1,8,11ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11a2,2,0,1,1,2-2A2,2,0,0,1,15,11Zm0-2h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,19.5c-3.86,0-7-2.81-7-6.263a1,1,0,0,1,.423-.818c.436-.31.815-.177,1.295-.007A16.874,16.874,0,0,0,11.5,13.5a16.874,16.874,0,0,0,5.282-1.088c.48-.169.86-.3,1.295.007a1,1,0,0,1,.423.818C18.5,16.69,15.36,19.5,11.5,19.5ZM6.81,14.714A5.038,5.038,0,0,0,11.5,17.5a5.038,5.038,0,0,0,4.69-2.786,16.7,16.7,0,0,1-4.69.786A16.7,16.7,0,0,1,6.81,14.714Z",
    fill: "currentColor"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "face-smile",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "face-smile icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,24A11.5,11.5,0,1,1,23,12.5,11.513,11.513,0,0,1,11.5,24Zm0-21A9.5,9.5,0,1,0,21,12.5,9.511,9.511,0,0,0,11.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11a2,2,0,1,1,2-2A2,2,0,0,1,8,11ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8ZM8,9H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11a2,2,0,1,1,2-2A2,2,0,0,1,15,11Zm0-2h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,17.5a8.645,8.645,0,0,1-5.707-2.293l1.414-1.414A6.712,6.712,0,0,0,11.5,15.5a6.607,6.607,0,0,0,4.293-1.707l1.414,1.414A8.645,8.645,0,0,1,11.5,17.5Z",
    fill: "currentColor"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "factory",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "factory icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,24H2a1,1,0,0,1-1-1V1A1,1,0,0,1,2,0H7A1,1,0,0,1,8,1V6H6V2H3V22H21V5.869l-7.445,4.963A1,1,0,0,1,12,10V6.414l-5,5L5.586,10l6.707-6.707A1,1,0,0,1,14,4V8.131l7.445-4.963A1,1,0,0,1,23,4V23A1,1,0,0,1,22,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,23H17V16H14v7H12V15a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-audio",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-audio icon"), /*#__PURE__*/React.createElement("path", {
    d: "M10,17H8V9A1.893,1.893,0,0,1,9.83,7.014l3.928-.984a1.907,1.907,0,0,1,1.558.384A1.953,1.953,0,0,1,16,8v8H14V8.03l-3.758.94c-.046.011-.16.028-.207.033l-.027,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,19a2,2,0,1,1,2-2A2,2,0,0,1,8,19Zm0-2H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18a2,2,0,1,1,2-2A2,2,0,0,1,14,18Zm0-2h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,24H4.125A2.115,2.115,0,0,1,2,21.9V2.1A2.115,2.115,0,0,1,4.125,0H14.443a3.255,3.255,0,0,1,2.29.93L21.04,5.141h0A3.2,3.2,0,0,1,22,7.411V21.9A2.115,2.115,0,0,1,19.875,24ZM4.125,2A.115.115,0,0,0,4,2.1V21.9a.115.115,0,0,0,.125.1h15.75A.115.115,0,0,0,20,21.9V7.411a1.169,1.169,0,0,0-.358-.841L15.335,2.359A1.283,1.283,0,0,0,14.443,2Z",
    fill: "currentColor"
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-code",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-code icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 6,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16.414,6.586,15l3.5-3.5L6.586,8,8,6.586l3.707,3.707a1.54,1.54,0,0,1,0,2.414Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,24H4.125A2.115,2.115,0,0,1,2,21.9V2.1A2.115,2.115,0,0,1,4.125,0H14.443a3.258,3.258,0,0,1,2.29.929L21.04,5.141A3.2,3.2,0,0,1,22,7.411V21.9A2.115,2.115,0,0,1,19.875,24ZM4.125,2A.116.116,0,0,0,4,2.1V21.9a.116.116,0,0,0,.125.1h15.75A.116.116,0,0,0,20,21.9V7.411a1.167,1.167,0,0,0-.358-.84h0L15.335,2.359A1.287,1.287,0,0,0,14.443,2Z",
    fill: "currentColor"
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-csv",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-csv icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19ZM2,17H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.151,5.406,16.654,3.4a1.018,1.018,0,0,1-.08-.072C16.265,3.013,16.174,3,16,3H5V5H3V3A1.979,1.979,0,0,1,5,1H16a2.61,2.61,0,0,1,1.949.87l2.457,1.979Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.857,24H5.143A2.077,2.077,0,0,1,3,22V20H5v2c0-.042.069,0,.143,0H17.857a.236.236,0,0,0,.16-.063L18,20h2v2A2.077,2.077,0,0,1,17.857,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.712,14.977a3.154,3.154,0,0,1-1.047-.167A2.169,2.169,0,0,1,4.3,13.483,3.48,3.48,0,0,1,4.3,11.241a2.347,2.347,0,0,1,.526-.844,2.233,2.233,0,0,1,.822-.523,3.017,3.017,0,0,1,1.071-.185,4.148,4.148,0,0,1,.579.036,3.951,3.951,0,0,1,.477.094,3.392,3.392,0,0,1,.416.146c.124.053.233.1.326.148v1.234h-.15c-.064-.054-.144-.119-.241-.194a3.217,3.217,0,0,0-.33-.221,2.3,2.3,0,0,0-.407-.184,1.439,1.439,0,0,0-.468-.075,1.585,1.585,0,0,0-.526.087,1.284,1.284,0,0,0-.461.288,1.421,1.421,0,0,0-.326.515,2.143,2.143,0,0,0-.125.778,2.068,2.068,0,0,0,.135.8,1.4,1.4,0,0,0,.34.5,1.244,1.244,0,0,0,.465.268,1.694,1.694,0,0,0,.506.08,1.618,1.618,0,0,0,.473-.071,1.856,1.856,0,0,0,.433-.194,2.887,2.887,0,0,0,.311-.211c.1-.075.174-.14.236-.194h.137v1.217c-.127.057-.25.11-.366.161a3.02,3.02,0,0,1-.366.13,4.355,4.355,0,0,1-.468.109A3.761,3.761,0,0,1,6.712,14.977Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.972,13.278a1.45,1.45,0,0,1-.638,1.222,2.856,2.856,0,0,1-1.731.47,4.85,4.85,0,0,1-1.1-.111,5.718,5.718,0,0,1-.88-.282v-1.22h.144a3.043,3.043,0,0,0,.911.5,2.964,2.964,0,0,0,.969.174,3.147,3.147,0,0,0,.314-.021,1.264,1.264,0,0,0,.318-.068.8.8,0,0,0,.248-.154.361.361,0,0,0,.1-.273.367.367,0,0,0-.142-.289.984.984,0,0,0-.415-.187q-.287-.068-.606-.128a4.681,4.681,0,0,1-.6-.152,1.885,1.885,0,0,1-.924-.565,1.386,1.386,0,0,1-.282-.887,1.365,1.365,0,0,1,.638-1.161A2.782,2.782,0,0,1,11.928,9.7a5.051,5.051,0,0,1,.993.1,4.6,4.6,0,0,1,.849.244V11.21h-.14a2.7,2.7,0,0,0-.754-.412,2.584,2.584,0,0,0-.911-.166,2.359,2.359,0,0,0-.327.022,1.274,1.274,0,0,0-.312.083.6.6,0,0,0-.229.156.34.34,0,0,0-.1.237.356.356,0,0,0,.154.31,1.733,1.733,0,0,0,.581.2l.538.113a5.62,5.62,0,0,1,.556.15,1.858,1.858,0,0,1,.863.521A1.283,1.283,0,0,1,13.972,13.278Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,9.788l-1.856,5.089h-1.47L14.723,9.788H16.1l1.23,3.573,1.23-3.573Z",
    fill: "currentColor"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-generic",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-generic icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,24H4.125A2.115,2.115,0,0,1,2,21.9V2.1A2.115,2.115,0,0,1,4.125,0H14.443a3.255,3.255,0,0,1,2.29.93L21.04,5.141h0A3.2,3.2,0,0,1,22,7.411V21.9A2.115,2.115,0,0,1,19.875,24ZM4.125,2A.115.115,0,0,0,4,2.1V21.9a.115.115,0,0,0,.125.1h15.75A.115.115,0,0,0,20,21.9V7.411a1.169,1.169,0,0,0-.358-.841L15.335,2.359A1.283,1.283,0,0,0,14.443,2Z",
    fill: "currentColor"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-jpg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-jpg icon"), /*#__PURE__*/React.createElement("path", {
    d: "M7.41,13.384a1.656,1.656,0,0,1-.12.627,1.271,1.271,0,0,1-.355.494,1.777,1.777,0,0,1-.6.333,2.793,2.793,0,0,1-.872.118q-.352,0-.662-.025a4.727,4.727,0,0,1-.547-.073V13.828h.123c.109.041.223.079.342.115A1.627,1.627,0,0,0,5.171,14a1.271,1.271,0,0,0,.552-.1A.575.575,0,0,0,6,13.633a.969.969,0,0,0,.089-.368c.007-.133.011-.3.011-.512V10.725H4.932V9.788H7.41Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.264,11.395a1.921,1.921,0,0,1-.119.668,1.486,1.486,0,0,1-.342.548,2.086,2.086,0,0,1-.679.455,2.456,2.456,0,0,1-.931.154h-.817v1.658H9.063V9.788h2.16a3.42,3.42,0,0,1,.818.083,1.928,1.928,0,0,1,.59.251,1.344,1.344,0,0,1,.47.516A1.626,1.626,0,0,1,13.264,11.395Zm-1.356.029a.6.6,0,0,0-.116-.37.635.635,0,0,0-.27-.216,1.226,1.226,0,0,0-.4-.091c-.13-.005-.3-.008-.52-.008h-.226v1.521h.376a3.06,3.06,0,0,0,.552-.041.777.777,0,0,0,.364-.164.628.628,0,0,0,.183-.261A1.056,1.056,0,0,0,11.907,11.424Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.115,14.587a6.893,6.893,0,0,1-.906.265,4.94,4.94,0,0,1-1.124.131,2.817,2.817,0,0,1-2.034-.706,2.579,2.579,0,0,1-.734-1.95,2.553,2.553,0,0,1,.742-1.912,2.828,2.828,0,0,1,2.067-.727,4.882,4.882,0,0,1,.957.091,4.256,4.256,0,0,1,1.012.36v1.193h-.147c-.063-.048-.156-.116-.279-.2a3.516,3.516,0,0,0-.355-.224,2.367,2.367,0,0,0-.463-.188,1.985,1.985,0,0,0-.562-.079,1.854,1.854,0,0,0-.633.1,1.4,1.4,0,0,0-.85.836,1.979,1.979,0,0,0-.125.729,1.751,1.751,0,0,0,.448,1.292,1.794,1.794,0,0,0,1.323.448c.05,0,.105,0,.166,0s.115-.006.165-.01v-1H16.768v-.96h2.348Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19ZM2,17H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.151,5.406,16.654,3.4a.879.879,0,0,1-.081-.073C16.265,3.013,16.175,3,16,3H5V5H3V3A1.979,1.979,0,0,1,5,1H16a2.609,2.609,0,0,1,1.949.87l2.457,1.978Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.857,24H5.143A2.077,2.077,0,0,1,3,22V20H5v2c0-.042.069,0,.143,0H17.857a.234.234,0,0,0,.159-.063L18,20h2v2A2.077,2.077,0,0,1,17.857,24Z",
    fill: "currentColor"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-multiple",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-multiple icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,24H4a2,2,0,0,1-2-2V4H4V22H19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,21H7a2,2,0,0,1-2-2V2A2,2,0,0,1,7,0h9.171a2.98,2.98,0,0,1,2.122.879l3.414,3.414A4.515,4.515,0,0,1,23,6.829V19A2,2,0,0,1,21,21ZM7,2V19H21V6.829a3.387,3.387,0,0,0-.707-1.122L16.879,2.293A.994.994,0,0,0,16.171,2Z",
    fill: "currentColor"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-pdf-1",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-pdf-1 icon"), /*#__PURE__*/React.createElement("path", {
    d: "M6.26,19.072a1.314,1.314,0,0,1-.946-.378,1.413,1.413,0,0,1-.345-1.5c.292-.821,1.344-1.47,3.14-1.941A8.8,8.8,0,0,0,9.332,13.01,22.68,22.68,0,0,0,10.193,9.9c-.67-1.529-1.146-3.148-.678-4.014a1.379,1.379,0,0,1,1.235-.724,1.519,1.519,0,0,1,1.268.666c.563.8.508,2.316.257,3.809a23.524,23.524,0,0,0,1.555,2.821A11.987,11.987,0,0,0,15.543,14.5c1.828.115,2.94.574,3.32,1.374a1.415,1.415,0,0,1-.313,1.638,1.456,1.456,0,0,1-1.211.4,5.524,5.524,0,0,1-2.6-1.433,23.971,23.971,0,0,0-2.706.143h0a26.655,26.655,0,0,0-2.787.417,5.9,5.9,0,0,1-2.623,2A1.665,1.665,0,0,1,6.26,19.072Zm5.31-6.487c-.185.617-.331,1.033-.353,1.095a9.617,9.617,0,0,1-.459,1.074q.514-.068,1.073-.125h0q.541-.056,1.041-.091c-.262-.327-.5-.658-.715-.982C12.146,13.541,11.906,13.167,11.569,12.585Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,24H4.125A2.115,2.115,0,0,1,2,21.9V2.1A2.115,2.115,0,0,1,4.125,0H14.443a3.258,3.258,0,0,1,2.29.929L21.04,5.141A3.2,3.2,0,0,1,22,7.411V21.9A2.115,2.115,0,0,1,19.875,24ZM4.125,2A.116.116,0,0,0,4,2.1V21.9a.116.116,0,0,0,.125.1h15.75A.116.116,0,0,0,20,21.9V7.411a1.167,1.167,0,0,0-.358-.84h0L15.335,2.359A1.287,1.287,0,0,0,14.443,2Z",
    fill: "currentColor"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-pdf-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-pdf-2 icon"), /*#__PURE__*/React.createElement("path", {
    d: "M8.559,11.395a1.945,1.945,0,0,1-.12.668,1.486,1.486,0,0,1-.342.548,2.076,2.076,0,0,1-.679.455,2.458,2.458,0,0,1-.932.154H5.67v1.658H4.357V9.788h2.16a3.415,3.415,0,0,1,.818.083,1.928,1.928,0,0,1,.59.251,1.352,1.352,0,0,1,.47.516A1.626,1.626,0,0,1,8.559,11.395ZM7.2,11.424a.6.6,0,0,0-.116-.37.62.62,0,0,0-.271-.216,1.221,1.221,0,0,0-.4-.091c-.13-.005-.3-.008-.52-.008H5.67v1.521h.376a3.053,3.053,0,0,0,.552-.041.786.786,0,0,0,.364-.164.62.62,0,0,0,.183-.261A1.056,1.056,0,0,0,7.2,11.424Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.717,12.338a2.5,2.5,0,0,1-.324,1.273,2.374,2.374,0,0,1-.82.863,2.524,2.524,0,0,1-.817.314,5.449,5.449,0,0,1-1.053.089H9.908V9.788h1.846a4.828,4.828,0,0,1,1.072.1,2.513,2.513,0,0,1,.76.3,2.309,2.309,0,0,1,.828.866A2.611,2.611,0,0,1,14.717,12.338Zm-1.357-.01a1.875,1.875,0,0,0-.182-.859,1.286,1.286,0,0,0-.58-.559,1.527,1.527,0,0,0-.412-.135,4.173,4.173,0,0,0-.634-.036h-.331v3.186h.331a3.971,3.971,0,0,0,.687-.042,1.5,1.5,0,0,0,.428-.156,1.27,1.27,0,0,0,.526-.548A1.922,1.922,0,0,0,13.359,12.328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.785,10.772H17.443v.947h2.171V12.7H17.443v2.174h-1.3V9.788h3.646Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19ZM2,17H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.151,5.406,16.654,3.4a.879.879,0,0,1-.081-.073C16.265,3.013,16.175,3,16,3H5V5H3V3A1.979,1.979,0,0,1,5,1H16a2.609,2.609,0,0,1,1.949.87l2.457,1.978Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.857,24H5.143A2.077,2.077,0,0,1,3,22V20H5v2c0-.042.069,0,.143,0H17.857a.234.234,0,0,0,.159-.063L18,20h2v2A2.077,2.077,0,0,1,17.857,24Z",
    fill: "currentColor"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-photo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-photo icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18,21H6a1,1,0,0,1-1-1V17a1,1,0,0,1,.137-.5c.161-.275.161-.275,5.354-3.355a1,1,0,0,1,1.217.153L14,15.586l3.293-3.293A1,1,0,0,1,19,13v7A1,1,0,0,1,18,21ZM7,19H17V15.414l-2.293,2.293a1,1,0,0,1-1.414,0l-2.45-2.451c-1.367.813-3.06,1.821-3.843,2.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.5,
    r: 2.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,24H4.125A2.115,2.115,0,0,1,2,21.9V2.1A2.115,2.115,0,0,1,4.125,0H14.443a3.255,3.255,0,0,1,2.29.93L21.04,5.141h0A3.2,3.2,0,0,1,22,7.411V21.9A2.115,2.115,0,0,1,19.875,24ZM4.125,2A.115.115,0,0,0,4,2.1V21.9a.115.115,0,0,0,.125.1h15.75A.115.115,0,0,0,20,21.9V7.411a1.169,1.169,0,0,0-.358-.841L15.335,2.359A1.283,1.283,0,0,0,14.443,2Z",
    fill: "currentColor"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-png",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-png icon"), /*#__PURE__*/React.createElement("path", {
    d: "M7.937,11.395a1.921,1.921,0,0,1-.119.668,1.486,1.486,0,0,1-.342.548,2.086,2.086,0,0,1-.679.455,2.456,2.456,0,0,1-.931.154H5.05v1.658H3.737V9.788H5.9a3.42,3.42,0,0,1,.818.083,1.928,1.928,0,0,1,.59.251,1.344,1.344,0,0,1,.47.516A1.626,1.626,0,0,1,7.937,11.395Zm-1.356.029a.6.6,0,0,0-.116-.37.635.635,0,0,0-.27-.216,1.226,1.226,0,0,0-.4-.091c-.13-.005-.3-.008-.52-.008H5.05v1.521h.376a3.06,3.06,0,0,0,.552-.041.777.777,0,0,0,.364-.164.628.628,0,0,0,.183-.261A1.056,1.056,0,0,0,6.581,11.424Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.916,14.877H12.65l-2.16-3.493v3.493h-1.2V9.788h1.569L12.713,12.7V9.788h1.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.136,14.587a6.918,6.918,0,0,1-.905.265,4.967,4.967,0,0,1-1.125.131,2.815,2.815,0,0,1-2.033-.706,2.576,2.576,0,0,1-.735-1.95,2.556,2.556,0,0,1,.741-1.912,2.83,2.83,0,0,1,2.068-.727,4.875,4.875,0,0,1,.957.091,4.256,4.256,0,0,1,1.012.36v1.193h-.146q-.1-.072-.281-.2a3.41,3.41,0,0,0-.355-.224,2.318,2.318,0,0,0-.463-.188,1.965,1.965,0,0,0-.562-.079,1.844,1.844,0,0,0-.632.1,1.471,1.471,0,0,0-.509.314,1.406,1.406,0,0,0-.34.521,1.959,1.959,0,0,0-.125.729,1.747,1.747,0,0,0,.447,1.292,1.794,1.794,0,0,0,1.322.448c.051,0,.105,0,.166,0s.115-.006.166-.01v-1H17.787v-.96h2.349Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19ZM2,17H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.151,5.406,16.654,3.4a.879.879,0,0,1-.081-.073C16.265,3.013,16.175,3,16,3H5V5H3V3A1.979,1.979,0,0,1,5,1H16a2.609,2.609,0,0,1,1.949.87l2.457,1.978Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.857,24H5.143A2.077,2.077,0,0,1,3,22V20H5v2c0-.042.07,0,.143,0H17.857a.234.234,0,0,0,.159-.063L18,20h2v2A2.077,2.077,0,0,1,17.857,24Z",
    fill: "currentColor"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-pptx",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-pptx icon"), /*#__PURE__*/React.createElement("path", {
    d: "M8.789,11.395a1.944,1.944,0,0,1-.119.668,1.5,1.5,0,0,1-.342.548,2.09,2.09,0,0,1-.68.455,2.449,2.449,0,0,1-.931.154H5.9v1.658H4.588V9.788h2.16a3.409,3.409,0,0,1,.818.083,1.918,1.918,0,0,1,.59.251,1.355,1.355,0,0,1,.471.516A1.638,1.638,0,0,1,8.789,11.395Zm-1.357.029a.6.6,0,0,0-.115-.37.631.631,0,0,0-.271-.216,1.226,1.226,0,0,0-.4-.091c-.131-.005-.3-.008-.52-.008H5.9v1.521h.377a3.048,3.048,0,0,0,.551-.041.785.785,0,0,0,.365-.164.626.626,0,0,0,.182-.261A1.033,1.033,0,0,0,7.432,11.424Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.34,11.395a1.945,1.945,0,0,1-.12.668,1.486,1.486,0,0,1-.342.548,2.076,2.076,0,0,1-.679.455,2.458,2.458,0,0,1-.932.154h-.816v1.658H10.139V9.788H12.3a3.415,3.415,0,0,1,.818.083,1.928,1.928,0,0,1,.59.251,1.352,1.352,0,0,1,.47.516A1.626,1.626,0,0,1,14.34,11.395Zm-1.357.029a.6.6,0,0,0-.116-.37.62.62,0,0,0-.271-.216,1.221,1.221,0,0,0-.4-.091c-.13-.005-.3-.008-.52-.008h-.226v1.521h.376a3.053,3.053,0,0,0,.552-.041.786.786,0,0,0,.364-.164.62.62,0,0,0,.183-.261A1.056,1.056,0,0,0,12.982,11.424Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.671,10.772H18.082v4.1H16.77v-4.1H15.18V9.788h4.491Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19ZM2,17H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.151,5.406,16.654,3.4a.879.879,0,0,1-.081-.073C16.265,3.013,16.175,3,16,3H5V5H3V3A1.979,1.979,0,0,1,5,1H16a2.609,2.609,0,0,1,1.949.87l2.457,1.978Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.857,24H5.143A2.077,2.077,0,0,1,3,22V20H5v2c0-.042.07,0,.143,0H17.857a.234.234,0,0,0,.159-.063L18,20h2v2A2.077,2.077,0,0,1,17.857,24Z",
    fill: "currentColor"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-spreadsheet",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-spreadsheet icon"), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 13,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 13,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 13,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,24H4.125A2.115,2.115,0,0,1,2,21.9V2.1A2.115,2.115,0,0,1,4.125,0H14.443a3.258,3.258,0,0,1,2.29.929L21.04,5.141A3.2,3.2,0,0,1,22,7.411V21.9A2.115,2.115,0,0,1,19.875,24ZM4.125,2A.116.116,0,0,0,4,2.1V21.9a.116.116,0,0,0,.125.1h15.75A.116.116,0,0,0,20,21.9V7.411a1.167,1.167,0,0,0-.358-.84h0L15.335,2.359A1.287,1.287,0,0,0,14.443,2Z",
    fill: "currentColor"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-video",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-video icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9.648,17.077a1.881,1.881,0,0,1-.947-.249A1.368,1.368,0,0,1,8,15.651v-6.3a1.368,1.368,0,0,1,.7-1.177,1.881,1.881,0,0,1,1.784-.047l5.429,3.067a1.5,1.5,0,0,1-.006,2.619l-5.416,3.059A1.748,1.748,0,0,1,9.648,17.077ZM10,10.148v4.7L14.163,12.5Zm4.931,2.786.006,0Zm0-.868-.006,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,24H4.125A2.115,2.115,0,0,1,2,21.9V2.1A2.115,2.115,0,0,1,4.125,0H14.443a3.258,3.258,0,0,1,2.29.929L21.04,5.141A3.2,3.2,0,0,1,22,7.411V21.9A2.115,2.115,0,0,1,19.875,24ZM4.125,2A.116.116,0,0,0,4,2.1V21.9a.116.116,0,0,0,.125.1h15.75A.116.116,0,0,0,20,21.9V7.411a1.167,1.167,0,0,0-.358-.84h0L15.335,2.359A1.287,1.287,0,0,0,14.443,2Z",
    fill: "currentColor"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-xlsx",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "file-xlsx icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9.329,14.877H7.81l-1.095-1.67L5.6,14.877H4.147l1.8-2.564L4.186,9.788H5.7l1.059,1.584L7.848,9.788H9.3L7.525,12.26Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.151,14.877H10.48V9.788h1.313v4.1h2.358Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.436,13.278A1.45,1.45,0,0,1,18.8,14.5a2.854,2.854,0,0,1-1.73.47,4.839,4.839,0,0,1-1.1-.111,5.69,5.69,0,0,1-.881-.282v-1.22h.144a3.04,3.04,0,0,0,.911.5,2.956,2.956,0,0,0,.969.174,3.138,3.138,0,0,0,.314-.021,1.268,1.268,0,0,0,.318-.068.818.818,0,0,0,.248-.154.361.361,0,0,0,.1-.273.37.37,0,0,0-.142-.289.988.988,0,0,0-.416-.187c-.191-.045-.393-.088-.605-.128a4.647,4.647,0,0,1-.6-.152,1.884,1.884,0,0,1-.925-.565,1.391,1.391,0,0,1-.281-.887,1.365,1.365,0,0,1,.637-1.161A2.785,2.785,0,0,1,17.391,9.7a5.061,5.061,0,0,1,.994.1,4.6,4.6,0,0,1,.849.244V11.21h-.14a2.71,2.71,0,0,0-.754-.412,2.589,2.589,0,0,0-.911-.166,2.376,2.376,0,0,0-.327.022,1.286,1.286,0,0,0-.312.083.606.606,0,0,0-.229.156.338.338,0,0,0-.1.237.354.354,0,0,0,.154.31,1.721,1.721,0,0,0,.58.2l.539.113a5.57,5.57,0,0,1,.555.15,1.851,1.851,0,0,1,.863.521A1.284,1.284,0,0,1,19.436,13.278Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19ZM2,17H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.151,5.406,16.654,3.4a.879.879,0,0,1-.081-.073C16.265,3.013,16.175,3,16,3H5V5H3V3A1.979,1.979,0,0,1,5,1H16a2.609,2.609,0,0,1,1.949.87l2.457,1.978Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.857,24H5.143A2.077,2.077,0,0,1,3,22V20H5v2c0-.042.07,0,.143,0H17.857a.234.234,0,0,0,.159-.063L18,20h2v2A2.077,2.077,0,0,1,17.857,24Z",
    fill: "currentColor"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "filmstrip",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "filmstrip icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23,24H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H23a1,1,0,0,1,1,1V23A1,1,0,0,1,23,24ZM2,22H22V2H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 3,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 7,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,21H15V15H9v6H7V14a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,11H8a1,1,0,0,1-1-1V3H9V9h6V3h2v7A1,1,0,0,1,16,11Z",
    fill: "currentColor"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "filter icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9,24a1,1,0,0,1-1-1V16.651L2.9,11.719A3.026,3.026,0,0,1,2,9.581V2A2,2,0,0,1,4,0H19a2,2,0,0,1,2,2V9.581a3.02,3.02,0,0,1-.886,2.128l-5.178,5.009L15,21a1,1,0,0,1-.628.929l-5,2A1,1,0,0,1,9,24ZM4,2V9.581a.991.991,0,0,0,.3.709l5.159,4.991A2.047,2.047,0,0,1,10,16.651v4.872l3-1.2V16.651a2,2,0,0,1,.481-1.3l5.232-5.068a1,1,0,0,0,.286-.7V2H4ZM14,21h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.586,
    width: 2,
    height: 4.828,
    transform: "translate(-4.728 8.586) rotate(-45)",
    fill: "currentColor"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag-simple-fill",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "flag-simple-fill icon"), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 2,
    height: 21,
    rx: 1,
    ry: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,24a2,2,0,0,1-2-2V3A2,2,0,0,1,7,3V22A2,2,0,0,1,5,24ZM5,3,5,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9 3 20 3 17 8.5 20 14 9 14 9 3",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,15H9a1,1,0,0,1-1-1V3A1,1,0,0,1,9,2H20a1,1,0,0,1,.878,1.479L18.139,8.5l2.739,5.021A1,1,0,0,1,20,15ZM10,13h8.315L16.122,8.979a1,1,0,0,1,0-.957L18.315,4H10Z",
    fill: "currentColor"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag-simple",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "flag-simple icon"), /*#__PURE__*/React.createElement("path", {
    d: "M6,24H5a2,2,0,0,1-2-2V3A2,2,0,0,1,5,1H6A2,2,0,0,1,8,3V22A2,2,0,0,1,6,24ZM5,3V22H6V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16H9V14h9.131L15.168,9.555a1,1,0,0,1,0-1.109L18.131,4H9V2H20a1,1,0,0,1,.832,1.555L17.2,9l3.63,5.445A1,1,0,0,1,20,16Z",
    fill: "currentColor"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "flag icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16,13H3V11H15V2H3V0H16a1,1,0,0,1,1,1V12A1,1,0,0,1,16,13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,18H13V16h9V6H17V4h6a1,1,0,0,1,1,1V17A1,1,0,0,1,23,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,18a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h8a1,1,0,0,1,.53,1.848l-8,5A1,1,0,0,1,8,18Zm1-5v2.2L12.513,13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 24,
    fill: "currentColor"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    id: "flask",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "flask icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,24H4a2.474,2.474,0,0,1-2.357-1.374,3.09,3.09,0,0,1,.583-3.26L8,13.586V6H7A1,1,0,0,1,6,5V1A1,1,0,0,1,7,0H17a1,1,0,0,1,1,1V5a1,1,0,0,1-1,1H13V4h3V2H8V4H9a1,1,0,0,1,1,1v9a1,1,0,0,1-.293.707l-6,6A1.128,1.128,0,0,0,3.45,21.77c.072.153.257.23.55.23H20c.293,0,.478-.077.55-.23a1.188,1.188,0,0,0-.324-1.137l-5.933-5.926A1,1,0,0,1,14,14V9H12V7h3a1,1,0,0,1,1,1v5.586l5.707,5.707a3.132,3.132,0,0,1,.65,3.333A2.474,2.474,0,0,1,20,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 3.5,
    height: 2,
    fill: "currentColor"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder-open",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "folder-open icon"), /*#__PURE__*/React.createElement("path", {
    d: "M3,16H1V3.969A1.971,1.971,0,0,1,2.969,2H8.936a2.931,2.931,0,0,1,1.659.513l1.932,1.323A.933.933,0,0,0,13.057,4h5.975A1.971,1.971,0,0,1,21,5.969V8H19V5.969L13.057,6A2.925,2.925,0,0,1,11.4,5.486L9.466,4.164A.934.934,0,0,0,8.936,4H2.969Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.634,22H3.981a2.017,2.017,0,0,1-1.912-2.662l3.383-9.025A2.025,2.025,0,0,1,7.342,9H21.975a2.017,2.017,0,0,1,1.892,2.718l-3.331,8.937A2,2,0,0,1,18.634,22ZM7.342,11,3.953,20.009,18.634,20a.017.017,0,0,0,.016-.012l3.341-8.967Z",
    fill: "currentColor"
  }))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder-shared",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "folder-shared icon"), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13a2,2,0,1,1,2-2A2,2,0,0,1,12,13Zm0-2h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,13a2,2,0,1,1,2-2A2,2,0,0,1,7,13Zm0-2H7Zm0,0H7Zm0,0H7Zm0,0H7Zm0,0H7Zm0,0H7Zm0,0H7Zm0,0H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,13a2,2,0,1,1,2-2A2,2,0,0,1,17,13Zm0-2h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.889,21H2.1A2.1,2.1,0,0,1,0,18.9V2.111A2.114,2.114,0,0,1,2.111,0H7.535A3.572,3.572,0,0,1,9.35.566L11.3,1.919A9.7,9.7,0,0,0,12.943,2H20.9a2.005,2.005,0,0,1,2.047,2.053v1h-2v-1L12.943,4a5.1,5.1,0,0,1-2.778-.437L8.212,2.211A1.646,1.646,0,0,0,7.535,2H2.111A.115.115,0,0,0,2,2.111V18.9a.1.1,0,0,0,.1.1H21.889A.115.115,0,0,0,22,18.889V8.1a.1.1,0,0,0-.1-.1H3V6H21.9A2.1,2.1,0,0,1,24,8.1V18.889A2.114,2.114,0,0,1,21.889,21Z",
    fill: "currentColor"
  }))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "folder icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21.889,21H2.1A2.1,2.1,0,0,1,0,18.9V2.111A2.114,2.114,0,0,1,2.111,0H7.535A3.572,3.572,0,0,1,9.35.566L11.3,1.919A9.7,9.7,0,0,0,12.943,2H20.9a2.005,2.005,0,0,1,2.047,2.053v1h-2v-1L12.943,4a5.1,5.1,0,0,1-2.778-.437L8.212,2.211A1.646,1.646,0,0,0,7.535,2H2.111A.115.115,0,0,0,2,2.111V18.9a.1.1,0,0,0,.1.1H21.889A.115.115,0,0,0,22,18.889V8.1a.1.1,0,0,0-.1-.1H3V6H21.9A2.1,2.1,0,0,1,24,8.1V18.889A2.114,2.114,0,0,1,21.889,21Z",
    fill: "currentColor"
  }))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    id: "fpso",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "fpso icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5,21.7c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C17.2,22,17.2,22,17,22c-0.1,0-0.3-0.2-0.5-0.3 c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C12.2,22,12.2,22,12,22c-0.1,0-0.3-0.2-0.5-0.3c-0.5-0.3-1.2-0.7-2.2-0.7 c-1,0-1.6,0.5-1.9,0.8C7.2,22,7.2,22,7,22c-0.1,0-0.3-0.2-0.5-0.3C6.1,21.4,5.4,21,4.4,21c-1,0-1.6,0.5-1.9,0.8C2.2,22,2.2,22,2,22 H1v2h1c0.9,0,1.4-0.4,1.7-0.7C4,23.1,4.1,23,4.4,23c0.4,0,0.7,0.2,1.1,0.4C5.9,23.7,6.4,24,7,24c0.9,0,1.4-0.4,1.7-0.7 C9,23.1,9.1,23,9.4,23c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3 c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3c0.4,0,0.7,0.2,1.1,0.4 c0.4,0.3,0.9,0.6,1.5,0.6h1l0-2h-1C21.9,22,21.7,21.8,21.5,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.9,13.6C23.8,13.2,23.4,13,23,13h-4V9.3l4.4-3.1l-1.1-1.6L17.4,8C17.2,8.2,17,8.5,17,8.8V13h-1L15,0.9 C15,0.4,14.5,0,14,0h-3c-0.5,0-1,0.4-1,0.9L9.7,5l0,0l0,0L9,13H8.8L8,12.5V8c0-0.6-0.4-1-1-1H2C1.4,7,1,7.4,1,8v4c-0.6,0-1,0.4-1,1 c0,0.2,0,4.4,1.7,6.6l0.6,0.8l1.6-1.2l-0.6-0.8C2.5,17.3,2.2,15.3,2,14h4.6l1.2,0.8C8.1,14.9,8.3,15,8.5,15h12.3 c-0.9,1.1-1.8,2.7-1.8,4v1h2v-1c0-1.1,1.6-3.2,2.7-4.3C24,14.4,24.1,14,23.9,13.6z M3,9h3v3H3V9z M13.1,2l0.5,6l-1.9-3.4L11.9,2 H13.1z M11.4,8.2l2.6,4.8l0,0.1h-3L11.4,8.2z"
  })))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    id: "gas-pump",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "gas-pump icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17,4h-6c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1V5C18,4.4,17.6,4,17,4z M16,8h-4V6h4V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21,22V3.3C21,1.5,19.3,0,17.3,0h-6.5C8.7,0,7,1.5,7,3.3V22H6v2h16v-2H21z M9,3.3C9,2.6,9.8,2,10.7,2h6.5 C18.2,2,19,2.6,19,3.3V22H9V3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6,14.1H5c-1.1,0-2-0.7-2-1.6c0.2-2.5,0.3-5.1,0.6-7c0-0.3,0.2-0.3,0.2-0.4C3.9,5,4.2,5,4.6,5.2l0.9,0.4 l0.8-1.8L5.4,3.4C4.5,3,3.6,3,2.8,3.4c-0.7,0.4-1.1,1-1.2,1.8c-0.3,2-0.5,4.6-0.6,7.2c0,2,1.8,3.7,4,3.7h1V14.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    fill: "currentColor",
    width: 6,
    height: 2
  })))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    id: "gasoline-bottle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "gasoline-bottle icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.7,9.7l-1.4-1.4L12.6,10H8.4L6.7,8.3L5.3,9.7L7,11.4v4.1l-1.7,1.7l1.4,1.4L8.3,17h4.3l1.7,1.7l1.4-1.4L14,15.6v-4.2 L15.7,9.7z M12,15H9v-3h3V15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20,8.8c-0.1-0.1-0.2-0.1-0.2-0.2l-5.1-5.2c-0.1-0.1-0.2-0.1-0.3-0.2l-2.5-2.8C11.8,0.1,11.5,0,11.2,0H4.8 C4.7,0,4.6,0,4.6,0H2.5C1.1,0,0,1.2,0,2.5v19C0,22.9,1.1,24,2.5,24h16c1.4,0,2.5-1.1,2.5-2.5v-11C21,9.7,20.4,9.1,20,8.8z M11.7,3 H7.5L6.8,2h3.9L11.7,3z M19,21.5c0,0.3-0.2,0.5-0.5,0.5h-16C2.2,22,2,21.8,2,21.5v-19C2,2.3,2.2,2,2.5,2h2l1.7,2.6 C6.4,4.9,6.7,5,7,5h6.6l4.8,4.9c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.3,0.3,0.3V21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.7,4.5l-4.2-4.2c-0.4-0.4-1-0.4-1.4,0l-1.8,1.8c-0.4,0.4-0.4,1,0,1.4l4.2,4.2C20.7,7.9,21,8,21.2,8s0.5-0.1,0.7-0.3 L23.7,6C24.1,5.6,24.1,4.9,23.7,4.5z M21.2,5.6l-2.8-2.8l0.4-0.4l2.8,2.8L21.2,5.6z"
  })))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    id: "gauge",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "gauge icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,24A11.5,11.5,0,1,1,24,12.5,11.513,11.513,0,0,1,12.5,24Zm0-21A9.5,9.5,0,1,0,22,12.5,9.511,9.511,0,0,0,12.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 6.068,
    width: 2,
    height: 8.364,
    transform: "translate(-4.246 10.25) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,18A5.507,5.507,0,0,1,7,12.5v-1H9v1A3.5,3.5,0,1,0,12.5,9h-1V7h1a5.5,5.5,0,0,1,0,11Z",
    fill: "currentColor"
  }))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    id: "gavel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "gavel icon"), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 19.379,
    width: 2,
    height: 4.243,
    transform: "translate(-14.471 8.065) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.379,
    y: 20.5,
    width: 4.243,
    height: 2,
    transform: "translate(-11.835 14.429) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,23a1,1,0,0,1-.707-.293L12.586,16,14,14.586l6,6L20.586,20l-6-6L16,12.586l6.707,6.707a1,1,0,0,1,0,1.414l-2,2A1,1,0,0,1,20,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,18.589a3.115,3.115,0,0,1-2.207-.882l-3.019-3a3.2,3.2,0,0,1,.019-4.417l9-9a3.2,3.2,0,0,1,4.414-.021l3,3.024a3.2,3.2,0,0,1,0,4.412l-9,9A3.115,3.115,0,0,1,6.5,18.589ZM12.522,2.4a1.162,1.162,0,0,0-.815.305l-9,9a1.215,1.215,0,0,0-.021,1.586l3.019,3a1.214,1.214,0,0,0,1.588,0l9-9a1.215,1.215,0,0,0,0-1.586l-3-3.023A1.088,1.088,0,0,0,12.522,2.4Z",
    fill: "currentColor"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    id: "gift",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "gift icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23,12H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6H23a1,1,0,0,1,1,1v4A1,1,0,0,1,23,12ZM2,10H22V8H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,24H4c-1.907,0-2-.9-2-2.5v-10H4v10c0,.173,0,.349,0,.5H20V12h2V22A2,2,0,0,1,20,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 2,
    height: 5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6.5,
    width: 2,
    height: 5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11.5,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11.5,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.293,7.707c-1.332-1.332-2.522-3.892-1-5.414a3.085,3.085,0,0,1,3.358-.666,7.234,7.234,0,0,1,4.342,5.257l-1.986.23a5.318,5.318,0,0,0-3.013-3.6,1.105,1.105,0,0,0-1.287.19c-.378.378.146,1.731,1,2.586Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.707,7.707,18.293,6.293a2.105,2.105,0,0,0,.25-2.586c-.122-.122-.49-.491-1.4-.175a5.433,5.433,0,0,0-3.154,3.583l-1.986-.23A7.331,7.331,0,0,1,16.49,1.644a3.182,3.182,0,0,1,3.467.649C21.411,3.747,21.017,6.4,19.707,7.707Z",
    fill: "currentColor"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    id: "globe",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "globe icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.091,
    y: 11,
    width: 17.818,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3.091,
    width: 2,
    height: 17.818,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.553,21.342,6.105,18.447a1.075,1.075,0,0,1-.067-.173,20.181,20.181,0,0,1,0-11.549,1.075,1.075,0,0,1,.067-.173L7.553,3.658l1.789.895L7.937,7.363a18.239,18.239,0,0,0,0,10.273l1.405,2.811Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.447,21.342l-1.789-.895,1.405-2.811a18.239,18.239,0,0,0,0-10.273L14.658,4.553l1.789-.895,1.447,2.895a1.075,1.075,0,0,1,.067.173,20.181,20.181,0,0,1,0,11.549,1.075,1.075,0,0,1-.067.173Z",
    fill: "currentColor"
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    id: "graduation-hat",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "graduation-hat icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,16a1,1,0,0,1-.537-.156l-11-7a1,1,0,0,1,0-1.687l11-7a1,1,0,0,1,1.074,0l11,7a1,1,0,0,1,0,1.688l-11,7A1,1,0,0,1,12,16ZM2.862,8,12,13.814,21.138,8,12,2.186Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,23c-3.6,0-7-2.43-7-5V13H6v5c0,1.31,2.425,3,5,3h2a4.914,4.914,0,0,0,2.649-1.05A2.9,2.9,0,0,0,17,18V14h2v4a4.7,4.7,0,0,1-2.15,3.55A6.8,6.8,0,0,1,13,23H11Z",
    fill: "currentColor"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    id: "group",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "group icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,17A4.5,4.5,0,1,1,17,12.5,4.5,4.5,0,0,1,12.5,17Zm0-7A2.5,2.5,0,1,0,15,12.5,2.5,2.5,0,0,0,12.5,10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,9a4,4,0,1,1,4-4A4,4,0,0,1,18,9Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,18,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,16H18V14h4V12c0-.521-.115-.65-.725-1.25L21.94,10l.707-.707.023.023A3.385,3.385,0,0,1,24,12v3A1,1,0,0,1,23,16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9a4,4,0,1,1,4-4A4,4,0,0,1,6,9ZM6,3A2,2,0,1,0,8,5,2,2,0,0,0,6,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,16H1a1,1,0,0,1-1-1V12A3.377,3.377,0,0,1,1.369,9.277l.723-.691,1.382,1.446-.724.691c-.631.6-.75.734-.75,1.277v2H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,24H6a1,1,0,0,1-1-1V22a6.177,6.177,0,0,1,3.6-5.9l.9-.44.88,1.8-.9.44A4.14,4.14,0,0,0,7,22H18a6.836,6.836,0,0,0-2.118-4H14.96V16h1C17.819,16,20,19.966,20,22v1A1,1,0,0,1,19,24Zm-3.153-6.016Z",
    fill: "currentColor"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    id: "hamburger",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "hamburger icon"), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 23,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 23,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 23,
    height: 2,
    fill: "currentColor"
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    id: "hardware",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "hardware icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,23H2c-1.221,0-2-1.48-2-2.5v-10A1.452,1.452,0,0,1,.414,9.432,1.917,1.917,0,0,1,1.875,9H22a2,2,0,0,1,2,2V21A2,2,0,0,1,22,23ZM2.185,21H22V11H2v9.5A1.19,1.19,0,0,0,2.185,21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 18,
    width: 10,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 18,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,7H11V4a3.918,3.918,0,0,1,4-4h3V2H15a1.928,1.928,0,0,0-2,2Z",
    fill: "currentColor"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    id: "headphones",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "headphones icon"), /*#__PURE__*/React.createElement("path", {
    d: "M7,21H3a3,3,0,0,1-3-3V14a3,3,0,0,1,3-3H7a1,1,0,0,1,1,1v8A1,1,0,0,1,7,21ZM3,13a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H6V13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,21H17a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h4a3,3,0,0,1,3,3v4A3,3,0,0,1,21,21Zm-3-2h3a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,10h-2V9a7.008,7.008,0,0,0-7-7h-1a7.008,7.008,0,0,0-7,7v1h-2V9a9.01,9.01,0,0,1,9-9h1a9.01,9.01,0,0,1,9,9Z",
    fill: "currentColor"
  }))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    id: "headset",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "headset icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18,24H11V22h7a1,1,0,0,0,1-1V19h2v2A3,3,0,0,1,18,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,21H3a3,3,0,0,1-3-3V14a3,3,0,0,1,3-3H7a1,1,0,0,1,1,1v8A1,1,0,0,1,7,21ZM3,13a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H6V13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,21H17a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h4a3,3,0,0,1,3,3v4A3,3,0,0,1,21,21Zm-3-2h3a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,10h-2V9a7.008,7.008,0,0,0-7-7h-1a7.008,7.008,0,0,0-7,7v1h-2V9a9.01,9.01,0,0,1,9-9h1a9.01,9.01,0,0,1,9,9Z",
    fill: "currentColor"
  }))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-broken",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "heart-broken icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,24a1,1,0,0,1-.606-.2C10.949,23.457.5,15.421.5,9,.5,5.523,3.233,3,7,3A4.408,4.408,0,0,1,9.706,4.292L10.414,5,9,6.414l-.707-.7A2.491,2.491,0,0,0,7,5C4.351,5,2.5,6.645,2.5,9c0,4.22,6.371,10.215,9.5,12.729C15.128,19.213,21.5,13.215,21.5,9c0-2.355-1.851-4-4.5-4a4.407,4.407,0,0,0-3.761,1.825l1.468,1.468a1,1,0,0,1-.152,1.539L12.8,11l1.752,1.168a1,1,0,0,1,0,1.664l-1.985,1.323L14.414,17,13,18.414l-2.707-2.707a1,1,0,0,1,.152-1.539L12.2,13l-1.752-1.168a1,1,0,0,1,0-1.664l1.985-1.323L11.293,7.707a1,1,0,0,1-.2-1.12A6.32,6.32,0,0,1,17,3c3.767,0,6.5,2.523,6.5,6,0,6.421-10.449,14.457-10.894,14.8A1,1,0,0,1,12,24Z",
    fill: "currentColor"
  }))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-fill",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "heart-fill icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,8c0,6.5-10,14-10,14S2,14.5,2,8A4.683,4.683,0,0,1,7,3a5.291,5.291,0,0,1,5,3,5.291,5.291,0,0,1,5-3A4.683,4.683,0,0,1,22,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23a1,1,0,0,1-.6-.2C10.976,22.481,1,14.92,1,8A5.68,5.68,0,0,1,7,2a6.54,6.54,0,0,1,5,2.166A6.54,6.54,0,0,1,17,2a5.68,5.68,0,0,1,6,6c0,6.92-9.976,14.481-10.4,14.8A1,1,0,0,1,12,23ZM7,4A3.675,3.675,0,0,0,3,8c0,5.046,6.9,11.022,9,12.726,2.1-1.7,9-7.68,9-12.726a3.675,3.675,0,0,0-4-4,4.292,4.292,0,0,0-4.089,2.413,1,1,0,0,1-1.822,0A4.292,4.292,0,0,0,7,4Z",
    fill: "currentColor"
  }))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "heart-line icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,23a1,1,0,0,1-.6-.2C10.976,22.481,1,14.92,1,8A5.68,5.68,0,0,1,7,2a6.54,6.54,0,0,1,5,2.166A6.54,6.54,0,0,1,17,2a5.68,5.68,0,0,1,6,6c0,6.92-9.976,14.481-10.4,14.8A1,1,0,0,1,12,23ZM7,4A3.675,3.675,0,0,0,3,8c0,5.046,6.9,11.022,9,12.726,2.1-1.7,9-7.68,9-12.726a3.675,3.675,0,0,0-4-4,4.292,4.292,0,0,0-4.089,2.413,1,1,0,0,1-1.822,0A4.292,4.292,0,0,0,7,4Z",
    fill: "currentColor"
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "home icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.941,24H5.059A2.082,2.082,0,0,1,3,21.9V11H5V21.9c0,.066.041.1.059.1H18.941c.018,0,.059-.034.059-.1V11h2V21.9A2.082,2.082,0,0,1,18.941,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.614,10.79.386,9.21,9.342,2.245a4.04,4.04,0,0,1,5.365.048l7.952,6.955-1.317,1.5-8-7a2.08,2.08,0,0,0-2.634-.045,1.072,1.072,0,0,1-.093.083Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,20H14V13H10v7H8V12a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    id: "inbox",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "inbox icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21.215,12.177,20.02,6.2a.337.337,0,0,0-.11-.214L15,6V4h5a2.124,2.124,0,0,1,1.99,1.859l1.187,5.926Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23H3a2,2,0,0,1-2-2V14a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1v2h6V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v7A2,2,0,0,1,21,23ZM3,15v6H21V15H17v2a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12.748c-.506,0-1.013-.347-1.707-1.041L7.586,9,9,7.586l2.707,2.707c.1.1.2.2.293.29.092-.089.2-.192.293-.29L15,7.586,16.414,9l-2.707,2.707C13.013,12.4,12.506,12.748,12,12.748Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.785,12.177.823,11.785,2.02,5.8A2.106,2.106,0,0,1,4,4H9V6H4c.055,0,0,.087-.01.141Z",
    fill: "currentColor"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    id: "info",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "info icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,22A10,10,0,0,1,4.929,4.929,10,10,0,1,1,19.071,19.071h0A9.933,9.933,0,0,1,12,22ZM12,4a8,8,0,1,0,5.657,13.657h0A8,8,0,0,0,12,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,17H12a1,1,0,0,1-1-1V12H10V10h2a1,1,0,0,1,1,1v4h1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    id: "leaf",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "leaf icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.338,19.545A6.345,6.345,0,0,1,8.564,18.9l.871-1.8a4.616,4.616,0,0,0,5.423-1.138C17.911,12.91,19.313,6.828,19.8,4.168c-2.709.417-8.962,1.674-12.01,4.723a5.25,5.25,0,0,0-.939,5.687l-1.826.816A7.314,7.314,0,0,1,6.374,7.477C10.818,3.032,20.493,2.044,20.9,2a.988.988,0,0,1,.813.3,1,1,0,0,1,.275.822c-.051.4-1.285,9.817-5.72,14.25A6.991,6.991,0,0,1,11.338,19.545Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.278,
    y: 14.5,
    width: 17.556,
    height: 2,
    transform: "translate(-8.471 10.55) rotate(-45)",
    fill: "currentColor"
  }))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    id: "life-saver-float",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "life-saver-float icon"), /*#__PURE__*/React.createElement("path", {
    d: "M4,8H2C2,5.42,5.42,2,8,2V4C6.542,4,4,6.542,4,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,8H20c0-1.458-2.542-4-4-4V2C18.58,2,22,5.42,22,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,22c-2.58,0-6-3.42-6-6H4c0,1.458,2.542,4,4,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,22V20c1.458,0,4-2.542,4-4h2C22,18.58,18.58,22,16,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18a6,6,0,1,1,6-6A6.007,6.007,0,0,1,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,8H13V2H11V8H9V1a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,24H10a1,1,0,0,1-1-1V16h2v6h2V16h2v7A1,1,0,0,1,14,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,15H16V13h6V11H16V9h7a1,1,0,0,1,1,1v4A1,1,0,0,1,23,15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.739,15H1a1,1,0,0,1-1-1V10A1,1,0,0,1,1,9H6.739v2H2v2H6.739Z",
    fill: "currentColor"
  }))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    id: "light-bulb",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "light-bulb icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15.353,18.118h-2v-1.29a1,1,0,0,1,.7-.955,7,7,0,1,0-4.111,0,1,1,0,0,1,.7.955v1.29h-2v-.584a9,9,0,1,1,6.705,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,24H9a1,1,0,0,1-1-1V20a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v3A1,1,0,0,1,15,24Zm-5-2h4V21H10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11H7V10a5.868,5.868,0,0,1,6-6h1V6H13a3.869,3.869,0,0,0-4,4Z",
    fill: "currentColor"
  }))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-broken",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "link-broken icon"), /*#__PURE__*/React.createElement("rect", {
    x: 5.586,
    y: 20,
    width: 4.828,
    height: 2,
    transform: "translate(-12.506 11.808) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18.586,
    width: 2,
    height: 4.828,
    transform: "translate(-10.163 17.464) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.586,
    y: 2,
    width: 4.828,
    height: 2,
    transform: "translate(2.565 12.192) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 0.586,
    width: 2,
    height: 4.828,
    transform: "translate(0.222 6.536) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 12,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,18H1a1,1,0,0,1-1-1V7A1,1,0,0,1,1,6h9a1,1,0,0,1,1,1v3H9V8H2v8H9V14h2v3A1,1,0,0,1,10,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,18H14a1,1,0,0,1-1-1V14h2v2h7V8H15v2H13V7a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1V17A1,1,0,0,1,23,18Z",
    fill: "currentColor"
  }))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-external",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "link-external icon"), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,22H2.1A2.1,2.1,0,0,1,0,19.9V4.1A2.1,2.1,0,0,1,2.1,2H14.6c1.592,0,2.4.673,2.4,2V8H15V4.013C14.879,4,14.707,4,14.6,4H2.1a.1.1,0,0,0-.1.1V19.9a.1.1,0,0,0,.1.1H14.6c.106,0,.279,0,.4-.013V16h2v4C17,21.327,16.192,22,14.6,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.056,
    y: 11,
    width: 12,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,17.414,17.586,16l3.707-3.707c.112-.112.281-.281-.013-.6L17.586,8,19,6.586l3.707,3.707a2.346,2.346,0,0,1,0,3.414Z",
    fill: "currentColor"
  }))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    id: "link",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "link icon"), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 12,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,19H1a1,1,0,0,1-1-1V8A1,1,0,0,1,1,7h9a1,1,0,0,1,1,1v3H9V9H2v8H9V15h2v3A1,1,0,0,1,10,19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H14a1,1,0,0,1-1-1V15h2v2h7V9H15v2H13V8a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19Z",
    fill: "currentColor"
  }))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    id: "list",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "list icon"), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 15,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 15,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 15,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,21a2,2,0,1,1,2-2A2,2,0,0,1,4,21Zm0-2H4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,14a2,2,0,1,1,2-2A2,2,0,0,1,4,14Zm0-2H4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,7A2,2,0,1,1,6,5,2,2,0,0,1,4,7ZM4,5H4Z",
    fill: "currentColor"
  }))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    id: "lng-vessel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "lng-vessel icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23,11L23,11c0.6-1,1-2.3,1-3.5C24,4.4,22.3,2,20.2,2h-7.4C10.6,2,9,4.3,9,7.4v0.1C9,8.8,9.4,10,10.1,11 H8.8L8,10.5V6c0-0.6-0.4-1-1-1H2C1.4,5,1,5.4,1,6v4c-0.6,0-1,0.4-1,1c0,0.2,0,4.4,1.7,6.6l0.6,0.8l1.6-1.2l-0.6-0.8 C2.5,15.3,2.2,13.3,2,12h4.6l1.2,0.8C8.1,12.9,8.3,13,8.5,13h12.3c-0.9,1.1-1.8,2.7-1.8,4v1h2v-1c0-1.1,1.6-3.2,2.7-4.3 c0.3-0.3,0.4-0.7,0.2-1.1C23.8,11.2,23.4,11,23,11z M3,7h3v3H3V7z M12,10.3c-0.5-0.5-1-1.3-1-2.8V7.4c0-2,0.9-3.4,1.8-3.4h7.4 C21,4,22,5.5,22,7.5c0,1-0.4,2.1-1.1,2.9L20.4,11h-7.7L12,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5,19.7c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C17.2,20,17.2,20,17,20c-0.1,0-0.3-0.2-0.5-0.3 c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C12.2,20,12.2,20,12,20c-0.1,0-0.3-0.2-0.5-0.3c-0.5-0.3-1.2-0.7-2.2-0.7 c-1,0-1.6,0.5-1.9,0.8C7.2,20,7.2,20,7,20c-0.1,0-0.3-0.2-0.5-0.3C6.1,19.4,5.4,19,4.4,19c-1,0-1.6,0.5-1.9,0.8C2.2,20,2.2,20,2,20 H1v2h1c0.9,0,1.4-0.4,1.7-0.7C4,21.1,4.1,21,4.4,21c0.4,0,0.7,0.2,1.1,0.4C5.9,21.7,6.4,22,7,22c0.9,0,1.4-0.4,1.7-0.7 C9,21.1,9.1,21,9.4,21c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3 c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3c0.4,0,0.7,0.2,1.1,0.4 c0.4,0.3,0.9,0.6,1.5,0.6h1l0-2h-1C21.9,20,21.7,19.8,21.5,19.7z"
  })))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    id: "location-arrow",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "location-arrow icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,24a1,1,0,0,1-.636-.228c-.367-.3-9-7.489-9-14.413C2.359,4.516,6.414,1,12,1s9.641,3.516,9.641,8.359c0,6.924-8.638,14.11-9,14.413A1,1,0,0,1,12,24ZM12,3C7.572,3,4.359,5.674,4.359,9.359c0,4.988,5.7,10.562,7.641,12.313,1.938-1.75,7.641-7.324,7.641-12.312C19.641,5.674,16.428,3,12,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,14a4,4,0,1,1,4-4A4,4,0,0,1,12,14Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,12,8Z",
    fill: "currentColor"
  }))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock-unlock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "lock-unlock icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,23H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H20a2,2,0,0,1,2,2V21A2,2,0,0,1,20,23ZM4,11V21H20V11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,8h-2V7a3.5,3.5,0,0,0-7,0V8h-2V7a5.5,5.5,0,0,1,11,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19H11a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,13,19Zm-2-4v2h2V15Z",
    fill: "currentColor"
  }))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "lock icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,23H4a2,2,0,0,1-2-2V11A2,2,0,0,1,4,9H20a2,2,0,0,1,2,2V21A2,2,0,0,1,20,23ZM4,11V21H20V11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,8h-2V7a3.5,3.5,0,0,0-7,0V8h-2V7a5.5,5.5,0,0,1,11,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19H11a2,2,0,0,1-2-2V15a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v2A2,2,0,0,1,13,19Zm-2-4v2h2V15Z",
    fill: "currentColor"
  }))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    id: "map-pin-person",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "map-pin-person icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,16H10a1,1,0,0,1-1-1V12.818a4.243,4.243,0,0,1,1.1-2.854l.671-.741,1.483,1.342-.671.742A2.246,2.246,0,0,0,11,12.818V14H21V12.818a2.246,2.246,0,0,0-.581-1.511l-.671-.742L21.23,9.224l.671.741A4.243,4.243,0,0,1,23,12.818V15A1,1,0,0,1,22,16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,11.636a4.818,4.818,0,1,1,4.818-4.818A4.824,4.824,0,0,1,16,11.636ZM16,4a2.818,2.818,0,1,0,2.818,2.818A2.821,2.821,0,0,0,16,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,24a1,1,0,0,1-.665-.252C8.38,22.9,0,15.3,0,10,0,5.122,4.58,1,10,1h1V3H10C5.664,3,2,6.206,2,10c0,3.451,5.357,9.173,8.066,11.706A24.342,24.342,0,0,0,14.2,17.4l.6-.8L16.4,17.808l-.6.8a23.555,23.555,0,0,1-5.25,5.233A1,1,0,0,1,10,24Z",
    fill: "currentColor"
  }))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    id: "map-pin",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "map-pin icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,13a6,6,0,1,1,6-6A6.007,6.007,0,0,1,12,13ZM12,3a4,4,0,1,0,4,4A4,4,0,0,0,12,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,23H4a3.5,3.5,0,0,1,0-7H9v2H4a1.5,1.5,0,0,0,0,3H19a1.5,1.5,0,0,0,0-3H15V16h4a3.5,3.5,0,0,1,0,7Z",
    fill: "currentColor"
  }))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    id: "map-w-pin",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "map-w-pin icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17,24.06A.994.994,0,0,1,16.668,24L9.023,21.318l-6.651,2.67A1,1,0,0,1,1,23.06V6.25A1,1,0,0,1,1.691,5.3L6.642,3.69l.618,1.9L3,6.977v14.6l5.627-2.259a1.007,1.007,0,0,1,.7-.015l7.552,2.652L21,19.439V5.477L19.443,6.1,18.7,4.243l2.929-1.171A1,1,0,0,1,23,4V20a1,1,0,0,1-.478.853l-5,3.06A1,1,0,0,1,17,24.06Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,13,10Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,13,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 2,
    height: 8,
    fill: "currentColor"
  }))), _symbol154 || (_symbol154 = /*#__PURE__*/React.createElement("symbol", {
    id: "map",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "map icon"), /*#__PURE__*/React.createElement("path", {
    d: "M1,22.05a1,1,0,0,1-1-1V6.252a1,1,0,0,1,.628-.928l7-2.8a.989.989,0,0,1,.7-.016l7.65,2.678,6.649-2.662A1,1,0,0,1,24,3.45v14.8a1,1,0,0,1-.628.928l-7,2.8a1,1,0,0,1-.7.016l-7.65-2.678L1.372,21.978A.994.994,0,0,1,1,22.05Zm7-4.8a.993.993,0,0,1,.33.056l7.65,2.678L22,17.571V4.928L16.374,7.18a1,1,0,0,1-.7.016L8.021,4.518,2,6.929V19.572L7.626,17.32A1,1,0,0,1,8,17.248Zm15,1h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 2,
    height: 15,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 2,
    height: 16,
    fill: "currentColor"
  }))), _symbol155 || (_symbol155 = /*#__PURE__*/React.createElement("symbol", {
    id: "maximize",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "maximize icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19.027,10,19,4.022,13,4,13,2l6,.027A2.005,2.005,0,0,1,21,4.013L21.027,10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,21l-6-.027A2.005,2.005,0,0,1,2,18.987L1.973,13l2-.009L4,18.978,10,19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.722,
    y: 10.5,
    width: 17.556,
    height: 2,
    transform: "translate(-4.763 11.5) rotate(-45)",
    fill: "currentColor"
  }))), _symbol156 || (_symbol156 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-next",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-next icon"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,16.953a1.5,1.5,0,0,1-1.5-1.5V8.547A1.5,1.5,0,0,1,8.351,7.312l5.02,3.452a1.5,1.5,0,0,1,0,2.473L8.35,16.688A1.5,1.5,0,0,1,7.5,16.953ZM8,9.5v5L11.638,12Zm4.237,2.914h0ZM7.217,8.96Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 2,
    height: 10,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }))), _symbol157 || (_symbol157 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-pause",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-pause icon"), /*#__PURE__*/React.createElement("path", {
    d: "M10,18H7a1,1,0,0,1-1-1V7A1,1,0,0,1,7,6h3a1,1,0,0,1,1,1V17A1,1,0,0,1,10,18ZM8,16H9V8H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,18H14a1,1,0,0,1-1-1V7a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1V17A1,1,0,0,1,17,18Zm-2-2h1V8H15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }))), _symbol158 || (_symbol158 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-play icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9,17.737a2.009,2.009,0,0,1-2-2V8.118A2,2,0,0,1,9.895,6.329l6.924,3.462a2,2,0,0,1,.134,3.5l-6.923,4.154A2,2,0,0,1,9,17.737ZM9,8.118v7.621l6.923-4.16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }))), _symbol159 || (_symbol159 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-previous",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-previous icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,16.953a1.5,1.5,0,0,1-.851-.265l-5.02-3.452a1.5,1.5,0,0,1,0-2.473L15.65,7.312A1.5,1.5,0,0,1,18,8.547v6.905a1.5,1.5,0,0,1-1.5,1.5Zm.284-1.913h0Zm0,0ZM12.362,12,16,14.5v-5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 2,
    height: 10,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }))), _symbol160 || (_symbol160 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-stop",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-stop icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,18H7a1,1,0,0,1-1-1V7A1,1,0,0,1,7,6H17a1,1,0,0,1,1,1V17A1,1,0,0,1,17,18ZM8,16h8V8H8Z",
    fill: "currentColor"
  }))), _symbol161 || (_symbol161 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-volume-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-volume-down icon"), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,17H6V8.069a2.012,2.012,0,0,1,.978-1.72l8.787-5.219A2,2,0,0,1,19,2.7V6H17V2.7a.954.954,0,0,1-.148.106L8,8.068Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.993,23.8a1.976,1.976,0,0,1-1.229-.431L6.726,18H3a2,2,0,0,1-2-2V9A2,2,0,0,1,3,7H7V9H3v7H7a1,1,0,0,1,.511.141l9.341,5.549A.95.95,0,0,1,17,21.8V18h2v3.8a1.98,1.98,0,0,1-1.173,1.821A2.023,2.023,0,0,1,16.993,23.8Z",
    fill: "currentColor"
  }))), _symbol162 || (_symbol162 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-volume-muted",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-volume-muted icon"), /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: -2.851,
    width: 2,
    height: 28.201,
    transform: "translate(-3.973 13.597) rotate(-48.094)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,11H19V3c0-.052-.063-.105-.09-.126a.423.423,0,0,0-.293-.1L11.723,7.387,10.613,5.723,17.4,1.2A2.151,2.151,0,0,1,19.641,1,2.213,2.213,0,0,1,21,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.993,23.8a1.976,1.976,0,0,1-1.229-.431L7.726,18H4a2,2,0,0,1-2-2V9A2,2,0,0,1,4,7H6V9H4v7H8a1,1,0,0,1,.511.141l9.341,5.549A.95.95,0,0,1,18,21.8v-1h2v1a1.98,1.98,0,0,1-1.173,1.821A2.023,2.023,0,0,1,17.993,23.8Z",
    fill: "currentColor"
  }))), _symbol163 || (_symbol163 = /*#__PURE__*/React.createElement("symbol", {
    id: "media-control-volume-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "media-control-volume-up icon"), /*#__PURE__*/React.createElement("path", {
    d: "M8,17H6V8.069a2.012,2.012,0,0,1,.978-1.72l8.787-5.219A2,2,0,0,1,19,2.7V6H17V2.7a.954.954,0,0,1-.148.106L8,8.068Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.993,23.8a1.976,1.976,0,0,1-1.229-.431L6.726,18H3a2,2,0,0,1-2-2V9A2,2,0,0,1,3,7H7V9H3v7H7a1,1,0,0,1,.511.141l9.341,5.549A.95.95,0,0,1,17,21.8V18h2v3.8a1.98,1.98,0,0,1-1.173,1.821A2.023,2.023,0,0,1,16.993,23.8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 2,
    height: 8,
    fill: "currentColor"
  }))), _symbol164 || (_symbol164 = /*#__PURE__*/React.createElement("symbol", {
    id: "megaphone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "megaphone icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21,20a1,1,0,0,1-.485-.126L11.741,15H6c-2.484,0-5-1.374-5-4C1,8.515,2.374,6,5,6h5c.106,0,.289.008.506.018.278.013.888.041,1.16.023l8.849-4.916A1,1,0,0,1,22,2V19a1,1,0,0,1-1,1ZM5,8C3.532,8,3,9.794,3,11c0,1.467,1.794,2,3,2h6a1,1,0,0,1,.485.126L20,17.3V3.7L12.485,7.874a.944.944,0,0,1-.191.082,6.276,6.276,0,0,1-1.881.06C10.236,8.007,10.087,8,10,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22.452a2.42,2.42,0,0,1-1.707-.745L5.586,17,7,15.586l4.707,4.707a.477.477,0,0,0,.293.159.477.477,0,0,0,.293-.159.351.351,0,0,0,0-.586L9.586,17,11,15.586l2.707,2.707a2.336,2.336,0,0,1,0,3.414A2.42,2.42,0,0,1,12,22.452Z",
    fill: "currentColor"
  }))), _symbol165 || (_symbol165 = /*#__PURE__*/React.createElement("symbol", {
    id: "microphone-muted",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "microphone-muted icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: -2.435,
    width: 2,
    height: 28.87,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,20H10a5.006,5.006,0,0,1-5-5V12H7v3a3,3,0,0,0,3,3h6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    width: 2,
    height: 5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 14,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16.5H11a3,3,0,0,1-3-3V12h2v1.5a1,1,0,0,0,1,1h1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,13H16V4a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V5H8V4a3,3,0,0,1,3-3h4a3,3,0,0,1,3,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 5,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 3,
    height: 2,
    fill: "currentColor"
  }))), _symbol166 || (_symbol166 = /*#__PURE__*/React.createElement("symbol", {
    id: "microphone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "microphone icon"), /*#__PURE__*/React.createElement("path", {
    d: "M14,17H10a3,3,0,0,1-3-3V4a3,3,0,0,1,3-3h4a3,3,0,0,1,3,3V14A3,3,0,0,1,14,17ZM10,3A1,1,0,0,0,9,4V14a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,20H9a5.006,5.006,0,0,1-5-5V12H6v3a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3V12h2v3A5.006,5.006,0,0,1,15,20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 6,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 6,
    height: 2,
    fill: "currentColor"
  }))), _symbol167 || (_symbol167 = /*#__PURE__*/React.createElement("symbol", {
    id: "minimize",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "minimize icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23,11l-7-.027A2,2,0,0,1,14,8.986L13.974,2l2-.008L16,8.979,23,9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.965,
    y: 3.5,
    width: 9.071,
    height: 2,
    transform: "translate(2.822 15.814) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.026,23,9,16.021,2,16,2,14l7,.027A2,2,0,0,1,11,16.014L11.026,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.035,
    y: 19.5,
    width: 9.071,
    height: 2,
    transform: "translate(-13.178 9.186) rotate(-45)",
    fill: "currentColor"
  }))), _symbol168 || (_symbol168 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "minus-filled icon"), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 15,
    height: 3,
    fill: "currentColor"
  }))), _symbol169 || (_symbol169 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "minus icon"), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 20,
    height: 2,
    fill: "currentColor"
  }))), _symbol170 || (_symbol170 = /*#__PURE__*/React.createElement("symbol", {
    id: "money",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "money icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,18H1a1,1,0,0,1-1-1V4A1,1,0,0,1,1,3H20a1,1,0,0,1,1,1V17A1,1,0,0,1,20,18ZM2,16H19V5H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,21H1V19H22V4h2V20A1,1,0,0,1,23,21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,15H6a1,1,0,0,1-1-1V13H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8H5V7A1,1,0,0,1,6,6h9a1,1,0,0,1,1,1V8h1a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H16v1A1,1,0,0,1,15,15ZM7,13h7V12a1,1,0,0,1,1-1h1V10H15a1,1,0,0,1-1-1V8H7V9a1,1,0,0,1-1,1H5v1H6a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 3,
    fill: "currentColor"
  }))), _symbol171 || (_symbol171 = /*#__PURE__*/React.createElement("symbol", {
    id: "moon-night",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "moon-night icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.294,7.778l-.336-.942a8.5,8.5,0,0,0-1.88-3.03,10.413,10.413,0,0,1,.065,2.806l-.111.994-1.988-.222.111-.994a8.422,8.422,0,0,0-.85-4.729A1,1,0,0,1,14.644.313a10.349,10.349,0,0,1,2.733,1.959,10.515,10.515,0,0,1,2.465,3.891l.336.942Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.954,20.194a10.488,10.488,0,0,1-7.43-3.066A4.287,4.287,0,0,1,1,14a1,1,0,0,1,1.707-.707c.74.739,3.295,1.589,4.846.813l.895-.447.895,1.789-.895.447a6.091,6.091,0,0,1-3.9.368,8.525,8.525,0,0,0,11.419-.55c.2-.2.378-.358.538-.5a2.578,2.578,0,0,0,.638-.721l.507-.862,1.724,1.015-.507.861a4.522,4.522,0,0,1-1.037,1.206c-.133.117-.279.245-.448.414A10.464,10.464,0,0,1,9.954,20.194Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 14,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 14,
    height: 2,
    fill: "currentColor"
  }))), _symbol172 || (_symbol172 = /*#__PURE__*/React.createElement("symbol", {
    id: "moon",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "moon icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,22.5A11,11,0,0,1,1.478,16.021,1,1,0,0,1,2.8,14.7a8.864,8.864,0,0,0,3.7.8,9.01,9.01,0,0,0,9-9,8.86,8.86,0,0,0-.8-3.7,1,1,0,0,1,1.32-1.327A11,11,0,0,1,11.5,22.5ZM4.662,17.347A9,9,0,1,0,17.347,4.663,11.007,11.007,0,0,1,4.662,17.347Z",
    fill: "currentColor"
  }))), _symbol173 || (_symbol173 = /*#__PURE__*/React.createElement("symbol", {
    id: "more-horizontal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "more-horizontal icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19.608,15a3,3,0,1,1,3-3A3,3,0,0,1,19.608,15Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,19.608,11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,15a3,3,0,1,1,3-3A3,3,0,0,1,11.5,15Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,11.5,11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.392,15a3,3,0,1,1,3-3A3,3,0,0,1,3.392,15Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,3.392,11Z",
    fill: "currentColor"
  }))), _symbol174 || (_symbol174 = /*#__PURE__*/React.createElement("symbol", {
    id: "more-vertical",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "more-vertical icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,23.108a3,3,0,1,1,3-3A3,3,0,0,1,12.5,23.108Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,12.5,19.108Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,15a3,3,0,1,1,3-3A3,3,0,0,1,12.5,15Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,12.5,11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,6.892a3,3,0,1,1,3-3A3,3,0,0,1,12.5,6.892Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,12.5,2.892Z",
    fill: "currentColor"
  }))), _symbol175 || (_symbol175 = /*#__PURE__*/React.createElement("symbol", {
    id: "mouse-pointer",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "mouse-pointer icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17,21a1,1,0,0,1-.707-.293L10.73,15.145,8.874,18.485a.987.987,0,0,1-.988.508,1,1,0,0,1-.848-.719l-4-14A1,1,0,0,1,4.274,3.038l14,4A1,1,0,0,1,18.6,8.8l-3.077,2.309,5.185,5.185a1,1,0,0,1,0,1.414l-3,3A1,1,0,0,1,17,21Zm-6.5-8.5a1,1,0,0,1,.707.293L17,18.586,18.586,17l-5.293-5.293A1,1,0,0,1,13.4,10.2l2.389-1.792L5.456,5.456,8.3,15.4l1.328-2.39a1,1,0,0,1,.735-.5A.946.946,0,0,1,10.5,12.5Z",
    fill: "currentColor"
  }))), _symbol176 || (_symbol176 = /*#__PURE__*/React.createElement("symbol", {
    id: "music-note",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "music-note icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V5.876a1.579,1.579,0,0,1,1.271-1.546l9.773-2.922a1.589,1.589,0,0,1,1.386.3A1.557,1.557,0,0,1,22,2.916V14H20V3.5L11,6.2ZM10.786,6.259l-.035.01A.14.14,0,0,0,10.786,6.259Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,23a4,4,0,0,1,0-8h3a1,1,0,0,1,1,1v3A4,4,0,0,1,7,23Zm0-6a2,2,0,1,0,2,2V17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,20a4,4,0,0,1,0-8h3a1,1,0,0,1,1,1v3A4,4,0,0,1,18,20Zm0-6a2,2,0,1,0,2,2V14Z",
    fill: "currentColor"
  }))), _symbol177 || (_symbol177 = /*#__PURE__*/React.createElement("symbol", {
    id: "newspaper",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "newspaper icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21,23a1.959,1.959,0,0,1-2-2V3H2V20c0,.376,0,.738.009,1H18v2H2c-2,0-2-1.065-2-3V2A1,1,0,0,1,1,1H20a1,1,0,0,1,1,1V21a3.018,3.018,0,0,0,1-.105V3h2V21C24,21.912,23.479,23,21,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,10H4A1,1,0,0,1,3,9V5A1,1,0,0,1,4,4H17a1,1,0,0,1,1,1V9A1,1,0,0,1,17,10ZM5,8H16V6H5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 9,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 9,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,18H14a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v4A1,1,0,0,1,17,18Zm-2-2h1V14H15Z",
    fill: "currentColor"
  }))), _symbol178 || (_symbol178 = /*#__PURE__*/React.createElement("symbol", {
    id: "offshore-rig",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "offshore-rig icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3,10h3v3h2V9c0-0.6-0.4-1-1-1H2C1.4,8,1,8.4,1,9v4h2V10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5,21.7c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C17.2,22,17.2,22,17,22c-0.1,0-0.3-0.2-0.5-0.3 c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C12.2,22,12.2,22,12,22c-0.1,0-0.3-0.2-0.5-0.3c-0.5-0.3-1.2-0.7-2.2-0.7 c-1,0-1.6,0.5-1.9,0.8C7.2,22,7.2,22,7,22c-0.1,0-0.3-0.2-0.5-0.3C6.1,21.4,5.4,21,4.4,21c-1,0-1.6,0.5-1.9,0.8C2.2,22,2.2,22,2,22 H1v2h1c0.9,0,1.4-0.4,1.7-0.7C4,23.1,4.1,23,4.4,23c0.4,0,0.7,0.2,1.1,0.4C5.9,23.7,6.4,24,7,24c0.9,0,1.4-0.4,1.7-0.7 C9,23.1,9.1,23,9.4,23c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3 c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3c0.4,0,0.7,0.2,1.1,0.4 c0.4,0.3,0.9,0.6,1.5,0.6h1l0-2h-1C21.9,22,21.7,21.8,21.5,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.9,13.1l0.5-5.4l2.6,4.3l0.1,1.1l2-0.2L15,0.9c0-0.5-0.5-0.9-1-0.9h-3c-0.5,0-0.9,0.4-1,0.9L9.7,4.7l0,0 l0,0l-0.7,8.2L10.9,13.1z M13.1,2l0.5,5.4l-1.9-3.1L11.9,2H13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19,9.6l4.3-2.2l-0.9-1.8l-4.9,2.4C17.2,8.3,17,8.6,17,9v4h2V9.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "2,20 4,20 4,16 6,16 6,20 8,20 8,16 16,16 16,20 18,20 18,16 20,16 20,20 22,20 22,16 23,16 23,14  22,14 20,14 18,14 16,14 8,14 6,14 4,14 2,14 1,14 1,16 2,16  "
  })))), _symbol179 || (_symbol179 = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-barrel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "oil-barrel icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21,3.5C21,0.7,15.3,0,12,0S3,0.7,3,3.5v17h0c0,0.1,0,0.1,0,0.2c0,3.2,8.1,3.3,9,3.3c3.3,0,9-0.7,9-3.3 c0-0.1,0-0.1,0-0.2h0V3.5z M12,2c4.2,0,6.6,1,7,1.5C18.6,4,16.2,5,12,5C7.8,5,5.4,4,5,3.5C5.4,3,7.8,2,12,2z M19,20.6 C18.7,21,16.3,22,12,22s-6.7-1-7-1.4c0,0,0-0.1,0-0.1h0V5.8C7,6.7,9.9,7,12,7s5-0.3,7-1.2v14.7h0C19,20.5,19,20.6,19,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,11c-2.1,0-3.9-0.4-5.5-1.3l-0.9,1.8c1.9,1,4,1.5,6.5,1.5c2.4,0,4.5-0.5,6.5-1.5l-0.9-1.8 C15.9,10.6,14.1,11,12,11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,16c-2.1,0-3.9-0.4-5.5-1.3l-0.9,1.8c1.9,1,4,1.5,6.5,1.5c2.4,0,4.5-0.5,6.5-1.5l-0.9-1.8 C15.9,15.6,14.1,16,12,16z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    cx: 9,
    cy: 3.5,
    rx: 1.5,
    ry: 1
  })))), _symbol180 || (_symbol180 = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-bottle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "oil-bottle icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,24H6a2,2,0,0,1-2-2V13A4.138,4.138,0,0,1,6.442,9.166l5.714-4.571,1.25,1.562L7.625,10.781a1.045,1.045,0,0,1-.146.1C6.387,11.474,6,12.029,6,13v9H19V6h2V22A2,2,0,0,1,19,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,5H14a1,1,0,0,1-1-1V2c0-1.3,1.546-2,3-2h3a2,2,0,0,1,2,2V4A1,1,0,0,1,20,5ZM15,3h4V2H16a2.2,2.2,0,0,0-1,.224Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19a2.84,2.84,0,0,1-3-3c0-1.454,1.677-3.879,2.19-4.587a1.036,1.036,0,0,1,1.619,0C14.323,12.121,16,14.546,16,16A2.84,2.84,0,0,1,13,19Zm0-5.192A6.524,6.524,0,0,0,12,16c0,.691.309,1,1,1s1-.309,1-1A6.524,6.524,0,0,0,13,13.808Z",
    fill: "currentColor"
  }))), _symbol181 || (_symbol181 = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-drop",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "oil-drop icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,24c-3,0-5.8-1.6-7.5-4.3c-0.2-0.3-0.3-0.5-0.5-0.8c-0.6-1.3-1-2.7-1-4.2c0-1.6,0.3-3.2,1-4.6 c0.5-1,1.5-2.5,3.1-4.6c2-2.9,4.1-5.1,4.2-5.2C11.4,0.1,11.7,0,12,0l0,0c0.3,0,0.6,0.1,0.7,0.3c0.1,0.1,2.2,2.4,4.2,5.3 c1.6,2.1,2.6,3.6,3.1,4.6l0.1,0.1c0.7,1.5,1,3.2,0.9,4.8c-0.1,1.7-0.6,3.2-1.5,4.6C17.8,22.4,15,24,12,24z M12,2.5 C11.2,3.4,9.9,5,8.7,6.8c-1.9,2.5-2.6,3.7-2.9,4.3C5.2,12.2,5,13.4,5,14.7l0,0C5,15.9,5.3,17,5.8,18c0.1,0.2,0.2,0.4,0.4,0.6 C7.5,20.8,9.7,22,12,22c2.3,0,4.5-1.2,5.8-3.3c0.7-1.1,1.1-2.3,1.2-3.6c0.1-1.3-0.2-2.7-0.7-3.9c0,0,0-0.1,0-0.1 c-0.3-0.6-1-1.8-2.9-4.3C14.1,5,12.8,3.4,12,2.5z"
  })))), _symbol182 || (_symbol182 = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-pump",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "oil-pump icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.6,3.2C23.3,3,23,3,22.7,3l-5,1.5l0.6,1.9L22,5.4V19h2V4C24,3.7,23.8,3.4,23.6,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.7,18.6l1.9,0.6l0.3-0.9l6.4-5.3l2.1,6.2l1.9-0.6L16.8,8.1C16.9,7.8,17,7.4,17,7c0-1.7-1.3-3-3-3 s-3,1.3-3,3c0,0.4,0.1,0.8,0.2,1.1L7.7,18.6z M11.1,14.8l1.7-5C13.2,9.9,13.6,10,14,10c0.4,0,0.8-0.1,1.2-0.3l0.4,1.3L11.1,14.8z  M14,6c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S13.4,6,14,6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    fill: "currentColor",
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2,14v5h2v-3.5c0.3,0.1,0.7,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1l1.1-0.3c0.3-0.1,0.5-0.2,0.6-0.5 s0.2-0.5,0.1-0.8l-1-3.9l3.8-1.1L9.7,7.3L5.9,8.3L5.1,5.5C5,4.9,4.4,4.6,3.9,4.8C2.8,5,2.4,5.1,1.7,5.3c-1.6,0.5-2.2,2.4-1.5,4.9 C0.5,11.5,1.2,12.9,2,14L2,14z M2.3,7.3C2.7,7.1,3,7.1,3.4,6.9l1.8,6.7l-0.1,0c-0.8,0.2-2.4-1.6-3-4C1.8,8.5,1.9,7.4,2.3,7.3z"
  })))), _symbol183 || (_symbol183 = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-tanker",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "oil-tanker icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5,18.7c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C17.2,19,17.2,19,17,19c-0.1,0-0.3-0.2-0.5-0.3 c-0.5-0.3-1.2-0.7-2.2-0.7c-1,0-1.6,0.5-1.9,0.8C12.2,19,12.2,19,12,19c-0.1,0-0.3-0.2-0.5-0.3c-0.5-0.3-1.2-0.7-2.2-0.7 c-1,0-1.6,0.5-1.9,0.8C7.2,19,7.2,19,7,19c-0.1,0-0.3-0.2-0.5-0.3C6.1,18.4,5.4,18,4.4,18c-1,0-1.6,0.5-1.9,0.8C2.2,19,2.2,19,2,19 H1v2h1c0.9,0,1.4-0.4,1.7-0.7C4,20.1,4.1,20,4.4,20c0.4,0,0.7,0.2,1.1,0.4C5.9,20.7,6.4,21,7,21c0.9,0,1.4-0.4,1.7-0.7 C9,20.1,9.1,20,9.4,20c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3 c0.4,0,0.7,0.2,1.1,0.4c0.4,0.3,0.9,0.6,1.5,0.6c0.9,0,1.4-0.4,1.7-0.7c0.3-0.2,0.4-0.3,0.7-0.3c0.4,0,0.7,0.2,1.1,0.4 c0.4,0.3,0.9,0.6,1.5,0.6h1l0-2h-1C21.9,19,21.7,18.8,21.5,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.9,10.6C23.8,10.2,23.4,10,23,10H8.8L8,9.5V5c0-0.6-0.4-1-1-1H2C1.4,4,1,4.4,1,5v4c-0.6,0-1,0.4-1,1 c0,0.2,0,4.4,1.7,6.6l0.6,0.8l1.6-1.2l-0.6-0.8C2.5,14.3,2.2,12.3,2,11h4.6l1.2,0.8C8.1,11.9,8.3,12,8.5,12h12.3 c-0.9,1.1-1.8,2.7-1.8,4v1h2v-1c0-1.1,1.6-3.2,2.7-4.3C24,11.4,24.1,11,23.9,10.6z M3,6h3v3H3V6z"
  })))), _symbol184 || (_symbol184 = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-tower",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "oil-tower icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7,19.9L7,19.9l4-4.3V21h2v-5.4l3.9,4.3l0,0l0.2,1.3l2-0.4L16,3.8C15.9,3.3,15.5,3,15,3h-2V1h-2v2H9 C8.5,3,8.1,3.3,8,3.8l-3.2,17l2,0.4L7,19.9z M7.7,16.2l1-5.3l1.9,2.1L7.7,16.2z M13.4,13l1.9-2.1l1,5.3L13.4,13z M14.2,5l0.6,3.4 l-1.8,2V5H14.2z M11,5v5.4l-1.8-2L9.8,5H11z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    fill: "currentColor",
    width: 18,
    height: 2
  })))), _symbol185 || (_symbol185 = /*#__PURE__*/React.createElement("symbol", {
    id: "oil-worker",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "oil-worker icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.6,13.2l-0.8-0.6l-1.1,1.7l0.8,0.6c2.5,1.7,2.6,3.1,2.6,5.9V22c0,0,0,0-0.1,0H4.1c0,0,0,0-0.1,0v-1.3 c0-2.8,0-4.2,2.6-5.9l0.8-0.6l-1.1-1.7l-0.8,0.6C2,15.5,2,17.9,2,20.8v1.3c0,1,0.9,1.9,2.1,1.9h15.9c1.1,0,2.1-0.9,2.1-1.9v-1.3 C22.1,18.1,22.1,15.5,18.6,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7,8c0,2.8,2.2,5,5,5s5-2.2,5-5V7h1V5h-1c0-2.8-2.2-5-5-5S7,2.2,7,5H6v2h1V8z M11,2.2V4h2V2.2 c1.2,0.4,2,1.5,2,2.8H9C9,3.7,9.8,2.6,11,2.2z M15,7v1c0,1.7-1.3,3-3,3S9,9.7,9,8V7H15z"
  })))), _symbol186 || (_symbol186 = /*#__PURE__*/React.createElement("symbol", {
    id: "outlet",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "outlet icon"), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.067,21H3.937a1,1,0,0,1-.948-.682L1.931,17.171a17.926,17.926,0,0,1,0-11.342L2.988,2.682A1,1,0,0,1,3.937,2H21.067a1,1,0,0,1,.948.682l1.058,3.147a17.926,17.926,0,0,1,0,11.342l-1.058,3.147A1,1,0,0,1,21.067,21ZM4.655,19H20.349l.828-2.466a15.9,15.9,0,0,0,0-10.068L20.349,4H4.655L3.827,6.466a15.9,15.9,0,0,0,0,10.068Z",
    fill: "currentColor"
  }))), _symbol187 || (_symbol187 = /*#__PURE__*/React.createElement("symbol", {
    id: "paste",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "paste icon"), /*#__PURE__*/React.createElement("path", {
    d: "M14,7H7A1,1,0,0,1,6,6V2A1,1,0,0,1,7,1h7a1,1,0,0,1,1,1V6A1,1,0,0,1,14,7ZM8,5h5V3H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,8H19V5H16V3h3a2,2,0,0,1,2,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,21H2a2,2,0,0,1-2-2V5A2,2,0,0,1,2,3H5V5H2V19H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,22H10a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1H22a1,1,0,0,1,1,1V21A1,1,0,0,1,22,22ZM11,20H21V10H11Z",
    fill: "currentColor"
  }))), _symbol188 || (_symbol188 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "pencil icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21,8.414,19.586,7l1-1L18,3.414l-1,1L15.586,3l1.707-1.707a1,1,0,0,1,1.414,0l4,4a1,1,0,0,1,0,1.414Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.868,23.132a1,1,0,0,1-.977-1.216l1.132-5.132a1,1,0,0,1,.27-.491l12-12a1,1,0,0,1,1.414,0l4,4a1,1,0,0,1,0,1.414l-12,12a1,1,0,0,1-.492.27L2.083,23.108A1.006,1.006,0,0,1,1.868,23.132ZM7,21H7ZM3.914,17.5l-.731,3.317L6.5,20.086,17.586,9,15,6.414Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.136,
    y: 12.5,
    width: 14.728,
    height: 2,
    transform: "translate(-6.471 11.379) rotate(-45)",
    fill: "currentColor"
  }))), _symbol189 || (_symbol189 = /*#__PURE__*/React.createElement("symbol", {
    id: "person-running",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "person-running icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,7a3.5,3.5,0,0,1-2.475-5.975,3.584,3.584,0,0,1,4.95,0,3.5,3.5,0,0,1,0,4.949h0A3.477,3.477,0,0,1,18.5,7Zm0-5a1.5,1.5,0,0,0-1.061,2.561,1.536,1.536,0,0,0,2.121,0h0A1.5,1.5,0,0,0,18.5,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.777,22.1a4.332,4.332,0,0,1-2.484-1.39,1.54,1.54,0,0,1,0-2.414L6,13.586,7.414,15,2.922,19.492a5.156,5.156,0,0,0,.676.5l4.4-4.4L9.414,17,4.707,21.707A1.269,1.269,0,0,1,3.777,22.1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.989,23.532a2.468,2.468,0,0,1-1.7-.825,2.778,2.778,0,0,1,0-3.414L10.586,17,7.293,13.707a1,1,0,0,1-.017-1.4L13.958,5.3a1,1,0,0,1,1.4-.043l3.612,3.354,1.318-1.318a2.108,2.108,0,0,1,2.121-.308,2.458,2.458,0,0,1,1.645,1.338,1.715,1.715,0,0,1-.352,2.384l-4,4c-1.118,1.12-2.9-.482-3.414-1L14.5,11.914l-.793.793a1.7,1.7,0,0,0,.055.655l2.363,2.558a1.954,1.954,0,0,1,.557,1.382,1.985,1.985,0,0,1-.586,1.416c-.073.068-3.356,3-4.406,4.006A2.479,2.479,0,0,1,9.989,23.532ZM9.4,12.983l3.31,3.31a1,1,0,0,1,0,1.414l-3,3a1.7,1.7,0,0,0,.055.655.829.829,0,0,0,.27.17c.031-.02.175-.157.253-.231,1.1-1.047,4.3-3.914,4.438-4.035l-2.458-2.589a2.775,2.775,0,0,1,.029-3.384l1-1a1.539,1.539,0,0,1,2.414,0l2,2a5.146,5.146,0,0,0,.891.694l3.695-3.694,0,0a.961.961,0,0,1-.107-.271,1.879,1.879,0,0,0-.62-.172l-1.861,1.86a1,1,0,0,1-1.388.025L14.725,7.394Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.044,9.449a2.562,2.562,0,0,1-1.751-.742,2.778,2.778,0,0,1,0-3.414l4-4c1.119-1.121,2.9.482,3.414,1L14.414,4,13,5.414,11.293,3.707a5.146,5.146,0,0,0-.891-.694L6.707,6.707a1.854,1.854,0,0,0,.04.619.346.346,0,0,0,.546-.033L10,4.586,11.414,6,8.707,8.707A2.315,2.315,0,0,1,7.044,9.449Z",
    fill: "currentColor"
  }))), _symbol190 || (_symbol190 = /*#__PURE__*/React.createElement("symbol", {
    id: "person-walking",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "person-walking icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16,24a4.062,4.062,0,0,1-2.707-1.293,1,1,0,0,1-.242-.391l-1-3,1.9-.633.92,2.76a2.289,2.289,0,0,0,1.027.539l.04-.016-1.884-5.65,1.9-.633,2,6c.237.824-.088,1.822-1.673,2.277A.978.978,0,0,1,16,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,24H8a1.959,1.959,0,0,1-2-2V17H8v5H9V17.035a1,1,0,0,1,.988-1C11.914,16.013,12,12.04,12,12V8h2v4c0,1.971-.66,5.158-3,5.885V22A1.959,1.959,0,0,1,9,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16a1,1,0,0,1-.408-.087C7.218,15.746,6,15.114,6,14V9C6,7.5,8.365,7,9,7a1,1,0,0,1,.408.087C9.782,7.254,11,7.886,11,9v5C11,15.5,8.635,16,8,16Zm0-2.17a1.7,1.7,0,0,0,.2.145A3.45,3.45,0,0,0,9,13.7V9.17a1.7,1.7,0,0,0-.2-.145A3.45,3.45,0,0,0,8,9.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,7A3.5,3.5,0,0,1,8.025,1.025a3.584,3.584,0,0,1,4.95,0,3.5,3.5,0,0,1,0,4.949h0A3.477,3.477,0,0,1,10.5,7Zm0-5A1.5,1.5,0,0,0,9.439,4.561a1.536,1.536,0,0,0,2.121,0h0A1.5,1.5,0,0,0,10.5,2Z",
    fill: "currentColor"
  }))), _symbol191 || (_symbol191 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "phone icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.611,22.981a5.144,5.144,0,0,1-3.244-1.207A126.9,126.9,0,0,1,3.235,9.644C1.506,7.589,2.727,3.858,4.293,2.293l1-1a1,1,0,0,1,1.414,0l5,5a1,1,0,0,1,0,1.414L10.414,9,16,14.586l1.293-1.293a1,1,0,0,1,1.414,0l5,5a1,1,0,0,1,0,1.414l-2,2A4.334,4.334,0,0,1,18.611,22.981ZM6,3.414l-.293.293c-1.1,1.1-1.782,3.65-.942,4.649A124.161,124.161,0,0,0,16.633,20.226a2.718,2.718,0,0,0,3.66.067L21.586,19,18,15.414l-1.293,1.293a1,1,0,0,1-1.414,0l-7-7a1,1,0,0,1,0-1.414L9.586,7Z",
    fill: "currentColor"
  }))), _symbol192 || (_symbol192 = /*#__PURE__*/React.createElement("symbol", {
    id: "photo-gallery",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "photo-gallery icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.987,19H2.013A2.016,2.016,0,0,1,0,16.986V3.014A2.016,2.016,0,0,1,2.013,1H18.987A2.016,2.016,0,0,1,21,3.014V16.986A2.016,2.016,0,0,1,18.987,19ZM2.013,3,2,16.986,18.987,17A.013.013,0,0,0,19,16.986V3.014Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,22H5V20H22V7h2V20A2,2,0,0,1,22,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,16H4a1,1,0,0,1-1-1V12a1,1,0,0,1,.137-.506c.15-.257.15-.257,3.686-2.354a1,1,0,0,1,.9-.059l4.225,1.811L16.529,8.45A1,1,0,0,1,18,9.333V15A1,1,0,0,1,17,16ZM5,14H16V11l-3.529,1.883a1,1,0,0,1-.865.036l-4.2-1.8C6.58,11.61,5.568,12.214,5,12.557Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.333,8a2,2,0,1,1,2-2A2,2,0,0,1,7.333,8Zm0-2h0Z",
    fill: "currentColor"
  }))), _symbol193 || (_symbol193 = /*#__PURE__*/React.createElement("symbol", {
    id: "photo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "photo icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21,22H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H21a2,2,0,0,1,2,2V20A2,2,0,0,1,21,22ZM4,4V20H21L21,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19H6a1,1,0,0,1-1-1V15a1,1,0,0,1,.137-.5c.161-.275.161-.275,5.354-3.355a1,1,0,0,1,1.217.153L14,13.586l3.293-3.293A1,1,0,0,1,19,11v7A1,1,0,0,1,18,19ZM7,17H17V13.414l-2.293,2.293a1,1,0,0,1-1.414,0l-2.45-2.45c-1.367.812-3.06,1.821-3.843,2.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10A2.5,2.5,0,1,1,12,7.5,2.5,2.5,0,0,1,9.5,10Zm0-3a.5.5,0,1,0,.5.5A.5.5,0,0,0,9.5,7Z",
    fill: "currentColor"
  }))), _symbol194 || (_symbol194 = /*#__PURE__*/React.createElement("symbol", {
    id: "pipeline-valve",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "pipeline-valve icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "11,7 13,7 13,2.1 18,2.1 18,0.1 6,0.1 6,2.1 11,2.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22,12.1v1h-5v-3h1v-2h-2H8H6v2h1v3H2v-1H0v12h2v-1h20v1h2v-12H22z M2,21.1v-6h6c0.6,0,1-0.4,1-1v-4h6v4 c0,0.6,0.4,1,1,1h6v6H2z"
  })))), _symbol195 || (_symbol195 = /*#__PURE__*/React.createElement("symbol", {
    id: "plane",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "plane icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,21h-4a1,1,0,0,1-.895-1.447l3.447-6.895,1.789.895L10.118,19h1.847l3.7-5.555A1,1,0,0,1,16.5,13h2.338a.6.6,0,0,0,.422-.175.988.988,0,0,1,.125-.105l1.265-.907a1,1,0,0,0,0-1.625L19.385,9.28a.988.988,0,0,1-.125-.105A.6.6,0,0,0,18.838,9H6.5a1,1,0,0,1-.895-.553L3.882,5H2.844l1.972,6.575A1.988,1.988,0,0,0,6.732,13H8v2H6.732A3.976,3.976,0,0,1,2.9,12.149L.542,4.287A1,1,0,0,1,1.5,3h3a1,1,0,0,1,.895.553L7.118,7h11.72a2.58,2.58,0,0,1,1.771.7l1.206.865a3,3,0,0,1,0,4.876l-1.206.864a2.58,2.58,0,0,1-1.771.7h-1.8l-3.7,5.555A1,1,0,0,1,12.5,21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.105,8.447,13.382,5H11.618l1.276,2.553-1.789.895-2-4A1,1,0,0,1,10,3h4a1,1,0,0,1,.895.553l2,4Z",
    fill: "currentColor"
  }))), _symbol196 || (_symbol196 = /*#__PURE__*/React.createElement("symbol", {
    id: "plug",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "plug icon"), /*#__PURE__*/React.createElement("path", {
    d: "M15,13H8a2,2,0,0,1-2-2V5A1,1,0,0,1,7,4h9a1,1,0,0,1,1,1v6A2,2,0,0,1,15,13ZM8,6v5h7V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0.5,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 0.5,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,24c-3.42,0-6-2.149-6-5V11h2v8c0,1.738,1.682,3,4,3a3.163,3.163,0,0,0,3-3V16h2v3A5.131,5.131,0,0,1,16,24Z",
    fill: "currentColor"
  }))), _symbol197 || (_symbol197 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "plus-filled icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 3,
    height: 15,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 15,
    height: 3,
    fill: "currentColor"
  }))), _symbol198 || (_symbol198 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "plus icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 20,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 20,
    height: 2,
    fill: "currentColor"
  }))), _symbol199 || (_symbol199 = /*#__PURE__*/React.createElement("symbol", {
    id: "power-cord",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "power-cord icon"), /*#__PURE__*/React.createElement("path", {
    d: "M7,10H3A2,2,0,0,1,1,8V4A1,1,0,0,1,2,3H8A1,1,0,0,1,9,4V8A2,2,0,0,1,7,10ZM3,5V8H7L7,5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 2,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 2,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,24c-.742,0-3,0-3-3V12.055A5.723,5.723,0,0,0,11,12a5.8,5.8,0,0,0-1,.054L10,21a2.916,2.916,0,0,1-3,3,3,3,0,0,1-3-3V8H6V21a1,1,0,0,0,1,1,.915.915,0,0,0,1-1V12c0-2,2.026-2,3-2s3,0,3,2v9c0,1,.172,1,1,1a.915.915,0,0,0,1-1V12c0-2,2.026-2,3-2s3,0,3,2v6h2v2H22a2,2,0,0,1-2-2V12.055A5.723,5.723,0,0,0,19,12a5.8,5.8,0,0,0-1,.054L18,21A2.916,2.916,0,0,1,15,24Z",
    fill: "currentColor"
  }))), _symbol200 || (_symbol200 = /*#__PURE__*/React.createElement("symbol", {
    id: "power-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "power-off icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,20H4a4,4,0,0,1-4-4V7A4,4,0,0,1,4,3H20a4,4,0,0,1,4,4v9A4,4,0,0,1,20,20ZM4,5A2,2,0,0,0,2,7v9a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,17H5a2,2,0,0,1-2-2V8A2,2,0,0,1,5,6h7a2,2,0,0,1,2,2v7A2,2,0,0,1,12,17ZM5,8v7h7V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 2,
    height: 5,
    fill: "currentColor"
  }))), _symbol201 || (_symbol201 = /*#__PURE__*/React.createElement("symbol", {
    id: "power-on",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "power-on icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,4H4A3,3,0,0,0,1,7v9a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V7A3,3,0,0,0,20,4Zm0,13H14a2.006,2.006,0,0,1-2-2V8a2.006,2.006,0,0,1,2-2h6a2.006,2.006,0,0,1,2,2v7A2.006,2.006,0,0,1,20,17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,20H4a4,4,0,0,1-4-4V7A4,4,0,0,1,4,3H20a4,4,0,0,1,4,4v9A4,4,0,0,1,20,20ZM4,5A2,2,0,0,0,2,7v9a2,2,0,0,0,2,2H14a3,3,0,0,1-3-3V8a3,3,0,0,1,3-3ZM14,7a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 2,
    height: 7,
    fill: "currentColor"
  }))), _symbol202 || (_symbol202 = /*#__PURE__*/React.createElement("symbol", {
    id: "printer",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "printer icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,24H5a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H19a1,1,0,0,1,1,1v9A1,1,0,0,1,19,24ZM6,22H18V15H6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19H21V17h1V7H2V17H3v2H1a1,1,0,0,1-1-1V6A1,1,0,0,1,1,5H23a1,1,0,0,1,1,1V18A1,1,0,0,1,23,19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 1,
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,8a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,7H18V2H6V7H4V1A1,1,0,0,1,5,0H19a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 10,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 10,
    height: 2,
    fill: "currentColor"
  }))), _symbol203 || (_symbol203 = /*#__PURE__*/React.createElement("symbol", {
    id: "quote-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "quote-left icon"), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 7,
    height: 7,
    rx: 1.333,
    ry: 1.333,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.667,20H4.333A2.336,2.336,0,0,1,2,17.667V13.333A2.336,2.336,0,0,1,4.333,11H8.667A2.336,2.336,0,0,1,11,13.333v4.334A2.336,2.336,0,0,1,8.667,20ZM4.333,13A.334.334,0,0,0,4,13.333v4.334A.334.334,0,0,0,4.333,18H8.667A.334.334,0,0,0,9,17.667V13.333A.334.334,0,0,0,8.667,13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 7,
    height: 7,
    rx: 1.333,
    ry: 1.333,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.667,20H15.333A2.336,2.336,0,0,1,13,17.667V13.333A2.336,2.336,0,0,1,15.333,11h4.333A2.336,2.336,0,0,1,22,13.333v4.334A2.336,2.336,0,0,1,19.667,20Zm-4.333-7a.334.334,0,0,0-.333.333v4.334a.334.334,0,0,0,.333.333h4.333A.334.334,0,0,0,20,17.667V13.333A.334.334,0,0,0,19.667,13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13H13V12a8.862,8.862,0,0,1,6.731-8.963l.963-.27.539,1.926-.963.27A6.872,6.872,0,0,0,15,12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,13H2V12A8.862,8.862,0,0,1,8.731,3.037l.963-.27.539,1.926-.963.27A6.872,6.872,0,0,0,4,12Z",
    fill: "currentColor"
  }))), _symbol204 || (_symbol204 = /*#__PURE__*/React.createElement("symbol", {
    id: "quote-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "quote-right icon"), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 7,
    height: 7,
    rx: 1.333,
    ry: 1.333,
    transform: "translate(37 17) rotate(180)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.667,13H16.333A2.336,2.336,0,0,1,14,10.667V6.333A2.336,2.336,0,0,1,16.333,4h4.333A2.336,2.336,0,0,1,23,6.333v4.334A2.336,2.336,0,0,1,20.667,13ZM16.333,6A.334.334,0,0,0,16,6.333v4.334a.334.334,0,0,0,.333.333h4.333A.334.334,0,0,0,21,10.667V6.333A.334.334,0,0,0,20.667,6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 7,
    height: 7,
    rx: 1.333,
    ry: 1.333,
    transform: "translate(15 17) rotate(180)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.667,13H5.333A2.336,2.336,0,0,1,3,10.667V6.333A2.336,2.336,0,0,1,5.333,4H9.667A2.336,2.336,0,0,1,12,6.333v4.334A2.336,2.336,0,0,1,9.667,13ZM5.333,6A.334.334,0,0,0,5,6.333v4.334A.334.334,0,0,0,5.333,11H9.667A.334.334,0,0,0,10,10.667V6.333A.334.334,0,0,0,9.667,6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.306,20.232l-.539-1.926.963-.27C6.623,17.229,10,14.9,10,11V10h2v1c0,4.132-3.035,7.65-7.731,8.963Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.306,20.232l-.539-1.926.963-.27C17.623,17.229,21,14.9,21,11V10h2v1c0,4.132-3.035,7.65-7.731,8.963Z",
    fill: "currentColor"
  }))), _symbol205 || (_symbol205 = /*#__PURE__*/React.createElement("symbol", {
    id: "redo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "redo icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,18H5V16H19V6H6V4H19a2,2,0,0,1,2,2V16A2,2,0,0,1,19,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,23.414,1.656,19.07A2.924,2.924,0,0,1,.682,17a2.924,2.924,0,0,1,.975-2.07L6,10.586,7.414,12,3.07,16.344c-.521.521-.521.791,0,1.313L7.414,22Z",
    fill: "currentColor"
  }))), _symbol206 || (_symbol206 = /*#__PURE__*/React.createElement("symbol", {
    id: "refinery",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "refinery icon"), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20,7.5c-2.2,0-4,1.8-4,4V15l-2,0V9c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.7-0.2-1,0l-5.2,3.5L6,0.9 C5.9,0.4,5.5,0,5,0H2C1.5,0,1,0.4,1,0.9L0.1,14.4L0,16.6V23c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1v-6l2,0v5c0,1.1,0.9,2.1,2.1,2.1h3.9 c1.1,0,2.1-0.9,2.1-2.1V11.5C24,9.3,22.2,7.5,20,7.5z M2,22l0-5.3l0.1-2.1L2.9,2h1.2l2.1,18.2l2-0.2l-0.7-6.1l4.5-3V15l0,0l0,1v6H2z  M22,21.9C22,22,22,22,22,21.9L18.1,22c0,0-0.1,0-0.1-0.1v-5l0,0l0-1v-4.4c0-1.1,0.9-2,2-2s2,0.9,2,2V21.9z"
  }))), _symbol207 || (_symbol207 = /*#__PURE__*/React.createElement("symbol", {
    id: "refresh",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "refresh icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20.585,11.751a1.815,1.815,0,0,1-.307-.026l-5.429-.9.328-1.973,5.273.877.7-4.859,1.979.286L22.4,10.205A1.858,1.858,0,0,1,20.585,11.751Zm.024-2h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.236,21.5a9.236,9.236,0,0,1,0-18.473,8.853,8.853,0,0,1,8.733,6.73l.243.97-1.94.485-.242-.971a6.879,6.879,0,0,0-6.794-5.215,7.236,7.236,0,1,0,6.271,10.849l.5-.866,1.732,1-.5.866A9.269,9.269,0,0,1,12.236,21.5Z",
    fill: "currentColor"
  }))), _symbol208 || (_symbol208 = /*#__PURE__*/React.createElement("symbol", {
    id: "repeat",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "repeat icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,19H5V17H22V13h2v4A2,2,0,0,1,22,19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,24.414,1.656,20.07A2.924,2.924,0,0,1,.682,18a2.924,2.924,0,0,1,.975-2.07L6,11.586,7.414,13,3.07,17.344c-.521.521-.521.791,0,1.313L7.414,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,12.414,16.586,11,20.93,6.656c.521-.521.521-.791,0-1.312L16.586,1,18-.414,22.344,3.93A2.924,2.924,0,0,1,23.318,6a2.924,2.924,0,0,1-.975,2.07Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,11H1V7A2,2,0,0,1,3,5H18.682V7H3Z",
    fill: "currentColor"
  }))), _symbol209 || (_symbol209 = /*#__PURE__*/React.createElement("symbol", {
    id: "rocket",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "rocket icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17,20H13V18h3V10.142a8.941,8.941,0,0,0-2.636-6.364L12,2.414,10.636,3.778A8.941,8.941,0,0,0,8,10.142V18h3v2H7a1,1,0,0,1-1-1V10.142A10.927,10.927,0,0,1,9.222,2.364L11.293.293a1,1,0,0,1,1.414,0l2.071,2.071A10.927,10.927,0,0,1,18,10.142V19A1,1,0,0,1,17,20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,19H1.5a1,1,0,0,1-.937-1.351L3.915,8.712l1.873.7L2.943,17H6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,19H18V17h2.057L17.212,9.415l1.873-.7,3.351,8.937A1,1,0,0,1,21.5,19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 2,
    height: 13,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 2,
    height: 4,
    fill: "currentColor"
  }))), _symbol210 || (_symbol210 = /*#__PURE__*/React.createElement("symbol", {
    id: "rotate-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-left icon"), /*#__PURE__*/React.createElement("path", {
    d: "M4.889,9.767a1.772,1.772,0,0,1-1.706-1.3L1.839,3.551l1.93-.527L5.051,7.716l4.7-1.236.509,1.935L5.334,9.709A1.748,1.748,0,0,1,4.889,9.767Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,11.785H20v-1A7.287,7.287,0,0,0,6.176,7.568l-.441.9L3.94,7.581l.442-.9A9.286,9.286,0,0,1,22,10.785Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.255,19.486l-.772-.635a9.819,9.819,0,0,1-.818-.755l-.7-.719,1.438-1.391.7.719a7.727,7.727,0,0,0,.65.6l.772.635Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,21a9.489,9.489,0,0,1-1.428-.107l-.988-.15.3-1.977.988.15a7.8,7.8,0,0,0,2,.034l.993-.114.228,1.987-.994.113A9.53,9.53,0,0,1,12.5,21Zm4.96-1.335-1.212-1.591.795-.605A7.584,7.584,0,0,0,17.8,16.8a7.692,7.692,0,0,0,.655-.748l.607-.794,1.588,1.215-.607.794a9.507,9.507,0,0,1-1.791,1.788Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.82,13.607l-1.986-.23.115-.993A7.768,7.768,0,0,0,20,11.5v-1h2v1a9.55,9.55,0,0,1-.064,1.114Z",
    fill: "currentColor"
  }))), _symbol211 || (_symbol211 = /*#__PURE__*/React.createElement("symbol", {
    id: "rotate-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-right icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.178,9.767a1.789,1.789,0,0,1-.444-.057l-4.93-1.3.509-1.935,4.705,1.236L19.3,3.023l1.93.527L19.886,8.467A1.776,1.776,0,0,1,18.178,9.767Zm.063-1.991h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.067,11.785h-2v-1a9.286,9.286,0,0,1,17.617-4.1l.442.9-1.794.884-.441-.9A7.287,7.287,0,0,0,3.067,10.785Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.813,19.486l-1.27-1.545.772-.635a7.739,7.739,0,0,0,.651-.6l.7-.719L18.1,17.378l-.7.719a9.831,9.831,0,0,1-.819.755Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.567,21a9.53,9.53,0,0,1-1.1-.063l-.994-.113L8.7,18.836l.993.114a7.8,7.8,0,0,0,2-.034l.988-.15.3,1.977-.988.15A9.489,9.489,0,0,1,10.567,21Zm-4.96-1.335-.8-.606a9.507,9.507,0,0,1-1.791-1.788l-.607-.794L4,15.262l.607.794a7.692,7.692,0,0,0,.655.748,7.584,7.584,0,0,0,.761.665l.795.605Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.251,13.61l-.118-.993A9.39,9.39,0,0,1,1.067,11.5v-1h2v1a7.5,7.5,0,0,0,.052.881l.118.993Z",
    fill: "currentColor"
  }))), _symbol212 || (_symbol212 = /*#__PURE__*/React.createElement("symbol", {
    id: "rss",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "rss icon"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,23A3.5,3.5,0,1,1,7,19.5,3.5,3.5,0,0,1,3.5,23Zm0-5A1.5,1.5,0,1,0,5,19.5,1.5,1.5,0,0,0,3.5,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,19H10a1,1,0,0,1-1-1c0-2.617-1.383-4-4-4a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8,10.011,10.011,0,0,1,15,18,1,1,0,0,1,14,19Zm-3.06-2h2A8.016,8.016,0,0,0,6,10.062v2A5.35,5.35,0,0,1,10.94,17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,19H18a1,1,0,0,1-1-1A12.474,12.474,0,0,0,5,6,1,1,0,0,1,4,5V1A1,1,0,0,1,5,0c9.084,0,18,8.916,18,18A1,1,0,0,1,22,19Zm-3.041-2h2C20.371,9.616,13.384,2.629,6,2.04v2A14.692,14.692,0,0,1,18.959,17Z",
    fill: "currentColor"
  }))), _symbol213 || (_symbol213 = /*#__PURE__*/React.createElement("symbol", {
    id: "save-disk",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "save-disk icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,22H3a2,2,0,0,1-2-2V3A2,2,0,0,1,3,1H15.532a1.994,1.994,0,0,1,1.536.719l4.469,5.362A2,2,0,0,1,22,8.362V20A2,2,0,0,1,20,22ZM15.532,3H3V20H20V8.362Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9H6A1,1,0,0,1,5,8V2A1,1,0,0,1,6,1h6a1,1,0,0,1,1,1V8A1,1,0,0,1,12,9ZM7,7h4V3H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,22H6a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1v8A1,1,0,0,1,17,22ZM7,20h9V14H7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 7,
    height: 2,
    fill: "currentColor"
  }))), _symbol214 || (_symbol214 = /*#__PURE__*/React.createElement("symbol", {
    id: "search-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "search-line icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,18A8.5,8.5,0,1,1,18,9.5,8.51,8.51,0,0,1,9.5,18Zm0-15A6.5,6.5,0,1,0,16,9.5,6.508,6.508,0,0,0,9.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12.757,
    width: 2,
    height: 10.485,
    transform: "translate(-7.456 18) rotate(-45)",
    fill: "currentColor"
  }))), _symbol215 || (_symbol215 = /*#__PURE__*/React.createElement("symbol", {
    id: "search-outline",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "search-outline icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.349,15.21a9.7,9.7,0,0,0,1.1-6.283,9.385,9.385,0,0,0-7.583-7.794A9.4,9.4,0,0,0,1.115,12.021a9.4,9.4,0,0,0,7.459,7.821A9.184,9.184,0,0,0,15.739,18.2l3.816,3.9a.962.962,0,0,0,1.381,0L22.318,20.7a1.016,1.016,0,0,0,0-1.415ZM10.1,16a5.444,5.444,0,0,1-5.281-5.6A5.433,5.433,0,0,1,10.285,5a5.444,5.444,0,0,1,5.281,5.6A5.433,5.433,0,0,1,10.1,16Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _symbol216 || (_symbol216 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "search icon"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,19A9.5,9.5,0,1,1,16.217,2.782h0A9.5,9.5,0,0,1,9.5,19Zm0-17A7.5,7.5,0,0,0,4.2,14.8,7.5,7.5,0,0,0,14.8,4.2h0A7.452,7.452,0,0,0,9.5,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12.757,
    width: 2,
    height: 10.485,
    transform: "translate(-7.163 18.707) rotate(-45)",
    fill: "currentColor"
  }))), _symbol217 || (_symbol217 = /*#__PURE__*/React.createElement("symbol", {
    id: "send",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "send icon"), /*#__PURE__*/React.createElement("path", {
    d: "M1,22a1,1,0,0,1-.9-1.428L4.6,11.059.1,1.544A1,1,0,0,1,1.41.2l22,9.884a1,1,0,0,1,0,1.822l-22,10A.992.992,0,0,1,1,22ZM3.065,3.141l3.548,7.49a1,1,0,0,1,0,.855l-3.54,7.473L20.572,11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 12,
    height: 2,
    fill: "currentColor"
  }))), _symbol218 || (_symbol218 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "settings icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.147,23h-1.3a2,2,0,0,1-1.976-1.672L8.618,19.8a.582.582,0,0,0-.354-.44.6.6,0,0,0-.589.049l-1.267.9A2.009,2.009,0,0,1,3.833,20.1l-.93-.93a2.011,2.011,0,0,1-.2-2.584l.893-1.258a.582.582,0,0,0,.058-.566l-.011-.026a.586.586,0,0,0-.438-.351l-1.526-.255A2,2,0,0,1,0,12.148v-1.3A2,2,0,0,1,1.673,8.874L3.2,8.618a.58.58,0,0,0,.44-.354.6.6,0,0,0-.049-.588l-.9-1.267A2.009,2.009,0,0,1,2.9,3.832L3.833,2.9a2.013,2.013,0,0,1,2.584-.2l1.259.894a.579.579,0,0,0,.565.058A.593.593,0,0,0,8.618,3.2l.226-1.35A2.061,2.061,0,0,1,10.85,0h1.3a2,2,0,0,1,1.979,1.675L14.382,3.2a.581.581,0,0,0,.354.441.594.594,0,0,0,.589-.049l1.266-.9a2.01,2.01,0,0,1,2.576.208l.93.93a2.013,2.013,0,0,1,.2,2.584l-.893,1.258a.582.582,0,0,0-.058.566l.011.026a.586.586,0,0,0,.438.351l1.528.256A2,2,0,0,1,23,10.85v1.3a2,2,0,0,1-1.673,1.976l-1.528.256a.58.58,0,0,0-.44.354.6.6,0,0,0,.049.588l.9,1.267a2.01,2.01,0,0,1-.209,2.576l-.93.93a2.013,2.013,0,0,1-2.584.2l-1.258-.893a.58.58,0,0,0-.566-.058.593.593,0,0,0-.377.449l-.226,1.349A2.063,2.063,0,0,1,12.147,23ZM8,17.3a2.606,2.606,0,0,1,1.012.206,2.578,2.578,0,0,1,1.574,1.964L10.847,21l1.288,0a1.7,1.7,0,0,0,.049-.184l.226-1.35a2.617,2.617,0,0,1,4.072-1.691l1.267.9.935-.921-.906-1.271A2.569,2.569,0,0,1,17.5,14q.009-.024.018-.044a2.565,2.565,0,0,1,1.952-1.547L21,12.153l0-1.3-1.531-.258a2.569,2.569,0,0,1-1.956-1.557L17.5,9a2.568,2.568,0,0,1,.275-2.486l.9-1.266-.922-.935-1.271.907A2.616,2.616,0,0,1,12.409,3.53l-.256-1.525L10.863,2c0,.013-.028.068-.047.182l-.226,1.352A2.617,2.617,0,0,1,6.519,5.225l-1.268-.9-.934.922.906,1.271A2.569,2.569,0,0,1,5.5,9q-.009.024-.018.044a2.565,2.565,0,0,1-1.952,1.547L2,10.847l0,1.3,1.531.261a2.569,2.569,0,0,1,1.956,1.557L5.5,14a2.568,2.568,0,0,1-.275,2.486l-.9,1.266.922.935,1.271-.907A2.562,2.562,0,0,1,8,17.3Zm10.423-2.929h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,16A4.5,4.5,0,1,1,16,11.5,4.5,4.5,0,0,1,11.5,16Zm0-7A2.5,2.5,0,1,0,14,11.5,2.5,2.5,0,0,0,11.5,9Z",
    fill: "currentColor"
  }))), _symbol219 || (_symbol219 = /*#__PURE__*/React.createElement("symbol", {
    id: "share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "share icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,24H4.1A2.1,2.1,0,0,1,2,21.9V11.4C2,9.808,2.673,9,4,9H8v2H4.013C4,11.121,4,11.294,4,11.4V21.9a.1.1,0,0,0,.1.1H19.9a.1.1,0,0,0,.1-.1V11.4c0-.1,0-.271-.012-.393L16,11V9h4c1.327,0,2,.808,2,2.4V21.9A2.1,2.1,0,0,1,19.9,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,6.414,13.293,2.707a2.073,2.073,0,0,0-2.586,0L7,6.414,5.586,5,9.293,1.293a4.03,4.03,0,0,1,5.414,0L18.414,5Z",
    fill: "currentColor"
  }))), _symbol220 || (_symbol220 = /*#__PURE__*/React.createElement("symbol", {
    id: "ship",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "ship icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21.632,22.265l-1.9-.633,2.037-6.111-10.251-4.9-9.3,4.873,2.047,6.141-1.9.633L.051,15.316a1,1,0,0,1,.485-1.2l10.5-5.5a1,1,0,0,1,.9-.017l11.5,5.5a1,1,0,0,1,.517,1.219Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,12H18V6H6v6H4V6A2,2,0,0,1,6,4H18a2,2,0,0,1,2,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,4H13V2H11V4H9V1a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,23.786a1.986,1.986,0,0,1-1.414-.586l-.786-.786-.786.786a2,2,0,0,1-2.828,0L9.8,22.414l-.786.786a2.047,2.047,0,0,1-2.829,0L5.4,22.415l-.786.785a2,2,0,0,1-2.829,0L-.414,21,1,19.586l2.2,2.2L3.986,21a2.047,2.047,0,0,1,2.829,0l.786.785L8.386,21a2,2,0,0,1,2.829,0l.786.786L12.786,21a2,2,0,0,1,2.829,0l.786.786L17.186,21a2.048,2.048,0,0,1,2.828,0l.786.786,2.2-2.2L24.414,21l-2.2,2.2a2,2,0,0,1-2.829,0l-.786-.786-.786.786A1.985,1.985,0,0,1,16.4,23.786Z",
    fill: "currentColor"
  }))), _symbol221 || (_symbol221 = /*#__PURE__*/React.createElement("symbol", {
    id: "shopping-cart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "shopping-cart icon"), /*#__PURE__*/React.createElement("path", {
    d: "M6,23a2,2,0,1,1,2-2A2,2,0,0,1,6,23Zm0-2v0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,23a2,2,0,1,1,2-2A2,2,0,0,1,18,23Zm0-2v0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,15H5a1,1,0,0,1-1-1V6A1,1,0,0,1,5,5H20a1,1,0,0,1,1,1v8A1,1,0,0,1,20,15ZM6,13H19V7H6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,19H2a1,1,0,0,1-.8-1.6l3.6-4.8,1.6,1.2L4,17H22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 2.001,
    height: 7.001,
    transform: "translate(-1.7 2.9) rotate(-36.868)",
    fill: "currentColor"
  }))), _symbol222 || (_symbol222 = /*#__PURE__*/React.createElement("symbol", {
    id: "sitemap",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "sitemap icon"), /*#__PURE__*/React.createElement("path", {
    d: "M14,8H10A1,1,0,0,1,9,7V3a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V7A1,1,0,0,1,14,8ZM11,6h2V4H11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,21H10a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4A1,1,0,0,1,14,21Zm-3-2h2V17H11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,21H2a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1H6a1,1,0,0,1,1,1v4A1,1,0,0,1,6,21ZM3,19H5V17H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,21H18a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4A1,1,0,0,1,22,21Zm-3-2h2V17H19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,17H19V13H5v4H3V12a1,1,0,0,1,1-1H20a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 2,
    height: 9,
    fill: "currentColor"
  }))), _symbol223 || (_symbol223 = /*#__PURE__*/React.createElement("symbol", {
    id: "sliders",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "sliders icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11,9H7A1,1,0,0,1,6,8V2A1,1,0,0,1,7,1h4a1,1,0,0,1,1,1V8A1,1,0,0,1,11,9ZM8,7h2V3H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,23H7a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v6A1,1,0,0,1,11,23ZM8,21h2V17H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,16H17a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v6A1,1,0,0,1,21,16Zm-3-2h2V10H18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 6,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 14,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18,
    width: 6,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 9,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 18,
    width: 9,
    height: 2,
    fill: "currentColor"
  }))), _symbol224 || (_symbol224 = /*#__PURE__*/React.createElement("symbol", {
    id: "snowflake",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "snowflake icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7.5a1,1,0,0,1-.707-.293l-2-2,1.414-1.414L12,5.086l1.293-1.293,1.414,1.414-2,2A1,1,0,0,1,12,7.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.293,20.207,12,18.914l-1.293,1.293L9.293,18.793l2-2a1,1,0,0,1,1.414,0l2,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5.382,
    width: 2,
    height: 2.236,
    transform: "translate(-4.708 5.382) rotate(-63.435)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8.394,
    width: 2,
    height: 7.211,
    transform: "translate(-4.641 15.328) rotate(-56.31)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.316,10.949l-.633-1.9,2.051-.684L4.051,6.316l1.9-.633,1,3a1,1,0,0,1-.632,1.265Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16.382,
    width: 2,
    height: 2.236,
    transform: "translate(-3.491 29.351) rotate(-63.435)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.051,18.316l-1-3a1,1,0,0,1,.632-1.265l3-1,.633,1.9-2.051.685.684,2.051Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.841,
    y: 16.425,
    width: 2.236,
    height: 2,
    transform: "translate(-8.603 3.428) rotate(-30.623)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.394,
    y: 11,
    width: 7.211,
    height: 2,
    transform: "translate(-4.641 8.672) rotate(-33.69)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.411,18.729l-1.937-.5.537-2.095L2.916,15.6l.5-1.937,3.063.785A1,1,0,0,1,7.2,15.665Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.923,
    y: 5.576,
    width: 2.236,
    height: 2,
    transform: "translate(-0.276 12.144) rotate(-30.623)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.588,10.336l-3.063-.785A1,1,0,0,1,16.8,8.334l.785-3.063,1.938.5-.537,2.094,2.095.537Z",
    fill: "currentColor"
  }))), _symbol225 || (_symbol225 = /*#__PURE__*/React.createElement("symbol", {
    id: "software",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "software icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.009,8.009,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.007,6.007,0,0,0,16,10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,18a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm0-2h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,21H3a2,2,0,0,1-2-2V2A2,2,0,0,1,3,0H17a2,2,0,0,1,2,2V7H17V2H3V19H7Z",
    fill: "currentColor"
  }))), _symbol226 || (_symbol226 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "sort-down icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.985,23.7a1.844,1.844,0,0,1-1.213-.519L6.586,19,8,17.586l4,4,4-4L17.414,19l-4.136,4.136A1.979,1.979,0,0,1,11.985,23.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 10,
    height: 2,
    fill: "currentColor"
  }))), _symbol227 || (_symbol227 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "sort-up icon"), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6.123l-4-4-4,4L6.586,4.709,10.722.574A1.72,1.72,0,0,1,13.229.527l4.186,4.182Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 20,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 10,
    height: 2,
    fill: "currentColor"
  }))), _symbol228 || (_symbol228 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "square-filled icon"), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 15,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,21H3V3H21ZM6,18H18V6H6Z",
    fill: "currentColor"
  }))), _symbol229 || (_symbol229 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "square-line icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21,21H3V3H21ZM6,18H18V6H6Z",
    fill: "currentColor"
  }))), _symbol230 || (_symbol230 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-empty",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "star-empty icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17.951,23.445a1,1,0,0,1-.587-.19L11.4,18.927,5.437,23.255A1,1,0,0,1,3.9,22.136l2.278-7L.214,10.81A1,1,0,0,1,.8,9H8.172l2.277-7a1,1,0,0,1,1.9,0l2.277,7H22a1,1,0,0,1,.587,1.81l-5.962,4.326,2.277,7a1,1,0,0,1-.951,1.31ZM11.4,16.691a1,1,0,0,1,.587.19l4.061,2.947L14.5,15.063a1,1,0,0,1,.364-1.119L18.919,11H13.9a1,1,0,0,1-.951-.69L11.4,5.541,9.85,10.31A1,1,0,0,1,8.9,11H3.882l4.058,2.944A1,1,0,0,1,8.3,15.063L6.752,19.829l4.061-2.947A1,1,0,0,1,11.4,16.691Z",
    fill: "currentColor"
  }))), _symbol231 || (_symbol231 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "star-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "11.599 2 14.102 9.702 22.199 9.702 15.648 14.463 18.15 22.165 11.599 17.405 5.049 22.165 7.551 14.463 1 9.702 9.097 9.702 11.599 2",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15,23.165a1,1,0,0,1-.588-.191L11.6,18.641,5.637,22.974A1,1,0,0,1,4.1,21.856l2.278-7.012L.412,10.511A1,1,0,0,1,1,8.7H8.371l2.278-7.011A1,1,0,0,1,11.6,1h0a1,1,0,0,1,.951.691L14.828,8.7H22.2a1,1,0,0,1,.588,1.809l-5.963,4.334L19.1,21.856a1,1,0,0,1-.951,1.309ZM4.077,10.7l4.062,2.952A1,1,0,0,1,8.5,14.771L6.951,19.547,11.012,16.6a1,1,0,0,1,1.176,0l4.061,2.951L14.7,14.771a1,1,0,0,1,.363-1.117L19.122,10.7H14.1a1,1,0,0,1-.951-.691L11.6,5.236l-1.551,4.774A1,1,0,0,1,9.1,10.7Z",
    fill: "currentColor"
  }))), _symbol232 || (_symbol232 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-half",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "star-half icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "11.599 2.004 11.599 17.406 5.049 22.165 7.548 14.939 1 9.705 9.097 9.705 11.599 2.004",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.049,23.165A1,1,0,0,1,4.1,21.856l2.277-7.011L.412,10.514A1,1,0,0,1,1,8.705H8.371L10.648,1.7A1,1,0,0,1,11.6,1h0a1,1,0,0,1,.951.691l2.277,7.01H22.2a1,1,0,0,1,.588,1.809l-5.963,4.332L19.1,21.856a1,1,0,0,1-1.539,1.117L11.6,18.642,5.637,22.974A1,1,0,0,1,5.049,23.165Zm-.971-12.46,4.061,2.95A1,1,0,0,1,8.5,14.772L6.951,19.547l4.061-2.95a1,1,0,0,1,1.176,0l4.061,2.95L14.7,14.772a1,1,0,0,1,.363-1.117l4.061-2.95H14.1a1,1,0,0,1-.951-.691L11.6,5.24l-1.551,4.773a1,1,0,0,1-.951.691Z",
    fill: "currentColor"
  }))), _symbol233 || (_symbol233 = /*#__PURE__*/React.createElement("symbol", {
    id: "sticky-note",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "sticky-note icon"), /*#__PURE__*/React.createElement("path", {
    d: "M17,23H2a1,1,0,0,1-1-1V2A1,1,0,0,1,2,1H23a1,1,0,0,1,1,1V16a1,1,0,0,1-.293.707l-6,6A1,1,0,0,1,17,23ZM3,21H16.586L22,15.586V3H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,22H15V15a1,1,0,0,1,1-1h6v2H17Z",
    fill: "currentColor"
  }))), _symbol234 || (_symbol234 = /*#__PURE__*/React.createElement("symbol", {
    id: "stop-sign",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "stop-sign icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,24H7.9a2.11,2.11,0,0,1-1.481-.613l-5.8-5.8A2.079,2.079,0,0,1,0,16.1V7.9A2.08,2.08,0,0,1,.615,6.415l5.8-5.8A2.11,2.11,0,0,1,7.9,0H16.1a2.11,2.11,0,0,1,1.481.613l5.8,5.8A2.079,2.079,0,0,1,24,7.9V16.1a2.08,2.08,0,0,1-.615,1.482l-5.8,5.8A2.11,2.11,0,0,1,16.1,24ZM7.9,2,2.028,7.83,2,16.1l5.83,5.87L16.1,22l5.87-5.83L22,7.9,16.1,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,20H9.635a2.119,2.119,0,0,1-1.509-.626L4.69,15.938a2.123,2.123,0,0,1-.625-1.509V9.57a2.123,2.123,0,0,1,.624-1.508L8.127,4.625A2.118,2.118,0,0,1,9.635,4H14.5A2.118,2.118,0,0,1,16,4.625L19.44,8.062a2.122,2.122,0,0,1,.625,1.509V14.43a2.121,2.121,0,0,1-.624,1.508L16,19.375A2.118,2.118,0,0,1,14.5,20ZM9.635,6a.131.131,0,0,0-.093.038L6.1,9.476a.134.134,0,0,0-.039.095V14.43a.135.135,0,0,0,.04.1l3.436,3.436A.132.132,0,0,0,9.635,18H14.5a.133.133,0,0,0,.095-.039l3.437-3.437a.134.134,0,0,0,.039-.095V9.57a.135.135,0,0,0-.04-.1L14.59,6.039A.133.133,0,0,0,14.5,6Z",
    fill: "currentColor"
  }))), _symbol235 || (_symbol235 = /*#__PURE__*/React.createElement("symbol", {
    id: "storage-tank",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "storage-tank icon"), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5,3c-1.6-0.7-5-1-10.4-1C6.8,2,3.2,2.3,1.5,3C0.6,3.4,0,4.2,0,5.1V22c0,0.6,0.4,1,1,1h22 c0.6,0,1-0.4,1-1V5.1C24,4.2,23.4,3.4,22.5,3z M21.8,4.9C21.9,4.9,22,5,22,5.1v1.8C20.1,6.3,16.7,6,11.5,6c-0.5,0-1,0-1.5,0V4 c0.7,0,1.4,0,2.2,0C18.4,4,20.8,4.5,21.8,4.9z M8,10H6V8.1c0,0,0,0,0.1,0C6.6,8.1,7.3,8.1,8,8V10z M6,6.1V4.2c0.6-0.1,1.2-0.1,2-0.1 v2C7.3,6.1,6.6,6.1,6,6.1z M2.3,4.9C2.6,4.8,3.1,4.6,4,4.5v1.9C3.3,6.5,2.7,6.6,2.3,6.8C2.2,6.8,2.1,6.8,2,6.9V5.1 C2,5.1,2.1,5,2.3,4.9z M22,21H2V9.2c0-0.1,0.2-0.3,0.8-0.5C3.1,8.6,3.5,8.5,4,8.4V15h2v-3h2v3h2V8c0.5,0,1,0,1.5,0 c6.6,0,9.2,0.5,10.2,0.9C21.9,8.9,22,9.1,22,9.1V21z"
  }))), _symbol236 || (_symbol236 = /*#__PURE__*/React.createElement("symbol", {
    id: "suitcase",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "suitcase icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,23H2a2,2,0,0,1-2-2V7A2,2,0,0,1,2,5H22a2,2,0,0,1,2,2V21A2,2,0,0,1,22,23ZM2,7V21H22V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,4H17V2.5a3.887,3.887,0,0,0-.027-.5H7.027A3.887,3.887,0,0,0,7,2.5V4H5V2.5C5,.771,5.617,0,7,0H17c1.383,0,2,.771,2,2.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 2,
    height: 12,
    fill: "currentColor"
  }))), _symbol237 || (_symbol237 = /*#__PURE__*/React.createElement("symbol", {
    id: "sun-cloud",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "sun-cloud icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.895,13.447l-1.789-.895a3.21,3.21,0,0,0-.6-4c-1.061-.884-2.521-.792-3.906.247L11.4,7.2c2.113-1.584,4.619-1.658,6.387-.183A5.182,5.182,0,0,1,18.895,13.447Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 3,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.586,
    y: 4,
    width: 2.828,
    height: 2,
    transform: "translate(2.322 15.607) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.761,24H5.056C3.979,24,.7,24,0,20.9H0a4.946,4.946,0,0,1,.85-3.98A4.587,4.587,0,0,1,3.2,15.194,6.767,6.767,0,0,1,9.874,9.617c3.625,0,6.167,3.2,6.72,6.481A3.935,3.935,0,0,1,19,19.9a.972.972,0,0,1-.013.159A4.393,4.393,0,0,1,14.761,24ZM9.874,11.617a4.821,4.821,0,0,0-4.812,4.537,1,1,0,0,1-.9.875,2.444,2.444,0,0,0-1.7,1.061,2.982,2.982,0,0,0-.52,2.367h0C2.118,21.2,2.511,22,5.056,22h9.705A2.407,2.407,0,0,0,17,19.824a2.044,2.044,0,0,0-1.643-2.068,1,1,0,0,1-.675-.856C14.446,14.3,12.583,11.617,9.874,11.617Z",
    fill: "currentColor"
  }))), _symbol238 || (_symbol238 = /*#__PURE__*/React.createElement("symbol", {
    id: "sun",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "sun icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.739A6.739,6.739,0,1,1,18.739,12,6.747,6.747,0,0,1,12,18.739ZM12,7.261A4.739,4.739,0,1,0,16.739,12,4.745,4.745,0,0,0,12,7.261Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.522,
    width: 2,
    height: 4.174,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.622,
    y: 2.535,
    width: 2,
    height: 4.174,
    transform: "translate(-1.914 4.622) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.522,
    width: 4.174,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.534,
    y: 18.379,
    width: 4.174,
    height: 2,
    transform: "translate(-12.349 8.944) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.522,
    y: 19.826,
    width: 2,
    height: 4.174,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.379,
    y: 17.291,
    width: 2,
    height: 4.175,
    transform: "translate(-8.027 19.378) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.826,
    y: 11.522,
    width: 4.174,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.291,
    y: 3.622,
    width: 4.174,
    height: 2,
    transform: "translate(2.408 15.056) rotate(-45)",
    fill: "currentColor"
  }))), _symbol239 || (_symbol239 = /*#__PURE__*/React.createElement("symbol", {
    id: "table",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "table icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,23H2a2,2,0,0,1-2-2V3A2,2,0,0,1,2,1H22a2,2,0,0,1,2,2V21A2,2,0,0,1,22,23ZM2,3V21H22V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 17,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 16,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 2,
    height: 13,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 2,
    fill: "currentColor"
  }))), _symbol240 || (_symbol240 = /*#__PURE__*/React.createElement("symbol", {
    id: "tag",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "tag icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,20H6.192a2,2,0,0,1-.74-.142l-4.2-1.679A1.989,1.989,0,0,1,0,16.323V8.677A1.988,1.988,0,0,1,1.258,6.82L5.45,5.143A2.01,2.01,0,0,1,6.192,5H22a2,2,0,0,1,2,2V18A2,2,0,0,1,22,20ZM6.192,7,2,8.678v7.646L6.193,18H22V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,16A3.5,3.5,0,1,1,11,12.5,3.5,3.5,0,0,1,7.5,16Zm0-5A1.5,1.5,0,1,0,9,12.5,1.5,1.5,0,0,0,7.5,11Z",
    fill: "currentColor"
  }))), _symbol241 || (_symbol241 = /*#__PURE__*/React.createElement("symbol", {
    id: "tags",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "tags icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,19H6.192a2,2,0,0,1-.74-.142l-4.2-1.679A1.989,1.989,0,0,1,0,15.323V7.677A1.988,1.988,0,0,1,1.258,5.82L5.45,4.143A2.01,2.01,0,0,1,6.192,4H22a2,2,0,0,1,2,2V17A2,2,0,0,1,22,19ZM6.192,6,2,7.678v7.646L6.193,17H22V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15A3.5,3.5,0,1,1,11,11.5,3.5,3.5,0,0,1,7.5,15Zm0-5A1.5,1.5,0,1,0,9,11.5,1.5,1.5,0,0,0,7.5,10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.192,22.944a2,2,0,0,1-.589-.089L4.753,18.668l.579-1.915,13.854,4.189.774-2.517,1.913.586L21.1,21.529a2,2,0,0,1-1.909,1.415Z",
    fill: "currentColor"
  }))), _symbol242 || (_symbol242 = /*#__PURE__*/React.createElement("symbol", {
    id: "tank-car",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "tank-car icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.2,17.1c0.6-0.1,1.8-0.6,1.8-6.1C24,5,22.6,5,22,5H2c-0.5,0-2,0-2,6.1c0,3.8,0.6,5.9,1.8,6 C0.8,17.4,0,18.3,0,19.5C0,20.9,1.1,22,2.5,22S5,20.9,5,19.5c0-1.1-0.7-2.1-1.8-2.4l3.5,0c-1,0.3-1.8,1.3-1.8,2.4 C5,20.9,6.1,22,7.5,22s2.5-1.1,2.5-2.5c0-1.1-0.7-2.1-1.8-2.4l7.5,0c-1,0.3-1.8,1.3-1.8,2.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5 c0-1.1-0.7-2.1-1.8-2.4l3.5,0c-1,0.3-1.8,1.3-1.8,2.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5C24,18.4,23.2,17.4,22.2,17.1z M7.5,20 C7.2,20,7,19.8,7,19.5S7.2,19,7.5,19S8,19.2,8,19.5S7.8,20,7.5,20z M16.5,20c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5S16.8,20,16.5,20z M16,7h2v2h-2V7z M2.4,7H14v6h2v-2h2v2h2V7h1.6c0.2,0.5,0.4,1.9,0.4,4.1s-0.2,3.5-0.4,4.1H2.5 c-0.2-0.6-0.5-2-0.5-4.1C2,8.9,2.2,7.5,2.4,7z M2.5,20C2.2,20,2,19.8,2,19.5S2.2,19,2.5,19S3,19.2,3,19.5S2.8,20,2.5,20z M21.5,20 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5S21.8,20,21.5,20z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    fill: "currentColor",
    width: 8,
    height: 2
  })))), _symbol243 || (_symbol243 = /*#__PURE__*/React.createElement("symbol", {
    id: "tank-truck",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "tank-truck icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.9,11.7l-1.8-5C22,6.3,21.6,6,21.2,6H17c-0.6,0-1,0.4-1,1v7h2V8h2.5l1.5,4.2V17h-0.2 c-0.4-1.2-1.5-2-2.8-2s-2.4,0.8-2.8,2h-4.4c-0.4-1.2-1.5-2-2.8-2c-1,0-2,0.5-2.5,1.3C6,15.5,5,15,4,15c-1.7,0-3,1.3-3,3s1.3,3,3,3 c1,0,2-0.5,2.5-1.3C7,20.5,8,21,9,21c1.3,0,2.4-0.8,2.8-2h4.4c0.4,1.2,1.5,2,2.8,2s2.4-0.8,2.8-2H23c0.6,0,1-0.4,1-1v-6 C24,11.9,24,11.8,23.9,11.7z M4,19c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S4.6,19,4,19z M9,19c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1 S9.6,19,9,19z M19,19c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S19.6,19,19,19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.8,14h7.4c2.7,0,3.8-3.5,3.8-5c0-2.8-1.7-5-3.8-5H3.8C1.7,4,0,6.2,0,9S1.7,14,3.8,14z M3.8,6h7.4 C12,6,13,7.2,13,9c0,0.9-0.8,3-1.8,3H3.8C3,12,2,10.8,2,9S3,6,3.8,6z"
  })))), _symbol244 || (_symbol244 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "thumbs-down icon"), /*#__PURE__*/React.createElement("path", {
    d: "M19,9H18V7h1c1.5,0,1.5-.376,1.5-.5A.5.5,0,0,0,20,6H19V4h1a2.5,2.5,0,0,1,2.5,2.5C22.5,7.641,21.893,9,19,9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,12H19V10h2a.5.5,0,0,0,0-1H20V7h1a2.5,2.5,0,0,1,0,5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.02,22A2.007,2.007,0,0,1,12,20V17.236l-1.895-3.789h0a9.636,9.636,0,0,0-2.553-1.553l-.895-.447.895-1.789.895.447c1.991,1,3.011,1.708,3.413,2.384l2.035,4.063A1,1,0,0,1,14,17v3a2.055,2.055,0,0,0,1.642-.856,2.162,2.162,0,0,0,.4-1.871l-.986-2.956A1,1,0,0,1,16,13h5.5a.5.5,0,0,0,0-1h-1V10h1a2.5,2.5,0,0,1,0,5H17.387l.562,1.684a4.185,4.185,0,0,1-.711,3.666A4.029,4.029,0,0,1,14.02,22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,6H17V4h1c1.5,0,1.5-.363,1.5-.5A.5.5,0,0,0,19,3H11.64a22.737,22.737,0,0,0-3.314.945l-.945.326L6.729,2.381l.946-.326A20.026,20.026,0,0,1,11.64,1H19a2.5,2.5,0,0,1,2.5,2.5C21.5,4.641,20.893,6,18,6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H6A2,2,0,0,1,8,2V12A2,2,0,0,1,6,14ZM2,2V12H6V2Z",
    fill: "currentColor"
  }))), _symbol245 || (_symbol245 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "thumbs-up icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,18H19V16h1a.5.5,0,0,0,.5-.5c0-.124,0-.5-1.5-.5H18V13h1c2.893,0,3.5,1.359,3.5,2.5A2.5,2.5,0,0,1,20,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,15H20V13h1a.5.5,0,0,0,0-1H19V10h2a2.5,2.5,0,0,1,0,5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.553,12.342l-.895-1.789.895-.447C9.764,9,10.109,8.536,10.142,8.487L12,4.765V2a2,2,0,0,1,2-2,4.038,4.038,0,0,1,3.237,1.65,4.17,4.17,0,0,1,.725,3.622L17.387,7H21.5a2.5,2.5,0,0,1,0,5h-1V10h1a.5.5,0,0,0,0-1H16a1,1,0,0,1-.949-1.316l1-3a2.152,2.152,0,0,0-.409-1.827A2.048,2.048,0,0,0,14.02,2L14,5a1,1,0,0,1-.105.447l-2,4c-.436.739-1.457,1.452-3.447,2.447Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,21H11.64a20.026,20.026,0,0,1-3.966-1.055l-.946-.326.652-1.891.945.326A22.657,22.657,0,0,0,11.643,19H19a.5.5,0,0,0,.5-.5c0-.137,0-.5-1.5-.5H17V16h1c2.893,0,3.5,1.359,3.5,2.5A2.5,2.5,0,0,1,19,21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,22H2a2,2,0,0,1-2-2V10A2,2,0,0,1,2,8H6a2,2,0,0,1,2,2V20A2,2,0,0,1,6,22ZM2,10V20H6V10Z",
    fill: "currentColor"
  }))), _symbol246 || (_symbol246 = /*#__PURE__*/React.createElement("symbol", {
    id: "ticket",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "ticket icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23,20H1a1,1,0,0,1-1-1V14a1,1,0,0,1,.8-.98c.536-.108.7-.141.7-1.02s-.162-.911-.7-1.02A1,1,0,0,1,0,10V5A1,1,0,0,1,1,4H23a1,1,0,0,1,1,1v5a1,1,0,0,1-.8.98C22,11.223,22,11.709,22,12s0,.777,1.2,1.02A1,1,0,0,1,24,14v5A1,1,0,0,1,23,20ZM2,18H22V14.755A2.809,2.809,0,0,1,20,12a2.809,2.809,0,0,1,2-2.755V6H2V9.271A2.684,2.684,0,0,1,3.5,12,2.684,2.684,0,0,1,2,14.729Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,17H6a1,1,0,0,1-1-1V8A1,1,0,0,1,6,7H18a1,1,0,0,1,1,1v8A1,1,0,0,1,18,17ZM7,15H17V9H7Z",
    fill: "currentColor"
  }))), _symbol247 || (_symbol247 = /*#__PURE__*/React.createElement("symbol", {
    id: "todo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "todo icon"), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 15,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 15,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 15,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,15H2a1,1,0,0,1-1-1V10A1,1,0,0,1,2,9H6a1,1,0,0,1,1,1v4A1,1,0,0,1,6,15ZM3,13H5V11H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,22H2a1,1,0,0,1-1-1V17a1,1,0,0,1,1-1H6a1,1,0,0,1,1,1v4A1,1,0,0,1,6,22ZM3,20H5V18H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8H2A1,1,0,0,1,1,7V3A1,1,0,0,1,2,2H6A1,1,0,0,1,7,3V7A1,1,0,0,1,6,8ZM3,6H5V4H3Z",
    fill: "currentColor"
  }))), _symbol248 || (_symbol248 = /*#__PURE__*/React.createElement("symbol", {
    id: "train",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "train icon"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,24H2.5a1,1,0,0,1-.707-1.707l6-6,1.414,1.414L4.914,22H19.086l-4.293-4.293,1.414-1.414,6,6A1,1,0,0,1,21.5,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 12,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,18H7a2,2,0,0,1-2-2V3A2,2,0,0,1,7,1H17a2,2,0,0,1,2,2V16A2,2,0,0,1,17,18ZM7,3V16H17V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12H9a1,1,0,0,1-1-1V5A1,1,0,0,1,9,4h6a1,1,0,0,1,1,1v6A1,1,0,0,1,15,12Zm-5-2h4V6H10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 2,
    height: 6,
    fill: "currentColor"
  }))), _symbol249 || (_symbol249 = /*#__PURE__*/React.createElement("symbol", {
    id: "trashcan-empty",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "trashcan-empty icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,24c-2.051,0-8-.738-8-3L4,5.063A2.316,2.316,0,0,1,5.684,3.052c3.186-1.062,10.447-1.062,13.633,0A2.319,2.319,0,0,1,21,5L20,21.063C20,22.957,15.935,24,13,24ZM6.984,20.714A13.368,13.368,0,0,0,13,22a9.012,9.012,0,0,0,5.013-1.2L18.989,5.14a.733.733,0,0,0-.306-.191c-2.773-.924-9.594-.924-12.367,0a.739.739,0,0,0-.308.193ZM18,20.925A.608.608,0,0,0,18,21ZM6.994,20.882l0,.056A.356.356,0,0,0,6.994,20.882ZM19.035,5.2h0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,8c-2.937,0-9-.733-9-3H6a.578.578,0,0,0-.115-.368C6.241,5.009,8.968,6,13,6c3.9,0,5.811-.922,6.066-1.257A.463.463,0,0,0,19,5h2C21,7.062,16.854,8,13,8Z",
    fill: "currentColor"
  }))), _symbol250 || (_symbol250 = /*#__PURE__*/React.createElement("symbol", {
    id: "trashcan-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "trashcan-filled icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,24c-2.051,0-8-.738-8-3L4,5.063A2.329,2.329,0,0,1,5.675,3.055l.946-.325.649,1.892-.945.324a.789.789,0,0,0-.316.2l.976,15.569A13.368,13.368,0,0,0,13,22a9.012,9.012,0,0,0,5.013-1.2l.977-15.656a.783.783,0,0,0-.314-.2l-.945-.324.649-1.892.946.325A2.332,2.332,0,0,1,21,5L20,21.063C20,22.957,15.935,24,13,24Zm5-3.075A.608.608,0,0,0,18,21ZM6.994,20.882l0,.056A.356.356,0,0,0,6.994,20.882Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,8c-2.937,0-9-.733-9-3H6a.578.578,0,0,0-.115-.368C6.241,5.009,8.968,6,13,6c3.9,0,5.811-.922,6.066-1.257A.463.463,0,0,0,19,5h2C21,7.062,16.854,8,13,8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4.414,13.607,2.021l-.713,1.426a1,1,0,0,1-1.342.447L10.2,3.217,9,4.414,7.586,3,9.293,1.293a1,1,0,0,1,1.154-.187l1.105.553L12.105.553A1,1,0,0,1,13,0h1a1,1,0,0,1,.707.293L17.414,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.447,14.342,8.553,12.895A1,1,0,0,1,8,12V9h2v2.382l2.342,1.171Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,15.414,12.586,14,15,11.586V9h2v3a1,1,0,0,1-.293.707Z",
    fill: "currentColor"
  }))), _symbol251 || (_symbol251 = /*#__PURE__*/React.createElement("symbol", {
    id: "trashcan",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "trashcan icon"), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 21,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,24H6a2,2,0,0,1-2-2V6H6V22H19V6h2V22A2,2,0,0,1,19,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,5H15V3H10V5H8V2A1,1,0,0,1,9,1h7a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 2,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 2,
    height: 12,
    fill: "currentColor"
  }))), _symbol252 || (_symbol252 = /*#__PURE__*/React.createElement("symbol", {
    id: "tree",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "tree icon"), /*#__PURE__*/React.createElement("path", {
    d: "M22,19H3a1,1,0,0,1-.759-1.65L6.826,12H5.175a1,1,0,0,1-.807-1.591l7.325-10a1.036,1.036,0,0,1,1.613,0l7.325,10A1,1,0,0,1,19.825,12H18.174l4.585,5.35A1,1,0,0,1,22,19ZM5.174,17H19.826l-4.585-5.349A1,1,0,0,1,16,10h1.854L12.5,2.692,7.146,10H9a1,1,0,0,1,.759,1.651Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,24H11a1,1,0,0,1-1-1V19h2v3h1V19h2v4A1,1,0,0,1,14,24Z",
    fill: "currentColor"
  }))), _symbol253 || (_symbol253 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangle-down-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "triangle-down-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "12 17.616 3 4.888 21 4.888 12 17.616",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20.214.1,3.389H23.9ZM5.9,6.389l6.1,8.63,6.1-8.63Z",
    fill: "currentColor"
  }))), _symbol254 || (_symbol254 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangle-line",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "triangle-line icon"), /*#__PURE__*/React.createElement("path", {
    d: "M23.74,20H.26L12,3.4ZM6.056,17H17.944L12,8.6Z",
    fill: "currentColor"
  }))), _symbol255 || (_symbol255 = /*#__PURE__*/React.createElement("symbol", {
    id: "triangle-up-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "triangle-up-filled icon"), /*#__PURE__*/React.createElement("polygon", {
    points: "12 4.888 21 17.616 3 17.616 12 4.888",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9,19.116H.1L12,2.291Zm-18-3H18.1L12,7.486Z",
    fill: "currentColor"
  }))), _symbol256 || (_symbol256 = /*#__PURE__*/React.createElement("symbol", {
    id: "trophy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "trophy icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,19H12a7.008,7.008,0,0,1-7-7V3A1,1,0,0,1,6,2H18a1,1,0,0,1,1,1v9C19,16.187,16.589,19,13,19ZM7,4v8a5.006,5.006,0,0,0,5,5h1c2.949,0,4-2.583,4-5V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,25H8a1,1,0,0,1-1-1,4,4,0,0,1,4-4h2a4,4,0,0,1,4,4A1,1,0,0,1,16,25ZM9.269,23h5.463A2,2,0,0,0,13,22H11A2,2,0,0,0,9.269,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.983,14H3c-1.717,0-3-2.111-3-4V5A1,1,0,0,1,1,4H4V6H2v4a2.24,2.24,0,0,0,1,2l.982.033Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,14H20V12h1a2.24,2.24,0,0,0,1-2V6H20V4h3a1,1,0,0,1,1,1v5C24,11.889,22.717,14,21,14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 2,
    height: 4,
    fill: "currentColor"
  }))), _symbol257 || (_symbol257 = /*#__PURE__*/React.createElement("symbol", {
    id: "truck",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "truck icon"), /*#__PURE__*/React.createElement("path", {
    d: "M8,24H6a2,2,0,0,1-2-2V20H6v2H8V20h2v2A2,2,0,0,1,8,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,24H16a2,2,0,0,1-2-2V20h2v2h2V20h2v2A2,2,0,0,1,18,24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,20H4a1,1,0,0,1-1-1V6A2,2,0,0,1,5,4H19a2,2,0,0,1,2,2V19A1,1,0,0,1,20,20ZM5,18H19V6H5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,13H7a1,1,0,0,1-1-1V8A1,1,0,0,1,7,7H17a1,1,0,0,1,1,1v4A1,1,0,0,1,17,13ZM8,11h8V9H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,20H22V2H2V20H0V1A1,1,0,0,1,1,0H23a1,1,0,0,1,1,1Z",
    fill: "currentColor"
  }))), _symbol258 || (_symbol258 = /*#__PURE__*/React.createElement("symbol", {
    id: "undo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "undo icon"), /*#__PURE__*/React.createElement("path", {
    d: "M14.238,20H8V18h6.238A4.767,4.767,0,0,0,19,13.238v-.477A4.767,4.767,0,0,0,14.238,8H8V6h6.238A6.769,6.769,0,0,1,21,12.762v.477A6.769,6.769,0,0,1,14.238,20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.539,13.414,3.68,8.816a2.145,2.145,0,0,1,0-3.132l4.86-4.6L9.914,2.539l-4.859,4.6a.145.145,0,0,0,0,.228l4.858,4.6Z",
    fill: "currentColor"
  }))), _symbol259 || (_symbol259 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload-cloud",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "upload-cloud icon"), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,18H16V16h2.1a3.136,3.136,0,0,0,3.151-2.511,3.028,3.028,0,0,0-2-3.371,1,1,0,0,1-.675-.856A6.156,6.156,0,0,0,6.336,9.085a1,1,0,0,1-.9.875,3.033,3.033,0,0,0-2.652,3.71A3.1,3.1,0,0,0,5.863,16H9v2H5.863a5.107,5.107,0,0,1-5.03-3.9A5.033,5.033,0,0,1,4.474,8.106a8.159,8.159,0,0,1,16.014.363,5.031,5.031,0,0,1,2.735,5.337A5.151,5.151,0,0,1,18.1,18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.414l-2.707-2.707A2.789,2.789,0,0,0,12,10.444a2.789,2.789,0,0,0-.293.263L9,13.414,7.586,12l2.707-2.707c1.2-1.2,2.217-1.2,3.414,0L16.414,12Z",
    fill: "currentColor"
  }))), _symbol260 || (_symbol260 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "upload icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20.95,21H15V19h5.95L21,3.05,3.05,3,3,18.95,9,19v2H3.05A2.053,2.053,0,0,1,1,18.95V3.05A2.053,2.053,0,0,1,3.05,1h17.9A2.053,2.053,0,0,1,23,3.05v15.9A2.053,2.053,0,0,1,20.95,21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 2,
    height: 10,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,13.123l-4-4-4,4L6.586,11.709l4.136-4.135a1.719,1.719,0,0,1,2.507-.047l4.186,4.182Z",
    fill: "currentColor"
  }))), _symbol261 || (_symbol261 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-1-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "user-1-minus icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,12A5.5,5.5,0,1,1,17,6.5,5.507,5.507,0,0,1,11.5,12Zm0-9A3.5,3.5,0,1,0,15,6.5,3.5,3.5,0,0,0,11.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23H4a2,2,0,0,1-2-2V19.5c0-4.644,1.932-6.584,3.553-7.395l.895-.447.895,1.789-.895.447C4.823,14.706,4,16.593,4,19.5V21H21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 8,
    height: 2,
    fill: "currentColor"
  }))), _symbol262 || (_symbol262 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-1-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "user-1-plus icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,12A5.5,5.5,0,1,1,17,6.5,5.507,5.507,0,0,1,11.5,12Zm0-9A3.5,3.5,0,1,0,15,6.5,3.5,3.5,0,0,0,11.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23H4a2,2,0,0,1-2-2V19.5c0-4.644,1.932-6.584,3.553-7.395l.895-.447.895,1.789-.895.447C4.823,14.706,4,16.593,4,19.5V21H21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 8,
    height: 2,
    fill: "currentColor"
  }))), _symbol263 || (_symbol263 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-1",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "user-1 icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,12A5.5,5.5,0,1,1,17,6.5,5.507,5.507,0,0,1,11.5,12Zm0-9A3.5,3.5,0,1,0,15,6.5,3.5,3.5,0,0,0,11.5,3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,23H4a2,2,0,0,1-2-2V19.5c0-4.644,1.932-6.584,3.553-7.395l.895-.447.895,1.789-.895.447C4.823,14.706,4,16.593,4,19.5V21H19V19.5c0-2.154-.916-4.84-2.447-5.605l-.895-.447.895-1.789.895.447C19.78,13.271,21,16.708,21,19.5V21A2,2,0,0,1,19,23Z",
    fill: "currentColor"
  }))), _symbol264 || (_symbol264 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-2-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "user-2-minus icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,11H10A4,4,0,0,1,6,7V5.5a5.5,5.5,0,0,1,11,0V7A4,4,0,0,1,13,11ZM11.5,2A3.5,3.5,0,0,0,8,5.5V7a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V5.5A3.5,3.5,0,0,0,11.5,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,23H2V21.5A9.511,9.511,0,0,1,11.5,12H13v2H11.5A7.508,7.508,0,0,0,4,21.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 8,
    height: 2,
    fill: "currentColor"
  }))), _symbol265 || (_symbol265 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-2-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "user-2-plus icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,11H10A4,4,0,0,1,6,7V5.5a5.5,5.5,0,0,1,11,0V7A4,4,0,0,1,13,11ZM11.5,2A3.5,3.5,0,0,0,8,5.5V7a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V5.5A3.5,3.5,0,0,0,11.5,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,23H2V21.5A9.511,9.511,0,0,1,11.5,12H13v2H11.5A7.508,7.508,0,0,0,4,21.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 2,
    height: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 8,
    height: 2,
    fill: "currentColor"
  }))), _symbol266 || (_symbol266 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "user-2 icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,11H10A4,4,0,0,1,6,7V5.5a5.5,5.5,0,0,1,11,0V7A4,4,0,0,1,13,11ZM11.5,2A3.5,3.5,0,0,0,8,5.5V7a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V5.5A3.5,3.5,0,0,0,11.5,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,23H19V21A7.5,7.5,0,0,0,4,21v2H2V21a9.5,9.5,0,0,1,19,0Z",
    fill: "currentColor"
  }))), _symbol267 || (_symbol267 = /*#__PURE__*/React.createElement("symbol", {
    id: "video-camera",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "video-camera icon"), /*#__PURE__*/React.createElement("path", {
    d: "M16,21H2a2,2,0,0,1-2-2V5A2,2,0,0,1,2,3H16a2,2,0,0,1,2,2V19A2,2,0,0,1,16,21ZM2,5V19H16L16,5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,19a1,1,0,0,1-.447-.105l-6-3A1,1,0,0,1,16,15V9a1,1,0,0,1,.553-.895l6-3A1,1,0,0,1,24,6V18a1,1,0,0,1-1,1Zm-5-4.618,4,2V7.618l-4,2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 3,
    height: 3,
    fill: "currentColor"
  }))), _symbol268 || (_symbol268 = /*#__PURE__*/React.createElement("symbol", {
    id: "video-game",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "video-game icon"), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 2,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1,
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,11a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 14,
    r: 1,
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,13a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 2,
    height: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19a6.33,6.33,0,0,1-4.467-2H11.467A6.33,6.33,0,0,1,7,19a6.237,6.237,0,0,1-6-6A6.237,6.237,0,0,1,7,7H18a6.237,6.237,0,0,1,6,6A5.741,5.741,0,0,1,18,19Zm-7.5-4h4l.3.4A4.319,4.319,0,0,0,18,17a3.749,3.749,0,0,0,4-4,4.214,4.214,0,0,0-4-4H7a4.214,4.214,0,0,0-4,4,4.214,4.214,0,0,0,4,4,4.319,4.319,0,0,0,3.2-1.6Z",
    fill: "currentColor"
  }))), _symbol269 || (_symbol269 = /*#__PURE__*/React.createElement("symbol", {
    id: "visibility-off",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "visibility-off icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20.415,16.914l-1.371-1.456.728-.686a22.975,22.975,0,0,0,1.991-2.135.993.993,0,0,0,0-1.274C20.317,9.6,16.471,5.5,12,5.5a8.038,8.038,0,0,0-2,.262l-.968.251-.5-1.937.968-.25A10,10,0,0,1,12,3.5c5.134,0,9.289,4.132,11.309,6.595a3.011,3.011,0,0,1,0,3.812,24.772,24.772,0,0,1-2.166,2.323Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20.5c-5.134,0-9.289-4.132-11.309-6.595a3.011,3.011,0,0,1,0-3.812A24.772,24.772,0,0,1,2.857,7.771l.728-.685L4.957,8.542l-.728.686a22.975,22.975,0,0,0-1.991,2.135.993.993,0,0,0,0,1.274C3.683,14.4,7.529,18.5,12,18.5a8.022,8.022,0,0,0,2-.263l.968-.251.5,1.936-.968.251A10,10,0,0,1,12,20.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16.5A4.5,4.5,0,1,1,16.5,12,4.5,4.5,0,0,1,12,16.5Zm0-7A2.5,2.5,0,1,0,14.5,12,2.5,2.5,0,0,0,12,9.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: -1.728,
    width: 2,
    height: 27.456,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }))), _symbol270 || (_symbol270 = /*#__PURE__*/React.createElement("symbol", {
    id: "visibility-on",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "visibility-on icon"), /*#__PURE__*/React.createElement("path", {
    d: "M12.366,20.5c-4.975,0-9-4-10.958-6.386a2.947,2.947,0,0,1,0-3.728C3.365,8,7.392,4,12.366,4s9,4,10.958,6.387a2.945,2.945,0,0,1,0,3.727C21.368,16.5,17.344,20.5,12.366,20.5Zm0-14.5C8.06,6,4.35,9.955,2.955,11.655a.928.928,0,0,0,0,1.19c1.395,1.7,5.1,5.654,9.411,5.654s8.017-3.954,9.411-5.654a.929.929,0,0,0,0-1.191h0C20.383,9.954,16.675,6,12.366,6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25,16.5a4.25,4.25,0,1,1,4.25-4.25A4.254,4.254,0,0,1,12.25,16.5Zm0-6.5a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,12.25,10Z",
    fill: "currentColor"
  }))), _symbol271 || (_symbol271 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "warning icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20.918,24H3.292A3.343,3.343,0,0,1,.464,22.358a3,3,0,0,1-.13-2.966l.011-.02L9.676,2.622A2.808,2.808,0,0,1,12.1,1a2.821,2.821,0,0,1,2.44,1.642l9.321,16.731a3,3,0,0,1-.12,2.985A3.341,3.341,0,0,1,20.918,24ZM2.1,20.335a1.01,1.01,0,0,0,.08.991A1.352,1.352,0,0,0,3.292,22H20.918a1.352,1.352,0,0,0,1.114-.674,1.01,1.01,0,0,0,.075-1L12.787,3.595c-.4-.761-.973-.739-1.353-.02Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 2,
    height: 9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1,
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    fill: "currentColor"
  }))), _symbol272 || (_symbol272 = /*#__PURE__*/React.createElement("symbol", {
    id: "watch",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "watch icon"), /*#__PURE__*/React.createElement("path", {
    d: "M11.556,21.056A8.556,8.556,0,1,1,20.111,12.5,8.565,8.565,0,0,1,11.556,21.056Zm0-15.111A6.556,6.556,0,1,0,18.111,12.5,6.563,6.563,0,0,0,11.556,5.944Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.278 23.889 5.833 23.889 5.833 21 7.833 21 7.833 21.889 15.278 21.889 15.278 21 17.278 21 17.278 23.889",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17 4 15 4 15 3 8 3 8 4 6 4 6 1 17 1 17 4",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13 16.414 10 13.414 10 8 12 8 12 12.586 14.414 15 13 16.414",
    fill: "currentColor"
  }))), _symbol273 || (_symbol273 = /*#__PURE__*/React.createElement("symbol", {
    id: "water-drop",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "water-drop icon"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,24c-3,0-5.8-1.6-7.5-4.3c-0.2-0.3-0.3-0.5-0.5-0.8c-0.6-1.3-1-2.7-1-4.2c0-1.6,0.3-3.2,1-4.6 c0.5-1,1.5-2.5,3.1-4.6c2-2.9,4.1-5.1,4.2-5.2C11.4,0.1,11.7,0,12,0l0,0c0.3,0,0.6,0.1,0.7,0.3c0.1,0.1,2.2,2.4,4.2,5.3 c1.6,2.1,2.6,3.6,3.1,4.6l0.1,0.1c0.7,1.5,1,3.2,0.9,4.8c-0.1,1.7-0.6,3.2-1.5,4.6C17.8,22.4,15,24,12,24z M12,2.5 C11.2,3.4,9.9,5,8.7,6.8c-1.9,2.5-2.6,3.7-2.9,4.3C5.2,12.2,5,13.4,5,14.7l0,0C5,15.9,5.3,17,5.8,18c0.1,0.2,0.2,0.4,0.4,0.6 C7.5,20.8,9.7,22,12,22c2.3,0,4.5-1.2,5.8-3.3c0.7-1.1,1.1-2.3,1.2-3.6c0.1-1.3-0.2-2.7-0.7-3.9c0,0,0-0.1,0-0.1 c-0.3-0.6-1-1.8-2.9-4.3C14.1,5,12.8,3.4,12,2.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,19.1v-2c1.7,0,3-1.4,3-3.1h2C17,16.8,14.8,19.1,12,19.1z"
  })))), _symbol274 || (_symbol274 = /*#__PURE__*/React.createElement("symbol", {
    id: "wifi",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "wifi icon"), /*#__PURE__*/React.createElement("path", {
    d: "M13,20l-1,1-1-1c.216-.216.666-1,1-1S12.784,19.784,13,20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.219,15.952,14.532,17.64a3.554,3.554,0,0,0-5.063,0L7.781,15.952a5.923,5.923,0,0,1,8.439,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.615,12.557l-1.7,1.7a8.339,8.339,0,0,0-11.834,0l-1.7-1.7a10.755,10.755,0,0,1,15.229,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,9.171l-1.688,1.7a13.136,13.136,0,0,0-18.615,0L1,9.171a15.541,15.541,0,0,1,22,0Z",
    fill: "currentColor"
  }))), _symbol275 || (_symbol275 = /*#__PURE__*/React.createElement("symbol", {
    id: "windows",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "windows icon"), /*#__PURE__*/React.createElement("path", {
    d: "M20,20H1a1,1,0,0,1-1-1V4.015A2.017,2.017,0,0,1,2.015,2h16.97A2.017,2.017,0,0,1,21,4.015V19A1,1,0,0,1,20,20ZM2,18H19V4.015L2.015,4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,23H4V21H22V7h2V22A1,1,0,0,1,23,23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,7.5A1.5,1.5,0,1,1,6.5,6,1.5,1.5,0,0,1,5,7.5Zm0-2a.5.5,0,1,0,.5.5A.5.5,0,0,0,5,5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,7.5A1.5,1.5,0,1,1,9.5,6,1.5,1.5,0,0,1,8,7.5Zm0-2a.5.5,0,1,0,.5.5A.5.5,0,0,0,8,5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,7.5A1.5,1.5,0,1,1,12.5,6,1.5,1.5,0,0,1,11,7.5Zm0-2a.5.5,0,1,0,.5.5A.5.5,0,0,0,11,5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 21,
    height: 2,
    fill: "currentColor"
  }))), _symbol276 || (_symbol276 = /*#__PURE__*/React.createElement("symbol", {
    id: "wrench",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "wrench icon"), /*#__PURE__*/React.createElement("circle", {
    cx: 6.285,
    cy: 18.019,
    r: 0.969,
    transform: "translate(-10.901 9.722) rotate(-45)",
    fill: "#112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.285,17.05a.969.969,0,1,0,.685.284.966.966,0,0,0-.685-.284Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.115,22.44A3.914,3.914,0,0,1,3.351,21.3l-.344-.344a3.909,3.909,0,0,1,.229-5.738L9.568,9.822A7.3,7.3,0,0,1,17.318.479a1.909,1.909,0,0,1,1.61,1.275,1.973,1.973,0,0,1-.462,2.072L15.9,6.391,17.957,8.4,20.478,5.84a1.966,1.966,0,0,1,2.071-.463,1.906,1.906,0,0,1,1.275,1.61,7.271,7.271,0,0,1-2.1,5.914h0a7.283,7.283,0,0,1-7.245,1.835L9.088,21.067a3.916,3.916,0,0,1-2.818,1.37ZM16.671,2.4a5.461,5.461,0,0,0-3.854,1.593,5.286,5.286,0,0,0-1.153,5.765l.276.672-7.407,6.31a1.908,1.908,0,0,0-.112,2.8l.344.344a1.917,1.917,0,0,0,1.425.557,1.885,1.885,0,0,0,1.375-.669l6.31-7.407.671.276a5.3,5.3,0,0,0,7.288-5.447L19.328,9.817a1.972,1.972,0,0,1-2.784,0L14.487,7.761a1.969,1.969,0,0,1,0-2.785l2.563-2.562C16.924,2.4,16.8,2.4,16.671,2.4Zm4.349,9.795h0Z",
    fill: "currentColor"
  }))), _symbol277 || (_symbol277 = /*#__PURE__*/React.createElement("symbol", {
    id: "x-filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "x-filled icon"), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 3.429,
    width: 3,
    height: 17.142,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.429,
    y: 10.5,
    width: 17.142,
    height: 3,
    transform: "translate(-4.971 12) rotate(-45)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmIcons);
export default __webpack_public_path__ + "static/media/em-icons.43edcf79970bc4d8a4cb2cc490763ba3.svg";
export { ForwardRef as ReactComponent };